export const STATES_BY_COUNTRY = {
    AD: [
        {
            country: "AD",
            name: "Andorra la Vella",
            code: "AD-07",
        },
        {
            country: "AD",
            name: "Canillo",
            code: "AD-02",
        },
        {
            country: "AD",
            name: "Encamp",
            code: "AD-03",
        },
        {
            country: "AD",
            name: "Escaldes-Engordany",
            code: "AD-08",
        },
        {
            country: "AD",
            name: "La Massana",
            code: "AD-04",
        },
        {
            country: "AD",
            name: "Ordino",
            code: "AD-05",
        },
        {
            country: "AD",
            name: "Sant Julia de Loria",
            code: "AD-06",
        },
    ],
    AE: [
        {
            country: "AE",
            name: "'Ajman",
            code: "AE-AJ",
        },
        {
            country: "AE",
            name: "Abu Zaby",
            code: "AE-AZ",
        },
        {
            country: "AE",
            name: "Al Fujayrah",
            code: "AE-FU",
        },
        {
            country: "AE",
            name: "Ash Shariqah",
            code: "AE-SH",
        },
        {
            country: "AE",
            name: "Dubayy",
            code: "AE-DU",
        },
        {
            country: "AE",
            name: "Ra's al Khaymah",
            code: "AE-RK",
        },
        {
            country: "AE",
            name: "Umm al Qaywayn",
            code: "AE-UQ",
        },
    ],
    AF: [
        {
            country: "AF",
            name: "Badghis",
            code: "AF-BDG",
        },
        {
            country: "AF",
            name: "Baghlan",
            code: "AF-BGL",
        },
        {
            country: "AF",
            name: "Balkh",
            code: "AF-BAL",
        },
        {
            country: "AF",
            name: "Bamyan",
            code: "AF-BAM",
        },
        {
            country: "AF",
            name: "Daykundi",
            code: "AF-DAY",
        },
        {
            country: "AF",
            name: "Farah",
            code: "AF-FRA",
        },
        {
            country: "AF",
            name: "Faryab",
            code: "AF-FYB",
        },
        {
            country: "AF",
            name: "Ghazni",
            code: "AF-GHA",
        },
        {
            country: "AF",
            name: "Ghor",
            code: "AF-GHO",
        },
        {
            country: "AF",
            name: "Helmand",
            code: "AF-HEL",
        },
        {
            country: "AF",
            name: "Herat",
            code: "AF-HER",
        },
        {
            country: "AF",
            name: "Jowzjan",
            code: "AF-JOW",
        },
        {
            country: "AF",
            name: "Kabul",
            code: "AF-KAB",
        },
        {
            country: "AF",
            name: "Kandahar",
            code: "AF-KAN",
        },
        {
            country: "AF",
            name: "Khost",
            code: "AF-KHO",
        },
        {
            country: "AF",
            name: "Kunduz",
            code: "AF-KDZ",
        },
        {
            country: "AF",
            name: "Laghman",
            code: "AF-LAG",
        },
        {
            country: "AF",
            name: "Logar",
            code: "AF-LOG",
        },
        {
            country: "AF",
            name: "Nangarhar",
            code: "AF-NAN",
        },
        {
            country: "AF",
            name: "Nimroz",
            code: "AF-NIM",
        },
        {
            country: "AF",
            name: "Paktika",
            code: "AF-PKA",
        },
        {
            country: "AF",
            name: "Paktiya",
            code: "AF-PIA",
        },
        {
            country: "AF",
            name: "Parwan",
            code: "AF-PAR",
        },
        {
            country: "AF",
            name: "Samangan",
            code: "AF-SAM",
        },
        {
            country: "AF",
            name: "Sar-e Pul",
            code: "AF-SAR",
        },
        {
            country: "AF",
            name: "Takhar",
            code: "AF-TAK",
        },
        {
            country: "AF",
            name: "Uruzgan",
            code: "AF-URU",
        },
    ],
    AG: [
        {
            country: "AG",
            name: "Barbuda",
            code: "AG-10",
        },
        {
            country: "AG",
            name: "Saint George",
            code: "AG-03",
        },
        {
            country: "AG",
            name: "Saint John",
            code: "AG-04",
        },
        {
            country: "AG",
            name: "Saint Mary",
            code: "AG-05",
        },
        {
            country: "AG",
            name: "Saint Paul",
            code: "AG-06",
        },
        {
            country: "AG",
            name: "Saint Peter",
            code: "AG-07",
        },
        {
            country: "AG",
            name: "Saint Philip",
            code: "AG-08",
        },
    ],
    AI: [
        {
            country: "AI",
            name: "Anguilla",
            code: "-",
        },
    ],
    AL: [
        {
            country: "AL",
            name: "Berat",
            code: "AL-01",
        },
        {
            country: "AL",
            name: "Diber",
            code: "AL-09",
        },
        {
            country: "AL",
            name: "Durres",
            code: "AL-02",
        },
        {
            country: "AL",
            name: "Elbasan",
            code: "AL-03",
        },
        {
            country: "AL",
            name: "Fier",
            code: "AL-04",
        },
        {
            country: "AL",
            name: "Gjirokaster",
            code: "AL-05",
        },
        {
            country: "AL",
            name: "Korce",
            code: "AL-06",
        },
        {
            country: "AL",
            name: "Kukes",
            code: "AL-07",
        },
        {
            country: "AL",
            name: "Lezhe",
            code: "AL-08",
        },
        {
            country: "AL",
            name: "Shkoder",
            code: "AL-10",
        },
        {
            country: "AL",
            name: "Tirane",
            code: "AL-11",
        },
        {
            country: "AL",
            name: "Vlore",
            code: "AL-12",
        },
    ],
    AM: [
        {
            country: "AM",
            name: "Aragacotn",
            code: "AM-AG",
        },
        {
            country: "AM",
            name: "Ararat",
            code: "AM-AR",
        },
        {
            country: "AM",
            name: "Armavir",
            code: "AM-AV",
        },
        {
            country: "AM",
            name: "Erevan",
            code: "AM-ER",
        },
        {
            country: "AM",
            name: "Gegark'unik'",
            code: "AM-GR",
        },
        {
            country: "AM",
            name: "Kotayk'",
            code: "AM-KT",
        },
        {
            country: "AM",
            name: "Lori",
            code: "AM-LO",
        },
        {
            country: "AM",
            name: "Sirak",
            code: "AM-SH",
        },
        {
            country: "AM",
            name: "Syunik'",
            code: "AM-SU",
        },
        {
            country: "AM",
            name: "Tavus",
            code: "AM-TV",
        },
        {
            country: "AM",
            name: "Vayoc Jor",
            code: "AM-VD",
        },
    ],
    AO: [
        {
            country: "AO",
            name: "Bengo",
            code: "AO-BGO",
        },
        {
            country: "AO",
            name: "Benguela",
            code: "AO-BGU",
        },
        {
            country: "AO",
            name: "Bie",
            code: "AO-BIE",
        },
        {
            country: "AO",
            name: "Cabinda",
            code: "AO-CAB",
        },
        {
            country: "AO",
            name: "Cuando Cubango",
            code: "AO-CCU",
        },
        {
            country: "AO",
            name: "Cuanza-Norte",
            code: "AO-CNO",
        },
        {
            country: "AO",
            name: "Cuanza-Sul",
            code: "AO-CUS",
        },
        {
            country: "AO",
            name: "Cunene",
            code: "AO-CNN",
        },
        {
            country: "AO",
            name: "Huambo",
            code: "AO-HUA",
        },
        {
            country: "AO",
            name: "Huila",
            code: "AO-HUI",
        },
        {
            country: "AO",
            name: "Luanda",
            code: "AO-LUA",
        },
        {
            country: "AO",
            name: "Lunda-Norte",
            code: "AO-LNO",
        },
        {
            country: "AO",
            name: "Lunda-Sul",
            code: "AO-LSU",
        },
        {
            country: "AO",
            name: "Malange",
            code: "AO-MAL",
        },
        {
            country: "AO",
            name: "Moxico",
            code: "AO-MOX",
        },
        {
            country: "AO",
            name: "Namibe",
            code: "AO-NAM",
        },
        {
            country: "AO",
            name: "Uige",
            code: "AO-UIG",
        },
        {
            country: "AO",
            name: "Zaire",
            code: "AO-ZAI",
        },
    ],
    AQ: [
        {
            country: "AQ",
            name: "Antarctica",
            code: "-",
        },
    ],
    AR: [
        {
            country: "AR",
            name: "Buenos Aires",
            code: "AR-B",
        },
        {
            country: "AR",
            name: "Catamarca",
            code: "AR-K",
        },
        {
            country: "AR",
            name: "Chaco",
            code: "AR-H",
        },
        {
            country: "AR",
            name: "Chubut",
            code: "AR-U",
        },
        {
            country: "AR",
            name: "Ciudad Autonoma de Buenos Aires",
            code: "AR-C",
        },
        {
            country: "AR",
            name: "Cordoba",
            code: "AR-X",
        },
        {
            country: "AR",
            name: "Corrientes",
            code: "AR-W",
        },
        {
            country: "AR",
            name: "Entre Rios",
            code: "AR-E",
        },
        {
            country: "AR",
            name: "Formosa",
            code: "AR-P",
        },
        {
            country: "AR",
            name: "Jujuy",
            code: "AR-Y",
        },
        {
            country: "AR",
            name: "La Pampa",
            code: "AR-L",
        },
        {
            country: "AR",
            name: "La Rioja",
            code: "AR-F",
        },
        {
            country: "AR",
            name: "Mendoza",
            code: "AR-M",
        },
        {
            country: "AR",
            name: "Misiones",
            code: "AR-N",
        },
        {
            country: "AR",
            name: "Neuquen",
            code: "AR-Q",
        },
        {
            country: "AR",
            name: "Rio Negro",
            code: "AR-R",
        },
        {
            country: "AR",
            name: "Salta",
            code: "AR-A",
        },
        {
            country: "AR",
            name: "San Juan",
            code: "AR-J",
        },
        {
            country: "AR",
            name: "San Luis",
            code: "AR-D",
        },
        {
            country: "AR",
            name: "Santa Cruz",
            code: "AR-Z",
        },
        {
            country: "AR",
            name: "Santa Fe",
            code: "AR-S",
        },
        {
            country: "AR",
            name: "Santiago del Estero",
            code: "AR-G",
        },
        {
            country: "AR",
            name: "Tierra del Fuego",
            code: "AR-V",
        },
        {
            country: "AR",
            name: "Tucuman",
            code: "AR-T",
        },
    ],
    AS: [
        {
            country: "AS",
            name: "Eastern District",
            code: "-",
        },
        {
            country: "AS",
            name: "Western District",
            code: "-",
        },
    ],
    AT: [
        {
            country: "AT",
            name: "Burgenland",
            code: "AT-1",
        },
        {
            country: "AT",
            name: "Karnten",
            code: "AT-2",
        },
        {
            country: "AT",
            name: "Niederosterreich",
            code: "AT-3",
        },
        {
            country: "AT",
            name: "Oberosterreich",
            code: "AT-4",
        },
        {
            country: "AT",
            name: "Salzburg",
            code: "AT-5",
        },
        {
            country: "AT",
            name: "Steiermark",
            code: "AT-6",
        },
        {
            country: "AT",
            name: "Tirol",
            code: "AT-7",
        },
        {
            country: "AT",
            name: "Vorarlberg",
            code: "AT-8",
        },
        {
            country: "AT",
            name: "Wien",
            code: "AT-9",
        },
    ],
    AU: [
        {
            country: "AU",
            name: "Australian Capital Territory",
            code: "AU-ACT",
        },
        {
            country: "AU",
            name: "New South Wales",
            code: "AU-NSW",
        },
        {
            country: "AU",
            name: "Northern Territory",
            code: "AU-NT",
        },
        {
            country: "AU",
            name: "Queensland",
            code: "AU-QLD",
        },
        {
            country: "AU",
            name: "South Australia",
            code: "AU-SA",
        },
        {
            country: "AU",
            name: "Tasmania",
            code: "AU-TAS",
        },
        {
            country: "AU",
            name: "Victoria",
            code: "AU-VIC",
        },
        {
            country: "AU",
            name: "Western Australia",
            code: "AU-WA",
        },
    ],
    AW: [
        {
            country: "AW",
            name: "Aruba",
            code: "-",
        },
    ],
    AX: [
        {
            country: "AX",
            name: "Eckeroe",
            code: "-",
        },
        {
            country: "AX",
            name: "Finstroem",
            code: "-",
        },
        {
            country: "AX",
            name: "Hammarland",
            code: "-",
        },
        {
            country: "AX",
            name: "Jomala",
            code: "-",
        },
        {
            country: "AX",
            name: "Lemland",
            code: "-",
        },
        {
            country: "AX",
            name: "Mariehamn",
            code: "-",
        },
        {
            country: "AX",
            name: "Saltvik",
            code: "-",
        },
    ],
    AZ: [
        {
            country: "AZ",
            name: "Abseron",
            code: "AZ-ABS",
        },
        {
            country: "AZ",
            name: "Agcabadi",
            code: "AZ-AGC",
        },
        {
            country: "AZ",
            name: "Agdas",
            code: "AZ-AGS",
        },
        {
            country: "AZ",
            name: "Agstafa",
            code: "AZ-AGA",
        },
        {
            country: "AZ",
            name: "Agsu",
            code: "AZ-AGU",
        },
        {
            country: "AZ",
            name: "Astara",
            code: "AZ-AST",
        },
        {
            country: "AZ",
            name: "Baki",
            code: "AZ-BA",
        },
        {
            country: "AZ",
            name: "Balakan",
            code: "AZ-BAL",
        },
        {
            country: "AZ",
            name: "Barda",
            code: "AZ-BAR",
        },
        {
            country: "AZ",
            name: "Beylaqan",
            code: "AZ-BEY",
        },
        {
            country: "AZ",
            name: "Calilabad",
            code: "AZ-CAL",
        },
        {
            country: "AZ",
            name: "Fuzuli",
            code: "AZ-FUZ",
        },
        {
            country: "AZ",
            name: "Gadabay",
            code: "AZ-GAD",
        },
        {
            country: "AZ",
            name: "Ganca",
            code: "AZ-GA",
        },
        {
            country: "AZ",
            name: "Goranboy",
            code: "AZ-GOR",
        },
        {
            country: "AZ",
            name: "Goycay",
            code: "AZ-GOY",
        },
        {
            country: "AZ",
            name: "Goygol",
            code: "AZ-GYG",
        },
        {
            country: "AZ",
            name: "Imisli",
            code: "AZ-IMI",
        },
        {
            country: "AZ",
            name: "Ismayilli",
            code: "AZ-ISM",
        },
        {
            country: "AZ",
            name: "Kurdamir",
            code: "AZ-KUR",
        },
        {
            country: "AZ",
            name: "Lankaran",
            code: "AZ-LA",
        },
        {
            country: "AZ",
            name: "Masalli",
            code: "AZ-MAS",
        },
        {
            country: "AZ",
            name: "Mingacevir",
            code: "AZ-MI",
        },
        {
            country: "AZ",
            name: "Naxcivan",
            code: "AZ-NX",
        },
        {
            country: "AZ",
            name: "Neftcala",
            code: "AZ-NEF",
        },
        {
            country: "AZ",
            name: "Oguz",
            code: "AZ-OGU",
        },
        {
            country: "AZ",
            name: "Qabala",
            code: "AZ-QAB",
        },
        {
            country: "AZ",
            name: "Qazax",
            code: "AZ-QAZ",
        },
        {
            country: "AZ",
            name: "Quba",
            code: "AZ-QBA",
        },
        {
            country: "AZ",
            name: "Qusar",
            code: "AZ-QUS",
        },
        {
            country: "AZ",
            name: "Saatli",
            code: "AZ-SAT",
        },
        {
            country: "AZ",
            name: "Sabirabad",
            code: "AZ-SAB",
        },
        {
            country: "AZ",
            name: "Saki",
            code: "AZ-SAK",
        },
        {
            country: "AZ",
            name: "Salyan",
            code: "AZ-SAL",
        },
        {
            country: "AZ",
            name: "Samaxi",
            code: "AZ-SMI",
        },
        {
            country: "AZ",
            name: "Samkir",
            code: "AZ-SKR",
        },
        {
            country: "AZ",
            name: "Samux",
            code: "AZ-SMX",
        },
        {
            country: "AZ",
            name: "Sirvan",
            code: "AZ-SR",
        },
        {
            country: "AZ",
            name: "Siyazan",
            code: "AZ-SIY",
        },
        {
            country: "AZ",
            name: "Sumqayit",
            code: "AZ-SM",
        },
        {
            country: "AZ",
            name: "Tartar",
            code: "AZ-TAR",
        },
        {
            country: "AZ",
            name: "Tovuz",
            code: "AZ-TOV",
        },
        {
            country: "AZ",
            name: "Ucar",
            code: "AZ-UCA",
        },
        {
            country: "AZ",
            name: "Xacmaz",
            code: "AZ-XAC",
        },
        {
            country: "AZ",
            name: "Xizi",
            code: "AZ-XIZ",
        },
        {
            country: "AZ",
            name: "Yardimli",
            code: "AZ-YAR",
        },
        {
            country: "AZ",
            name: "Yevlax",
            code: "AZ-YEV",
        },
        {
            country: "AZ",
            name: "Zaqatala",
            code: "AZ-ZAQ",
        },
        {
            country: "AZ",
            name: "Zardab",
            code: "AZ-ZAR",
        },
    ],
    BA: [
        {
            country: "BA",
            name: "Brcko distrikt",
            code: "BA-BRC",
        },
        {
            country: "BA",
            name: "Federacija Bosne i Hercegovine",
            code: "BA-BIH",
        },
        {
            country: "BA",
            name: "Republika Srpska",
            code: "BA-SRP",
        },
    ],
    BB: [
        {
            country: "BB",
            name: "Christ Church",
            code: "BB-01",
        },
        {
            country: "BB",
            name: "Saint Andrew",
            code: "BB-02",
        },
        {
            country: "BB",
            name: "Saint George",
            code: "BB-03",
        },
        {
            country: "BB",
            name: "Saint James",
            code: "BB-04",
        },
        {
            country: "BB",
            name: "Saint John",
            code: "BB-05",
        },
        {
            country: "BB",
            name: "Saint Joseph",
            code: "BB-06",
        },
        {
            country: "BB",
            name: "Saint Lucy",
            code: "BB-07",
        },
        {
            country: "BB",
            name: "Saint Michael",
            code: "BB-08",
        },
        {
            country: "BB",
            name: "Saint Peter",
            code: "BB-09",
        },
        {
            country: "BB",
            name: "Saint Philip",
            code: "BB-10",
        },
        {
            country: "BB",
            name: "Saint Thomas",
            code: "BB-11",
        },
    ],
    BD: [
        {
            country: "BD",
            name: "Barishal",
            code: "BD-A",
        },
        {
            country: "BD",
            name: "Chattogram",
            code: "BD-B",
        },
        {
            country: "BD",
            name: "Dhaka",
            code: "BD-C",
        },
        {
            country: "BD",
            name: "Khulna",
            code: "BD-D",
        },
        {
            country: "BD",
            name: "Rajshahi",
            code: "BD-E",
        },
        {
            country: "BD",
            name: "Rangpur",
            code: "BD-F",
        },
        {
            country: "BD",
            name: "Sylhet",
            code: "BD-G",
        },
    ],
    BE: [
        {
            country: "BE",
            name: "Antwerpen",
            code: "BE-VAN",
        },
        {
            country: "BE",
            name: "Brabant wallon",
            code: "BE-WBR",
        },
        {
            country: "BE",
            name: "Brussels Hoofdstedelijk Gewest",
            code: "BE-BRU",
        },
        {
            country: "BE",
            name: "Hainaut",
            code: "BE-WHT",
        },
        {
            country: "BE",
            name: "Liege",
            code: "BE-WLG",
        },
        {
            country: "BE",
            name: "Limburg",
            code: "BE-VLI",
        },
        {
            country: "BE",
            name: "Luxembourg",
            code: "BE-WLX",
        },
        {
            country: "BE",
            name: "Namur",
            code: "BE-WNA",
        },
        {
            country: "BE",
            name: "Oost-Vlaanderen",
            code: "BE-VOV",
        },
        {
            country: "BE",
            name: "Vlaams-Brabant",
            code: "BE-VBR",
        },
        {
            country: "BE",
            name: "West-Vlaanderen",
            code: "BE-VWV",
        },
    ],
    BF: [
        {
            country: "BF",
            name: "Bale",
            code: "BF-BAL",
        },
        {
            country: "BF",
            name: "Bam",
            code: "BF-BAM",
        },
        {
            country: "BF",
            name: "Banwa",
            code: "BF-BAN",
        },
        {
            country: "BF",
            name: "Bazega",
            code: "BF-BAZ",
        },
        {
            country: "BF",
            name: "Bougouriba",
            code: "BF-BGR",
        },
        {
            country: "BF",
            name: "Boulgou",
            code: "BF-BLG",
        },
        {
            country: "BF",
            name: "Boulkiemde",
            code: "BF-BLK",
        },
        {
            country: "BF",
            name: "Comoe",
            code: "BF-COM",
        },
        {
            country: "BF",
            name: "Ganzourgou",
            code: "BF-GAN",
        },
        {
            country: "BF",
            name: "Gnagna",
            code: "BF-GNA",
        },
        {
            country: "BF",
            name: "Gourma",
            code: "BF-GOU",
        },
        {
            country: "BF",
            name: "Houet",
            code: "BF-HOU",
        },
        {
            country: "BF",
            name: "Kadiogo",
            code: "BF-KAD",
        },
        {
            country: "BF",
            name: "Kenedougou",
            code: "BF-KEN",
        },
        {
            country: "BF",
            name: "Kompienga",
            code: "BF-KMP",
        },
        {
            country: "BF",
            name: "Kossi",
            code: "BF-KOS",
        },
        {
            country: "BF",
            name: "Kouritenga",
            code: "BF-KOT",
        },
        {
            country: "BF",
            name: "Kourweogo",
            code: "BF-KOW",
        },
        {
            country: "BF",
            name: "Leraba",
            code: "BF-LER",
        },
        {
            country: "BF",
            name: "Loroum",
            code: "BF-LOR",
        },
        {
            country: "BF",
            name: "Mouhoun",
            code: "BF-MOU",
        },
        {
            country: "BF",
            name: "Nahouri",
            code: "BF-NAO",
        },
        {
            country: "BF",
            name: "Namentenga",
            code: "BF-NAM",
        },
        {
            country: "BF",
            name: "Nayala",
            code: "BF-NAY",
        },
        {
            country: "BF",
            name: "Oubritenga",
            code: "BF-OUB",
        },
        {
            country: "BF",
            name: "Oudalan",
            code: "BF-OUD",
        },
        {
            country: "BF",
            name: "Passore",
            code: "BF-PAS",
        },
        {
            country: "BF",
            name: "Poni",
            code: "BF-PON",
        },
        {
            country: "BF",
            name: "Sanmatenga",
            code: "BF-SMT",
        },
        {
            country: "BF",
            name: "Seno",
            code: "BF-SEN",
        },
        {
            country: "BF",
            name: "Sissili",
            code: "BF-SIS",
        },
        {
            country: "BF",
            name: "Soum",
            code: "BF-SOM",
        },
        {
            country: "BF",
            name: "Tapoa",
            code: "BF-TAP",
        },
        {
            country: "BF",
            name: "Tuy",
            code: "BF-TUI",
        },
        {
            country: "BF",
            name: "Yatenga",
            code: "BF-YAT",
        },
        {
            country: "BF",
            name: "Ziro",
            code: "BF-ZIR",
        },
        {
            country: "BF",
            name: "Zondoma",
            code: "BF-ZON",
        },
        {
            country: "BF",
            name: "Zoundweogo",
            code: "BF-ZOU",
        },
    ],
    BG: [
        {
            country: "BG",
            name: "Blagoevgrad",
            code: "BG-01",
        },
        {
            country: "BG",
            name: "Burgas",
            code: "BG-02",
        },
        {
            country: "BG",
            name: "Dobrich",
            code: "BG-08",
        },
        {
            country: "BG",
            name: "Gabrovo",
            code: "BG-07",
        },
        {
            country: "BG",
            name: "Haskovo",
            code: "BG-26",
        },
        {
            country: "BG",
            name: "Kardzhali",
            code: "BG-09",
        },
        {
            country: "BG",
            name: "Kyustendil",
            code: "BG-10",
        },
        {
            country: "BG",
            name: "Lovech",
            code: "BG-11",
        },
        {
            country: "BG",
            name: "Montana",
            code: "BG-12",
        },
        {
            country: "BG",
            name: "Pazardzhik",
            code: "BG-13",
        },
        {
            country: "BG",
            name: "Pernik",
            code: "BG-14",
        },
        {
            country: "BG",
            name: "Pleven",
            code: "BG-15",
        },
        {
            country: "BG",
            name: "Plovdiv",
            code: "BG-16",
        },
        {
            country: "BG",
            name: "Razgrad",
            code: "BG-17",
        },
        {
            country: "BG",
            name: "Ruse",
            code: "BG-18",
        },
        {
            country: "BG",
            name: "Shumen",
            code: "BG-27",
        },
        {
            country: "BG",
            name: "Silistra",
            code: "BG-19",
        },
        {
            country: "BG",
            name: "Sliven",
            code: "BG-20",
        },
        {
            country: "BG",
            name: "Smolyan",
            code: "BG-21",
        },
        {
            country: "BG",
            name: "Sofia",
            code: "BG-23",
        },
        {
            country: "BG",
            name: "Sofia (stolitsa)",
            code: "BG-22",
        },
        {
            country: "BG",
            name: "Stara Zagora",
            code: "BG-24",
        },
        {
            country: "BG",
            name: "Targovishte",
            code: "BG-25",
        },
        {
            country: "BG",
            name: "Varna",
            code: "BG-03",
        },
        {
            country: "BG",
            name: "Veliko Tarnovo",
            code: "BG-04",
        },
        {
            country: "BG",
            name: "Vidin",
            code: "BG-05",
        },
        {
            country: "BG",
            name: "Vratsa",
            code: "BG-06",
        },
        {
            country: "BG",
            name: "Yambol",
            code: "BG-28",
        },
    ],
    BH: [
        {
            country: "BH",
            name: "Al 'Asimah",
            code: "BH-13",
        },
        {
            country: "BH",
            name: "Al Janubiyah",
            code: "BH-14",
        },
        {
            country: "BH",
            name: "Al Muharraq",
            code: "BH-15",
        },
        {
            country: "BH",
            name: "Ash Shamaliyah",
            code: "BH-17",
        },
    ],
    BI: [
        {
            country: "BI",
            name: "Bujumbura Mairie",
            code: "BI-BM",
        },
        {
            country: "BI",
            name: "Bururi",
            code: "BI-BR",
        },
        {
            country: "BI",
            name: "Cibitoke",
            code: "BI-CI",
        },
        {
            country: "BI",
            name: "Gitega",
            code: "BI-GI",
        },
        {
            country: "BI",
            name: "Kayanza",
            code: "BI-KY",
        },
        {
            country: "BI",
            name: "Kirundo",
            code: "BI-KI",
        },
        {
            country: "BI",
            name: "Mwaro",
            code: "BI-MW",
        },
        {
            country: "BI",
            name: "Ngozi",
            code: "BI-NG",
        },
        {
            country: "BI",
            name: "Rumonge",
            code: "BI-RM",
        },
        {
            country: "BI",
            name: "Rutana",
            code: "BI-RT",
        },
        {
            country: "BI",
            name: "Ruyigi",
            code: "BI-RY",
        },
    ],
    BJ: [
        {
            country: "BJ",
            name: "Atacora",
            code: "BJ-AK",
        },
        {
            country: "BJ",
            name: "Atlantique",
            code: "BJ-AQ",
        },
        {
            country: "BJ",
            name: "Borgou",
            code: "BJ-BO",
        },
        {
            country: "BJ",
            name: "Collines",
            code: "BJ-CO",
        },
        {
            country: "BJ",
            name: "Littoral",
            code: "BJ-LI",
        },
        {
            country: "BJ",
            name: "Oueme",
            code: "BJ-OU",
        },
        {
            country: "BJ",
            name: "Plateau",
            code: "BJ-PL",
        },
        {
            country: "BJ",
            name: "Zou",
            code: "BJ-ZO",
        },
    ],
    BL: [
        {
            country: "BL",
            name: "Saint Barthelemy",
            code: "-",
        },
    ],
    BM: [
        {
            country: "BM",
            name: "Hamilton",
            code: "-",
        },
        {
            country: "BM",
            name: "Saint George",
            code: "-",
        },
    ],
    BN: [
        {
            country: "BN",
            name: "Belait",
            code: "BN-BE",
        },
        {
            country: "BN",
            name: "Brunei-Muara",
            code: "BN-BM",
        },
        {
            country: "BN",
            name: "Temburong",
            code: "BN-TE",
        },
        {
            country: "BN",
            name: "Tutong",
            code: "BN-TU",
        },
    ],
    BO: [
        {
            country: "BO",
            name: "Chuquisaca",
            code: "BO-H",
        },
        {
            country: "BO",
            name: "Cochabamba",
            code: "BO-C",
        },
        {
            country: "BO",
            name: "El Beni",
            code: "BO-B",
        },
        {
            country: "BO",
            name: "La Paz",
            code: "BO-L",
        },
        {
            country: "BO",
            name: "Oruro",
            code: "BO-O",
        },
        {
            country: "BO",
            name: "Pando",
            code: "BO-N",
        },
        {
            country: "BO",
            name: "Potosi",
            code: "BO-P",
        },
        {
            country: "BO",
            name: "Santa Cruz",
            code: "BO-S",
        },
        {
            country: "BO",
            name: "Tarija",
            code: "BO-T",
        },
    ],
    BQ: [
        {
            country: "BQ",
            name: "Bonaire",
            code: "BQ-BO",
        },
        {
            country: "BQ",
            name: "Saba",
            code: "BQ-SA",
        },
        {
            country: "BQ",
            name: "Sint Eustatius",
            code: "BQ-SE",
        },
    ],
    BR: [
        {
            country: "BR",
            name: "Acre",
            code: "BR-AC",
        },
        {
            country: "BR",
            name: "Alagoas",
            code: "BR-AL",
        },
        {
            country: "BR",
            name: "Amapa",
            code: "BR-AP",
        },
        {
            country: "BR",
            name: "Amazonas",
            code: "BR-AM",
        },
        {
            country: "BR",
            name: "Bahia",
            code: "BR-BA",
        },
        {
            country: "BR",
            name: "Ceara",
            code: "BR-CE",
        },
        {
            country: "BR",
            name: "Distrito Federal",
            code: "BR-DF",
        },
        {
            country: "BR",
            name: "Espirito Santo",
            code: "BR-ES",
        },
        {
            country: "BR",
            name: "Goias",
            code: "BR-GO",
        },
        {
            country: "BR",
            name: "Maranhao",
            code: "BR-MA",
        },
        {
            country: "BR",
            name: "Mato Grosso",
            code: "BR-MT",
        },
        {
            country: "BR",
            name: "Mato Grosso do Sul",
            code: "BR-MS",
        },
        {
            country: "BR",
            name: "Minas Gerais",
            code: "BR-MG",
        },
        {
            country: "BR",
            name: "Para",
            code: "BR-PA",
        },
        {
            country: "BR",
            name: "Paraiba",
            code: "BR-PB",
        },
        {
            country: "BR",
            name: "Parana",
            code: "BR-PR",
        },
        {
            country: "BR",
            name: "Pernambuco",
            code: "BR-PE",
        },
        {
            country: "BR",
            name: "Piaui",
            code: "BR-PI",
        },
        {
            country: "BR",
            name: "Rio Grande do Norte",
            code: "BR-RN",
        },
        {
            country: "BR",
            name: "Rio Grande do Sul",
            code: "BR-RS",
        },
        {
            country: "BR",
            name: "Rio de Janeiro",
            code: "BR-RJ",
        },
        {
            country: "BR",
            name: "Rondonia",
            code: "BR-RO",
        },
        {
            country: "BR",
            name: "Roraima",
            code: "BR-RR",
        },
        {
            country: "BR",
            name: "Santa Catarina",
            code: "BR-SC",
        },
        {
            country: "BR",
            name: "Sao Paulo",
            code: "BR-SP",
        },
        {
            country: "BR",
            name: "Sergipe",
            code: "BR-SE",
        },
        {
            country: "BR",
            name: "Tocantins",
            code: "BR-TO",
        },
    ],
    BS: [
        {
            country: "BS",
            name: "Black Point",
            code: "BS-BP",
        },
        {
            country: "BS",
            name: "Central Abaco",
            code: "BS-CO",
        },
        {
            country: "BS",
            name: "City of Freeport",
            code: "BS-FP",
        },
        {
            country: "BS",
            name: "East Grand Bahama",
            code: "BS-EG",
        },
        {
            country: "BS",
            name: "Harbour Island",
            code: "BS-HI",
        },
        {
            country: "BS",
            name: "Long Island",
            code: "BS-LI",
        },
        {
            country: "BS",
            name: "Moore's Island",
            code: "BS-MI",
        },
        {
            country: "BS",
            name: "New Providence",
            code: "BS-NP",
        },
        {
            country: "BS",
            name: "North Andros",
            code: "BS-NS",
        },
        {
            country: "BS",
            name: "North Eleuthera",
            code: "BS-NE",
        },
        {
            country: "BS",
            name: "San Salvador",
            code: "BS-SS",
        },
        {
            country: "BS",
            name: "South Eleuthera",
            code: "BS-SE",
        },
        {
            country: "BS",
            name: "West Grand Bahama",
            code: "BS-WG",
        },
    ],
    BT: [
        {
            country: "BT",
            name: "Bumthang",
            code: "BT-33",
        },
        {
            country: "BT",
            name: "Chhukha",
            code: "BT-12",
        },
        {
            country: "BT",
            name: "Dagana",
            code: "BT-22",
        },
        {
            country: "BT",
            name: "Gasa",
            code: "BT-GA",
        },
        {
            country: "BT",
            name: "Lhuentse",
            code: "BT-44",
        },
        {
            country: "BT",
            name: "Monggar",
            code: "BT-42",
        },
        {
            country: "BT",
            name: "Paro",
            code: "BT-11",
        },
        {
            country: "BT",
            name: "Pema Gatshel",
            code: "BT-43",
        },
        {
            country: "BT",
            name: "Punakha",
            code: "BT-23",
        },
        {
            country: "BT",
            name: "Samdrup Jongkhar",
            code: "BT-45",
        },
        {
            country: "BT",
            name: "Samtse",
            code: "BT-14",
        },
        {
            country: "BT",
            name: "Sarpang",
            code: "BT-31",
        },
        {
            country: "BT",
            name: "Thimphu",
            code: "BT-15",
        },
        {
            country: "BT",
            name: "Trashigang",
            code: "BT-41",
        },
        {
            country: "BT",
            name: "Trongsa",
            code: "BT-32",
        },
        {
            country: "BT",
            name: "Tsirang",
            code: "BT-21",
        },
        {
            country: "BT",
            name: "Wangdue Phodrang",
            code: "BT-24",
        },
    ],
    BV: [
        {
            country: "BV",
            name: "Bouvet Island",
            code: "-",
        },
    ],
    BW: [
        {
            country: "BW",
            name: "Central",
            code: "BW-CE",
        },
        {
            country: "BW",
            name: "Chobe",
            code: "BW-CH",
        },
        {
            country: "BW",
            name: "Ghanzi",
            code: "BW-GH",
        },
        {
            country: "BW",
            name: "Kgalagadi",
            code: "BW-KG",
        },
        {
            country: "BW",
            name: "Kgatleng",
            code: "BW-KL",
        },
        {
            country: "BW",
            name: "Kweneng",
            code: "BW-KW",
        },
        {
            country: "BW",
            name: "North East",
            code: "BW-NE",
        },
        {
            country: "BW",
            name: "North West",
            code: "BW-NW",
        },
        {
            country: "BW",
            name: "South East",
            code: "BW-SE",
        },
        {
            country: "BW",
            name: "Southern",
            code: "BW-SO",
        },
    ],
    BY: [
        {
            country: "BY",
            name: "Brestskaya voblasts'",
            code: "BY-BR",
        },
        {
            country: "BY",
            name: "Homyel'skaya voblasts'",
            code: "BY-HO",
        },
        {
            country: "BY",
            name: "Horad Minsk",
            code: "BY-HM",
        },
        {
            country: "BY",
            name: "Hrodzyenskaya voblasts'",
            code: "BY-HR",
        },
        {
            country: "BY",
            name: "Mahilyowskaya voblasts'",
            code: "BY-MA",
        },
        {
            country: "BY",
            name: "Minskaya voblasts'",
            code: "BY-MI",
        },
        {
            country: "BY",
            name: "Vitsyebskaya voblasts'",
            code: "BY-VI",
        },
    ],
    BZ: [
        {
            country: "BZ",
            name: "Belize",
            code: "BZ-BZ",
        },
        {
            country: "BZ",
            name: "Cayo",
            code: "BZ-CY",
        },
        {
            country: "BZ",
            name: "Corozal",
            code: "BZ-CZL",
        },
        {
            country: "BZ",
            name: "Orange Walk",
            code: "BZ-OW",
        },
        {
            country: "BZ",
            name: "Stann Creek",
            code: "BZ-SC",
        },
        {
            country: "BZ",
            name: "Toledo",
            code: "BZ-TOL",
        },
    ],
    CA: [
        {
            country: "CA",
            name: "Alberta",
            code: "CA-AB",
        },
        {
            country: "CA",
            name: "British Columbia",
            code: "CA-BC",
        },
        {
            country: "CA",
            name: "Manitoba",
            code: "CA-MB",
        },
        {
            country: "CA",
            name: "New Brunswick",
            code: "CA-NB",
        },
        {
            country: "CA",
            name: "Newfoundland and Labrador",
            code: "CA-NL",
        },
        {
            country: "CA",
            name: "Northwest Territories",
            code: "CA-NT",
        },
        {
            country: "CA",
            name: "Nova Scotia",
            code: "CA-NS",
        },
        {
            country: "CA",
            name: "Nunavut",
            code: "CA-NU",
        },
        {
            country: "CA",
            name: "Ontario",
            code: "CA-ON",
        },
        {
            country: "CA",
            name: "Prince Edward Island",
            code: "CA-PE",
        },
        {
            country: "CA",
            name: "Quebec",
            code: "CA-QC",
        },
        {
            country: "CA",
            name: "Saskatchewan",
            code: "CA-SK",
        },
        {
            country: "CA",
            name: "Yukon",
            code: "CA-YT",
        },
    ],
    CC: [
        {
            country: "CC",
            name: "Cocos (Keeling) Islands",
            code: "-",
        },
    ],
    CD: [
        {
            country: "CD",
            name: "Equateur",
            code: "CD-EQ",
        },
        {
            country: "CD",
            name: "Haut-Katanga",
            code: "CD-HK",
        },
        {
            country: "CD",
            name: "Ituri",
            code: "CD-IT",
        },
        {
            country: "CD",
            name: "Kasai",
            code: "CD-KS",
        },
        {
            country: "CD",
            name: "Kasai Central",
            code: "CD-KC",
        },
        {
            country: "CD",
            name: "Kasai Oriental",
            code: "CD-KE",
        },
        {
            country: "CD",
            name: "Kinshasa",
            code: "CD-KN",
        },
        {
            country: "CD",
            name: "Kongo Central",
            code: "CD-BC",
        },
        {
            country: "CD",
            name: "Lualaba",
            code: "CD-LU",
        },
        {
            country: "CD",
            name: "Maniema",
            code: "CD-MA",
        },
        {
            country: "CD",
            name: "Nord-Kivu",
            code: "CD-NK",
        },
        {
            country: "CD",
            name: "Nord-Ubangi",
            code: "CD-NU",
        },
        {
            country: "CD",
            name: "Sankuru",
            code: "CD-SA",
        },
        {
            country: "CD",
            name: "Sud-Kivu",
            code: "CD-SK",
        },
        {
            country: "CD",
            name: "Tanganyika",
            code: "CD-TA",
        },
        {
            country: "CD",
            name: "Tshopo",
            code: "CD-TO",
        },
    ],
    CF: [
        {
            country: "CF",
            name: "Bamingui-Bangoran",
            code: "CF-BB",
        },
        {
            country: "CF",
            name: "Bangui",
            code: "CF-BGF",
        },
        {
            country: "CF",
            name: "Gribingui",
            code: "CF-KB",
        },
        {
            country: "CF",
            name: "Haut-Mbomou",
            code: "CF-HM",
        },
        {
            country: "CF",
            name: "Haute-Kotto",
            code: "CF-HK",
        },
        {
            country: "CF",
            name: "Kemo-Gribingui",
            code: "CF-KG",
        },
        {
            country: "CF",
            name: "Lobaye",
            code: "CF-LB",
        },
        {
            country: "CF",
            name: "Mambere-Kadei",
            code: "CF-HS",
        },
        {
            country: "CF",
            name: "Nana-Mambere",
            code: "CF-NM",
        },
        {
            country: "CF",
            name: "Ouaka",
            code: "CF-UK",
        },
        {
            country: "CF",
            name: "Ouham",
            code: "CF-AC",
        },
        {
            country: "CF",
            name: "Ouham-Pende",
            code: "CF-OP",
        },
        {
            country: "CF",
            name: "Vakaga",
            code: "CF-VK",
        },
    ],
    CG: [
        {
            country: "CG",
            name: "Bouenza",
            code: "CG-11",
        },
        {
            country: "CG",
            name: "Brazzaville",
            code: "CG-BZV",
        },
        {
            country: "CG",
            name: "Cuvette",
            code: "CG-8",
        },
        {
            country: "CG",
            name: "Likouala",
            code: "CG-7",
        },
        {
            country: "CG",
            name: "Niari",
            code: "CG-9",
        },
        {
            country: "CG",
            name: "Pointe-Noire",
            code: "CG-16",
        },
        {
            country: "CG",
            name: "Sangha",
            code: "CG-13",
        },
    ],
    CH: [
        {
            country: "CH",
            name: "Aargau",
            code: "CH-AG",
        },
        {
            country: "CH",
            name: "Appenzell Ausserrhoden",
            code: "CH-AR",
        },
        {
            country: "CH",
            name: "Appenzell Innerrhoden",
            code: "CH-AI",
        },
        {
            country: "CH",
            name: "Basel-Landschaft",
            code: "CH-BL",
        },
        {
            country: "CH",
            name: "Basel-Stadt",
            code: "CH-BS",
        },
        {
            country: "CH",
            name: "Bern",
            code: "CH-BE",
        },
        {
            country: "CH",
            name: "Fribourg",
            code: "CH-FR",
        },
        {
            country: "CH",
            name: "Geneve",
            code: "CH-GE",
        },
        {
            country: "CH",
            name: "Glarus",
            code: "CH-GL",
        },
        {
            country: "CH",
            name: "Graubunden",
            code: "CH-GR",
        },
        {
            country: "CH",
            name: "Jura",
            code: "CH-JU",
        },
        {
            country: "CH",
            name: "Luzern",
            code: "CH-LU",
        },
        {
            country: "CH",
            name: "Neuchatel",
            code: "CH-NE",
        },
        {
            country: "CH",
            name: "Nidwalden",
            code: "CH-NW",
        },
        {
            country: "CH",
            name: "Obwalden",
            code: "CH-OW",
        },
        {
            country: "CH",
            name: "Sankt Gallen",
            code: "CH-SG",
        },
        {
            country: "CH",
            name: "Schaffhausen",
            code: "CH-SH",
        },
        {
            country: "CH",
            name: "Schwyz",
            code: "CH-SZ",
        },
        {
            country: "CH",
            name: "Solothurn",
            code: "CH-SO",
        },
        {
            country: "CH",
            name: "Thurgau",
            code: "CH-TG",
        },
        {
            country: "CH",
            name: "Ticino",
            code: "CH-TI",
        },
        {
            country: "CH",
            name: "Uri",
            code: "CH-UR",
        },
        {
            country: "CH",
            name: "Valais",
            code: "CH-VS",
        },
        {
            country: "CH",
            name: "Vaud",
            code: "CH-VD",
        },
        {
            country: "CH",
            name: "Zug",
            code: "CH-ZG",
        },
        {
            country: "CH",
            name: "Zurich",
            code: "CH-ZH",
        },
    ],
    CI: [
        {
            country: "CI",
            name: "Abidjan",
            code: "CI-AB",
        },
        {
            country: "CI",
            name: "Bas-Sassandra",
            code: "CI-BS",
        },
        {
            country: "CI",
            name: "Comoe",
            code: "CI-CM",
        },
        {
            country: "CI",
            name: "Denguele",
            code: "CI-DN",
        },
        {
            country: "CI",
            name: "Goh-Djiboua",
            code: "CI-GD",
        },
        {
            country: "CI",
            name: "Lacs",
            code: "CI-LC",
        },
        {
            country: "CI",
            name: "Lagunes",
            code: "CI-LG",
        },
        {
            country: "CI",
            name: "Montagnes",
            code: "CI-MG",
        },
        {
            country: "CI",
            name: "Sassandra-Marahoue",
            code: "CI-SM",
        },
        {
            country: "CI",
            name: "Savanes",
            code: "CI-SV",
        },
        {
            country: "CI",
            name: "Vallee du Bandama",
            code: "CI-VB",
        },
        {
            country: "CI",
            name: "Woroba",
            code: "CI-WR",
        },
        {
            country: "CI",
            name: "Yamoussoukro",
            code: "CI-YM",
        },
        {
            country: "CI",
            name: "Zanzan",
            code: "CI-ZZ",
        },
    ],
    CK: [
        {
            country: "CK",
            name: "Cook Islands",
            code: "-",
        },
    ],
    CL: [
        {
            country: "CL",
            name: "Aisen del General Carlos Ibanez del Campo",
            code: "CL-AI",
        },
        {
            country: "CL",
            name: "Antofagasta",
            code: "CL-AN",
        },
        {
            country: "CL",
            name: "Arica y Parinacota",
            code: "CL-AP",
        },
        {
            country: "CL",
            name: "Atacama",
            code: "CL-AT",
        },
        {
            country: "CL",
            name: "Biobio",
            code: "CL-BI",
        },
        {
            country: "CL",
            name: "Coquimbo",
            code: "CL-CO",
        },
        {
            country: "CL",
            name: "La Araucania",
            code: "CL-AR",
        },
        {
            country: "CL",
            name: "Libertador General Bernardo O'Higgins",
            code: "CL-LI",
        },
        {
            country: "CL",
            name: "Los Lagos",
            code: "CL-LL",
        },
        {
            country: "CL",
            name: "Los Rios",
            code: "CL-LR",
        },
        {
            country: "CL",
            name: "Magallanes",
            code: "CL-MA",
        },
        {
            country: "CL",
            name: "Maule",
            code: "CL-ML",
        },
        {
            country: "CL",
            name: "Nuble",
            code: "CL-NB",
        },
        {
            country: "CL",
            name: "Region Metropolitana de Santiago",
            code: "CL-RM",
        },
        {
            country: "CL",
            name: "Tarapaca",
            code: "CL-TA",
        },
        {
            country: "CL",
            name: "Valparaiso",
            code: "CL-VS",
        },
    ],
    CM: [
        {
            country: "CM",
            name: "Adamaoua",
            code: "CM-AD",
        },
        {
            country: "CM",
            name: "Centre",
            code: "CM-CE",
        },
        {
            country: "CM",
            name: "Est",
            code: "CM-ES",
        },
        {
            country: "CM",
            name: "Extreme-Nord",
            code: "CM-EN",
        },
        {
            country: "CM",
            name: "Littoral",
            code: "CM-LT",
        },
        {
            country: "CM",
            name: "Nord",
            code: "CM-NO",
        },
        {
            country: "CM",
            name: "Nord-Ouest",
            code: "CM-NW",
        },
        {
            country: "CM",
            name: "Ouest",
            code: "CM-OU",
        },
        {
            country: "CM",
            name: "Sud",
            code: "CM-SU",
        },
        {
            country: "CM",
            name: "Sud-Ouest",
            code: "CM-SW",
        },
    ],
    CN: [
        {
            country: "CN",
            name: "Anhui",
            code: "CN-AH",
        },
        {
            country: "CN",
            name: "Beijing",
            code: "CN-BJ",
        },
        {
            country: "CN",
            name: "Chongqing",
            code: "CN-CQ",
        },
        {
            country: "CN",
            name: "Fujian",
            code: "CN-FJ",
        },
        {
            country: "CN",
            name: "Gansu",
            code: "CN-GS",
        },
        {
            country: "CN",
            name: "Guangdong",
            code: "CN-GD",
        },
        {
            country: "CN",
            name: "Guangxi Zhuangzu",
            code: "CN-GX",
        },
        {
            country: "CN",
            name: "Guizhou",
            code: "CN-GZ",
        },
        {
            country: "CN",
            name: "Hainan",
            code: "CN-HI",
        },
        {
            country: "CN",
            name: "Hebei",
            code: "CN-HE",
        },
        {
            country: "CN",
            name: "Heilongjiang",
            code: "CN-HL",
        },
        {
            country: "CN",
            name: "Henan",
            code: "CN-HA",
        },
        {
            country: "CN",
            name: "Hubei",
            code: "CN-HB",
        },
        {
            country: "CN",
            name: "Hunan",
            code: "CN-HN",
        },
        {
            country: "CN",
            name: "Jiangsu",
            code: "CN-JS",
        },
        {
            country: "CN",
            name: "Jiangxi",
            code: "CN-JX",
        },
        {
            country: "CN",
            name: "Jilin",
            code: "CN-JL",
        },
        {
            country: "CN",
            name: "Liaoning",
            code: "CN-LN",
        },
        {
            country: "CN",
            name: "Nei Mongol",
            code: "CN-NM",
        },
        {
            country: "CN",
            name: "Ningxia Huizu",
            code: "CN-NX",
        },
        {
            country: "CN",
            name: "Qinghai",
            code: "CN-QH",
        },
        {
            country: "CN",
            name: "Shaanxi",
            code: "CN-SN",
        },
        {
            country: "CN",
            name: "Shandong",
            code: "CN-SD",
        },
        {
            country: "CN",
            name: "Shanghai",
            code: "CN-SH",
        },
        {
            country: "CN",
            name: "Shanxi",
            code: "CN-SX",
        },
        {
            country: "CN",
            name: "Sichuan",
            code: "CN-SC",
        },
        {
            country: "CN",
            name: "Tianjin",
            code: "CN-TJ",
        },
        {
            country: "CN",
            name: "Xinjiang Uygur",
            code: "CN-XJ",
        },
        {
            country: "CN",
            name: "Xizang",
            code: "CN-XZ",
        },
        {
            country: "CN",
            name: "Yunnan",
            code: "CN-YN",
        },
        {
            country: "CN",
            name: "Zhejiang",
            code: "CN-ZJ",
        },
    ],
    CO: [
        {
            country: "CO",
            name: "Amazonas",
            code: "CO-AMA",
        },
        {
            country: "CO",
            name: "Antioquia",
            code: "CO-ANT",
        },
        {
            country: "CO",
            name: "Arauca",
            code: "CO-ARA",
        },
        {
            country: "CO",
            name: "Atlantico",
            code: "CO-ATL",
        },
        {
            country: "CO",
            name: "Bolivar",
            code: "CO-BOL",
        },
        {
            country: "CO",
            name: "Boyaca",
            code: "CO-BOY",
        },
        {
            country: "CO",
            name: "Caldas",
            code: "CO-CAL",
        },
        {
            country: "CO",
            name: "Caqueta",
            code: "CO-CAQ",
        },
        {
            country: "CO",
            name: "Casanare",
            code: "CO-CAS",
        },
        {
            country: "CO",
            name: "Cauca",
            code: "CO-CAU",
        },
        {
            country: "CO",
            name: "Cesar",
            code: "CO-CES",
        },
        {
            country: "CO",
            name: "Choco",
            code: "CO-CHO",
        },
        {
            country: "CO",
            name: "Cordoba",
            code: "CO-COR",
        },
        {
            country: "CO",
            name: "Cundinamarca",
            code: "CO-CUN",
        },
        {
            country: "CO",
            name: "Distrito Capital de Bogota",
            code: "CO-DC",
        },
        {
            country: "CO",
            name: "Guainia",
            code: "CO-GUA",
        },
        {
            country: "CO",
            name: "Guaviare",
            code: "CO-GUV",
        },
        {
            country: "CO",
            name: "Huila",
            code: "CO-HUI",
        },
        {
            country: "CO",
            name: "La Guajira",
            code: "CO-LAG",
        },
        {
            country: "CO",
            name: "Magdalena",
            code: "CO-MAG",
        },
        {
            country: "CO",
            name: "Meta",
            code: "CO-MET",
        },
        {
            country: "CO",
            name: "Narino",
            code: "CO-NAR",
        },
        {
            country: "CO",
            name: "Norte de Santander",
            code: "CO-NSA",
        },
        {
            country: "CO",
            name: "Putumayo",
            code: "CO-PUT",
        },
        {
            country: "CO",
            name: "Quindio",
            code: "CO-QUI",
        },
        {
            country: "CO",
            name: "Risaralda",
            code: "CO-RIS",
        },
        {
            country: "CO",
            name: "San Andres, Providencia y Santa Catalina",
            code: "CO-SAP",
        },
        {
            country: "CO",
            name: "Santander",
            code: "CO-SAN",
        },
        {
            country: "CO",
            name: "Sucre",
            code: "CO-SUC",
        },
        {
            country: "CO",
            name: "Tolima",
            code: "CO-TOL",
        },
        {
            country: "CO",
            name: "Valle del Cauca",
            code: "CO-VAC",
        },
        {
            country: "CO",
            name: "Vichada",
            code: "CO-VID",
        },
    ],
    CR: [
        {
            country: "CR",
            name: "Alajuela",
            code: "CR-A",
        },
        {
            country: "CR",
            name: "Cartago",
            code: "CR-C",
        },
        {
            country: "CR",
            name: "Guanacaste",
            code: "CR-G",
        },
        {
            country: "CR",
            name: "Heredia",
            code: "CR-H",
        },
        {
            country: "CR",
            name: "Limon",
            code: "CR-L",
        },
        {
            country: "CR",
            name: "Puntarenas",
            code: "CR-P",
        },
        {
            country: "CR",
            name: "San Jose",
            code: "CR-SJ",
        },
    ],
    CU: [
        {
            country: "CU",
            name: "Artemisa",
            code: "CU-15",
        },
        {
            country: "CU",
            name: "Camaguey",
            code: "CU-09",
        },
        {
            country: "CU",
            name: "Ciego de Avila",
            code: "CU-08",
        },
        {
            country: "CU",
            name: "Cienfuegos",
            code: "CU-06",
        },
        {
            country: "CU",
            name: "Granma",
            code: "CU-12",
        },
        {
            country: "CU",
            name: "Guantanamo",
            code: "CU-14",
        },
        {
            country: "CU",
            name: "Holguin",
            code: "CU-11",
        },
        {
            country: "CU",
            name: "Isla de la Juventud",
            code: "CU-99",
        },
        {
            country: "CU",
            name: "La Habana",
            code: "CU-03",
        },
        {
            country: "CU",
            name: "Las Tunas",
            code: "CU-10",
        },
        {
            country: "CU",
            name: "Matanzas",
            code: "CU-04",
        },
        {
            country: "CU",
            name: "Mayabeque",
            code: "CU-16",
        },
        {
            country: "CU",
            name: "Pinar del Rio",
            code: "CU-01",
        },
        {
            country: "CU",
            name: "Sancti Spiritus",
            code: "CU-07",
        },
        {
            country: "CU",
            name: "Santiago de Cuba",
            code: "CU-13",
        },
        {
            country: "CU",
            name: "Villa Clara",
            code: "CU-05",
        },
    ],
    CV: [
        {
            country: "CV",
            name: "Boa Vista",
            code: "CV-BV",
        },
        {
            country: "CV",
            name: "Porto Novo",
            code: "CV-PN",
        },
        {
            country: "CV",
            name: "Praia",
            code: "CV-PR",
        },
        {
            country: "CV",
            name: "Ribeira Grande",
            code: "CV-RG",
        },
        {
            country: "CV",
            name: "Ribeira Grande de Santiago",
            code: "CV-RS",
        },
        {
            country: "CV",
            name: "Sal",
            code: "CV-SL",
        },
        {
            country: "CV",
            name: "Santa Catarina",
            code: "CV-CA",
        },
        {
            country: "CV",
            name: "Sao Filipe",
            code: "CV-SF",
        },
        {
            country: "CV",
            name: "Sao Lourenco dos Orgaos",
            code: "CV-SO",
        },
        {
            country: "CV",
            name: "Sao Vicente",
            code: "CV-SV",
        },
        {
            country: "CV",
            name: "Tarrafal",
            code: "CV-TA",
        },
    ],
    CW: [
        {
            country: "CW",
            name: "Curacao",
            code: "-",
        },
    ],
    CX: [
        {
            country: "CX",
            name: "Christmas Island",
            code: "-",
        },
    ],
    CY: [
        {
            country: "CY",
            name: "Ammochostos",
            code: "CY-04",
        },
        {
            country: "CY",
            name: "Keryneia",
            code: "CY-06",
        },
        {
            country: "CY",
            name: "Larnaka",
            code: "CY-03",
        },
        {
            country: "CY",
            name: "Lefkosia",
            code: "CY-01",
        },
        {
            country: "CY",
            name: "Lemesos",
            code: "CY-02",
        },
        {
            country: "CY",
            name: "Pafos",
            code: "CY-05",
        },
    ],
    CZ: [
        {
            country: "CZ",
            name: "Jihocesky kraj",
            code: "CZ-31",
        },
        {
            country: "CZ",
            name: "Jihomoravsky kraj",
            code: "CZ-64",
        },
        {
            country: "CZ",
            name: "Karlovarsky kraj",
            code: "CZ-41",
        },
        {
            country: "CZ",
            name: "Kraj Vysocina",
            code: "CZ-63",
        },
        {
            country: "CZ",
            name: "Kralovehradecky kraj",
            code: "CZ-52",
        },
        {
            country: "CZ",
            name: "Liberecky kraj",
            code: "CZ-51",
        },
        {
            country: "CZ",
            name: "Moravskoslezsky kraj",
            code: "CZ-80",
        },
        {
            country: "CZ",
            name: "Olomoucky kraj",
            code: "CZ-71",
        },
        {
            country: "CZ",
            name: "Pardubicky kraj",
            code: "CZ-53",
        },
        {
            country: "CZ",
            name: "Plzensky kraj",
            code: "CZ-32",
        },
        {
            country: "CZ",
            name: "Praha, Hlavni mesto",
            code: "CZ-10",
        },
        {
            country: "CZ",
            name: "Stredocesky kraj",
            code: "CZ-20",
        },
        {
            country: "CZ",
            name: "Ustecky kraj",
            code: "CZ-42",
        },
        {
            country: "CZ",
            name: "Zlinsky kraj",
            code: "CZ-72",
        },
    ],
    DE: [
        {
            country: "DE",
            name: "Baden-Wurttemberg",
            code: "DE-BW",
        },
        {
            country: "DE",
            name: "Bayern",
            code: "DE-BY",
        },
        {
            country: "DE",
            name: "Berlin",
            code: "DE-BE",
        },
        {
            country: "DE",
            name: "Brandenburg",
            code: "DE-BB",
        },
        {
            country: "DE",
            name: "Bremen",
            code: "DE-HB",
        },
        {
            country: "DE",
            name: "Hamburg",
            code: "DE-HH",
        },
        {
            country: "DE",
            name: "Hessen",
            code: "DE-HE",
        },
        {
            country: "DE",
            name: "Mecklenburg-Vorpommern",
            code: "DE-MV",
        },
        {
            country: "DE",
            name: "Niedersachsen",
            code: "DE-NI",
        },
        {
            country: "DE",
            name: "Nordrhein-Westfalen",
            code: "DE-NW",
        },
        {
            country: "DE",
            name: "Rheinland-Pfalz",
            code: "DE-RP",
        },
        {
            country: "DE",
            name: "Saarland",
            code: "DE-SL",
        },
        {
            country: "DE",
            name: "Sachsen",
            code: "DE-SN",
        },
        {
            country: "DE",
            name: "Sachsen-Anhalt",
            code: "DE-ST",
        },
        {
            country: "DE",
            name: "Schleswig-Holstein",
            code: "DE-SH",
        },
        {
            country: "DE",
            name: "Thuringen",
            code: "DE-TH",
        },
    ],
    DJ: [
        {
            country: "DJ",
            name: "Arta",
            code: "DJ-AR",
        },
        {
            country: "DJ",
            name: "Dikhil",
            code: "DJ-DI",
        },
        {
            country: "DJ",
            name: "Djibouti",
            code: "DJ-DJ",
        },
        {
            country: "DJ",
            name: "Tadjourah",
            code: "DJ-TA",
        },
    ],
    DK: [
        {
            country: "DK",
            name: "Hovedstaden",
            code: "DK-84",
        },
        {
            country: "DK",
            name: "Midtjylland",
            code: "DK-82",
        },
        {
            country: "DK",
            name: "Nordjylland",
            code: "DK-81",
        },
        {
            country: "DK",
            name: "Sjaelland",
            code: "DK-85",
        },
        {
            country: "DK",
            name: "Syddanmark",
            code: "DK-83",
        },
    ],
    DM: [
        {
            country: "DM",
            name: "Saint Andrew",
            code: "DM-02",
        },
        {
            country: "DM",
            name: "Saint George",
            code: "DM-04",
        },
        {
            country: "DM",
            name: "Saint John",
            code: "DM-05",
        },
        {
            country: "DM",
            name: "Saint Joseph",
            code: "DM-06",
        },
        {
            country: "DM",
            name: "Saint Luke",
            code: "DM-07",
        },
        {
            country: "DM",
            name: "Saint Patrick",
            code: "DM-09",
        },
        {
            country: "DM",
            name: "Saint Paul",
            code: "DM-10",
        },
    ],
    DO: [
        {
            country: "DO",
            name: "Azua",
            code: "DO-02",
        },
        {
            country: "DO",
            name: "Baoruco",
            code: "DO-03",
        },
        {
            country: "DO",
            name: "Barahona",
            code: "DO-04",
        },
        {
            country: "DO",
            name: "Dajabon",
            code: "DO-05",
        },
        {
            country: "DO",
            name: "Distrito Nacional (Santo Domingo)",
            code: "DO-01",
        },
        {
            country: "DO",
            name: "Duarte",
            code: "DO-06",
        },
        {
            country: "DO",
            name: "El Seibo",
            code: "DO-08",
        },
        {
            country: "DO",
            name: "Elias Pina",
            code: "DO-07",
        },
        {
            country: "DO",
            name: "Espaillat",
            code: "DO-09",
        },
        {
            country: "DO",
            name: "Hato Mayor",
            code: "DO-30",
        },
        {
            country: "DO",
            name: "Hermanas Mirabal",
            code: "DO-19",
        },
        {
            country: "DO",
            name: "Independencia",
            code: "DO-10",
        },
        {
            country: "DO",
            name: "La Altagracia",
            code: "DO-11",
        },
        {
            country: "DO",
            name: "La Romana",
            code: "DO-12",
        },
        {
            country: "DO",
            name: "La Vega",
            code: "DO-13",
        },
        {
            country: "DO",
            name: "Maria Trinidad Sanchez",
            code: "DO-14",
        },
        {
            country: "DO",
            name: "Monsenor Nouel",
            code: "DO-28",
        },
        {
            country: "DO",
            name: "Monte Cristi",
            code: "DO-15",
        },
        {
            country: "DO",
            name: "Monte Plata",
            code: "DO-29",
        },
        {
            country: "DO",
            name: "Peravia",
            code: "DO-17",
        },
        {
            country: "DO",
            name: "Puerto Plata",
            code: "DO-18",
        },
        {
            country: "DO",
            name: "Samana",
            code: "DO-20",
        },
        {
            country: "DO",
            name: "San Cristobal",
            code: "DO-21",
        },
        {
            country: "DO",
            name: "San Jose de Ocoa",
            code: "DO-31",
        },
        {
            country: "DO",
            name: "San Juan",
            code: "DO-22",
        },
        {
            country: "DO",
            name: "San Pedro de Macoris",
            code: "DO-23",
        },
        {
            country: "DO",
            name: "Sanchez Ramirez",
            code: "DO-24",
        },
        {
            country: "DO",
            name: "Santiago",
            code: "DO-25",
        },
        {
            country: "DO",
            name: "Santiago Rodriguez",
            code: "DO-26",
        },
        {
            country: "DO",
            name: "Valverde",
            code: "DO-27",
        },
    ],
    DZ: [
        {
            country: "DZ",
            name: "Adrar",
            code: "DZ-01",
        },
        {
            country: "DZ",
            name: "Ain Defla",
            code: "DZ-44",
        },
        {
            country: "DZ",
            name: "Ain Temouchent",
            code: "DZ-46",
        },
        {
            country: "DZ",
            name: "Alger",
            code: "DZ-16",
        },
        {
            country: "DZ",
            name: "Annaba",
            code: "DZ-23",
        },
        {
            country: "DZ",
            name: "Batna",
            code: "DZ-05",
        },
        {
            country: "DZ",
            name: "Bechar",
            code: "DZ-08",
        },
        {
            country: "DZ",
            name: "Bejaia",
            code: "DZ-06",
        },
        {
            country: "DZ",
            name: "Biskra",
            code: "DZ-07",
        },
        {
            country: "DZ",
            name: "Blida",
            code: "DZ-09",
        },
        {
            country: "DZ",
            name: "Bordj Bou Arreridj",
            code: "DZ-34",
        },
        {
            country: "DZ",
            name: "Bouira",
            code: "DZ-10",
        },
        {
            country: "DZ",
            name: "Boumerdes",
            code: "DZ-35",
        },
        {
            country: "DZ",
            name: "Chlef",
            code: "DZ-02",
        },
        {
            country: "DZ",
            name: "Constantine",
            code: "DZ-25",
        },
        {
            country: "DZ",
            name: "Djanet",
            code: "DZ-56",
        },
        {
            country: "DZ",
            name: "Djelfa",
            code: "DZ-17",
        },
        {
            country: "DZ",
            name: "El Bayadh",
            code: "DZ-32",
        },
        {
            country: "DZ",
            name: "El Meghaier",
            code: "DZ-57",
        },
        {
            country: "DZ",
            name: "El Oued",
            code: "DZ-39",
        },
        {
            country: "DZ",
            name: "El Tarf",
            code: "DZ-36",
        },
        {
            country: "DZ",
            name: "Ghardaia",
            code: "DZ-47",
        },
        {
            country: "DZ",
            name: "Guelma",
            code: "DZ-24",
        },
        {
            country: "DZ",
            name: "Illizi",
            code: "DZ-33",
        },
        {
            country: "DZ",
            name: "In Salah",
            code: "DZ-53",
        },
        {
            country: "DZ",
            name: "Jijel",
            code: "DZ-18",
        },
        {
            country: "DZ",
            name: "Khenchela",
            code: "DZ-40",
        },
        {
            country: "DZ",
            name: "Laghouat",
            code: "DZ-03",
        },
        {
            country: "DZ",
            name: "M'sila",
            code: "DZ-28",
        },
        {
            country: "DZ",
            name: "Mascara",
            code: "DZ-29",
        },
        {
            country: "DZ",
            name: "Medea",
            code: "DZ-26",
        },
        {
            country: "DZ",
            name: "Mila",
            code: "DZ-43",
        },
        {
            country: "DZ",
            name: "Mostaganem",
            code: "DZ-27",
        },
        {
            country: "DZ",
            name: "Naama",
            code: "DZ-45",
        },
        {
            country: "DZ",
            name: "Oran",
            code: "DZ-31",
        },
        {
            country: "DZ",
            name: "Ouargla",
            code: "DZ-30",
        },
        {
            country: "DZ",
            name: "Ouled Djellal",
            code: "DZ-51",
        },
        {
            country: "DZ",
            name: "Oum el Bouaghi",
            code: "DZ-04",
        },
        {
            country: "DZ",
            name: "Relizane",
            code: "DZ-48",
        },
        {
            country: "DZ",
            name: "Saida",
            code: "DZ-20",
        },
        {
            country: "DZ",
            name: "Setif",
            code: "DZ-19",
        },
        {
            country: "DZ",
            name: "Sidi Bel Abbes",
            code: "DZ-22",
        },
        {
            country: "DZ",
            name: "Skikda",
            code: "DZ-21",
        },
        {
            country: "DZ",
            name: "Souk Ahras",
            code: "DZ-41",
        },
        {
            country: "DZ",
            name: "Tamanrasset",
            code: "DZ-11",
        },
        {
            country: "DZ",
            name: "Tebessa",
            code: "DZ-12",
        },
        {
            country: "DZ",
            name: "Tiaret",
            code: "DZ-14",
        },
        {
            country: "DZ",
            name: "Timimoun",
            code: "DZ-49",
        },
        {
            country: "DZ",
            name: "Tindouf",
            code: "DZ-37",
        },
        {
            country: "DZ",
            name: "Tipaza",
            code: "DZ-42",
        },
        {
            country: "DZ",
            name: "Tissemsilt",
            code: "DZ-38",
        },
        {
            country: "DZ",
            name: "Tizi Ouzou",
            code: "DZ-15",
        },
        {
            country: "DZ",
            name: "Tlemcen",
            code: "DZ-13",
        },
        {
            country: "DZ",
            name: "Touggourt",
            code: "DZ-55",
        },
    ],
    EC: [
        {
            country: "EC",
            name: "Azuay",
            code: "EC-A",
        },
        {
            country: "EC",
            name: "Bolivar",
            code: "EC-B",
        },
        {
            country: "EC",
            name: "Canar",
            code: "EC-F",
        },
        {
            country: "EC",
            name: "Carchi",
            code: "EC-C",
        },
        {
            country: "EC",
            name: "Chimborazo",
            code: "EC-H",
        },
        {
            country: "EC",
            name: "Cotopaxi",
            code: "EC-X",
        },
        {
            country: "EC",
            name: "El Oro",
            code: "EC-O",
        },
        {
            country: "EC",
            name: "Esmeraldas",
            code: "EC-E",
        },
        {
            country: "EC",
            name: "Galapagos",
            code: "EC-W",
        },
        {
            country: "EC",
            name: "Guayas",
            code: "EC-G",
        },
        {
            country: "EC",
            name: "Imbabura",
            code: "EC-I",
        },
        {
            country: "EC",
            name: "Loja",
            code: "EC-L",
        },
        {
            country: "EC",
            name: "Los Rios",
            code: "EC-R",
        },
        {
            country: "EC",
            name: "Manabi",
            code: "EC-M",
        },
        {
            country: "EC",
            name: "Morona Santiago",
            code: "EC-S",
        },
        {
            country: "EC",
            name: "Napo",
            code: "EC-N",
        },
        {
            country: "EC",
            name: "Orellana",
            code: "EC-D",
        },
        {
            country: "EC",
            name: "Pastaza",
            code: "EC-Y",
        },
        {
            country: "EC",
            name: "Pichincha",
            code: "EC-P",
        },
        {
            country: "EC",
            name: "Santa Elena",
            code: "EC-SE",
        },
        {
            country: "EC",
            name: "Santo Domingo de los Tsachilas",
            code: "EC-SD",
        },
        {
            country: "EC",
            name: "Sucumbios",
            code: "EC-U",
        },
        {
            country: "EC",
            name: "Tungurahua",
            code: "EC-T",
        },
        {
            country: "EC",
            name: "Zamora Chinchipe",
            code: "EC-Z",
        },
    ],
    EE: [
        {
            country: "EE",
            name: "Harjumaa",
            code: "EE-37",
        },
        {
            country: "EE",
            name: "Hiiumaa",
            code: "EE-39",
        },
        {
            country: "EE",
            name: "Ida-Virumaa",
            code: "EE-45",
        },
        {
            country: "EE",
            name: "Jarvamaa",
            code: "EE-52",
        },
        {
            country: "EE",
            name: "Jogevamaa",
            code: "EE-50",
        },
        {
            country: "EE",
            name: "Laane-Virumaa",
            code: "EE-60",
        },
        {
            country: "EE",
            name: "Laanemaa",
            code: "EE-56",
        },
        {
            country: "EE",
            name: "Parnumaa",
            code: "EE-68",
        },
        {
            country: "EE",
            name: "Polvamaa",
            code: "EE-64",
        },
        {
            country: "EE",
            name: "Raplamaa",
            code: "EE-71",
        },
        {
            country: "EE",
            name: "Saaremaa",
            code: "EE-74",
        },
        {
            country: "EE",
            name: "Tartumaa",
            code: "EE-79",
        },
        {
            country: "EE",
            name: "Valgamaa",
            code: "EE-81",
        },
        {
            country: "EE",
            name: "Viljandimaa",
            code: "EE-84",
        },
        {
            country: "EE",
            name: "Vorumaa",
            code: "EE-87",
        },
    ],
    EG: [
        {
            country: "EG",
            name: "Ad Daqahliyah",
            code: "EG-DK",
        },
        {
            country: "EG",
            name: "Al Bahr al Ahmar",
            code: "EG-BA",
        },
        {
            country: "EG",
            name: "Al Buhayrah",
            code: "EG-BH",
        },
        {
            country: "EG",
            name: "Al Fayyum",
            code: "EG-FYM",
        },
        {
            country: "EG",
            name: "Al Gharbiyah",
            code: "EG-GH",
        },
        {
            country: "EG",
            name: "Al Iskandariyah",
            code: "EG-ALX",
        },
        {
            country: "EG",
            name: "Al Isma'iliyah",
            code: "EG-IS",
        },
        {
            country: "EG",
            name: "Al Jizah",
            code: "EG-GZ",
        },
        {
            country: "EG",
            name: "Al Minufiyah",
            code: "EG-MNF",
        },
        {
            country: "EG",
            name: "Al Minya",
            code: "EG-MN",
        },
        {
            country: "EG",
            name: "Al Qahirah",
            code: "EG-C",
        },
        {
            country: "EG",
            name: "Al Qalyubiyah",
            code: "EG-KB",
        },
        {
            country: "EG",
            name: "Al Uqsur",
            code: "EG-LX",
        },
        {
            country: "EG",
            name: "Al Wadi al Jadid",
            code: "EG-WAD",
        },
        {
            country: "EG",
            name: "As Suways",
            code: "EG-SUZ",
        },
        {
            country: "EG",
            name: "Ash Sharqiyah",
            code: "EG-SHR",
        },
        {
            country: "EG",
            name: "Aswan",
            code: "EG-ASN",
        },
        {
            country: "EG",
            name: "Asyut",
            code: "EG-AST",
        },
        {
            country: "EG",
            name: "Bani Suwayf",
            code: "EG-BNS",
        },
        {
            country: "EG",
            name: "Bur Sa'id",
            code: "EG-PTS",
        },
        {
            country: "EG",
            name: "Dumyat",
            code: "EG-DT",
        },
        {
            country: "EG",
            name: "Janub Sina'",
            code: "EG-JS",
        },
        {
            country: "EG",
            name: "Kafr ash Shaykh",
            code: "EG-KFS",
        },
        {
            country: "EG",
            name: "Matruh",
            code: "EG-MT",
        },
        {
            country: "EG",
            name: "Qina",
            code: "EG-KN",
        },
        {
            country: "EG",
            name: "Shamal Sina'",
            code: "EG-SIN",
        },
        {
            country: "EG",
            name: "Suhaj",
            code: "EG-SHG",
        },
    ],
    EH: [
        {
            country: "EH",
            name: "Western Sahara",
            code: "-",
        },
    ],
    ER: [
        {
            country: "ER",
            name: "Al Awsat",
            code: "ER-MA",
        },
        {
            country: "ER",
            name: "Qash-Barkah",
            code: "ER-GB",
        },
    ],
    ES: [
        {
            country: "ES",
            name: "Andalucia",
            code: "ES-AN",
        },
        {
            country: "ES",
            name: "Aragon",
            code: "ES-AR",
        },
        {
            country: "ES",
            name: "Asturias, Principado de",
            code: "ES-AS",
        },
        {
            country: "ES",
            name: "Canarias",
            code: "ES-CN",
        },
        {
            country: "ES",
            name: "Cantabria",
            code: "ES-CB",
        },
        {
            country: "ES",
            name: "Castilla y Leon",
            code: "ES-CL",
        },
        {
            country: "ES",
            name: "Castilla-La Mancha",
            code: "ES-CM",
        },
        {
            country: "ES",
            name: "Catalunya",
            code: "ES-CT",
        },
        {
            country: "ES",
            name: "Ceuta",
            code: "ES-CE",
        },
        {
            country: "ES",
            name: "Extremadura",
            code: "ES-EX",
        },
        {
            country: "ES",
            name: "Galicia",
            code: "ES-GA",
        },
        {
            country: "ES",
            name: "Illes Balears",
            code: "ES-IB",
        },
        {
            country: "ES",
            name: "La Rioja",
            code: "ES-RI",
        },
        {
            country: "ES",
            name: "Madrid, Comunidad de",
            code: "ES-MD",
        },
        {
            country: "ES",
            name: "Melilla",
            code: "ES-ML",
        },
        {
            country: "ES",
            name: "Murcia, Region de",
            code: "ES-MC",
        },
        {
            country: "ES",
            name: "Navarra, Comunidad Foral de",
            code: "ES-NC",
        },
        {
            country: "ES",
            name: "Pais Vasco",
            code: "ES-PV",
        },
        {
            country: "ES",
            name: "Valenciana, Comunidad",
            code: "ES-VC",
        },
    ],
    ET: [
        {
            country: "ET",
            name: "Addis Ababa",
            code: "ET-AA",
        },
        {
            country: "ET",
            name: "Afar",
            code: "ET-AF",
        },
        {
            country: "ET",
            name: "Amara",
            code: "ET-AM",
        },
        {
            country: "ET",
            name: "Benshangul-Gumaz",
            code: "ET-BE",
        },
        {
            country: "ET",
            name: "Dire Dawa",
            code: "ET-DD",
        },
        {
            country: "ET",
            name: "Harari People",
            code: "ET-HA",
        },
        {
            country: "ET",
            name: "Oromia",
            code: "ET-OR",
        },
        {
            country: "ET",
            name: "Somali",
            code: "ET-SO",
        },
        {
            country: "ET",
            name: "Southern Nations, Nationalities and Peoples",
            code: "ET-SN",
        },
        {
            country: "ET",
            name: "Tigrai",
            code: "ET-TI",
        },
    ],
    FI: [
        {
            country: "FI",
            name: "Etela-Karjala",
            code: "FI-02",
        },
        {
            country: "FI",
            name: "Etela-Pohjanmaa",
            code: "FI-03",
        },
        {
            country: "FI",
            name: "Etela-Savo",
            code: "FI-04",
        },
        {
            country: "FI",
            name: "Kainuu",
            code: "FI-05",
        },
        {
            country: "FI",
            name: "Kanta-Hame",
            code: "FI-06",
        },
        {
            country: "FI",
            name: "Keski-Pohjanmaa",
            code: "FI-07",
        },
        {
            country: "FI",
            name: "Keski-Suomi",
            code: "FI-08",
        },
        {
            country: "FI",
            name: "Kymenlaakso",
            code: "FI-09",
        },
        {
            country: "FI",
            name: "Lappi",
            code: "FI-10",
        },
        {
            country: "FI",
            name: "Paijat-Hame",
            code: "FI-16",
        },
        {
            country: "FI",
            name: "Pirkanmaa",
            code: "FI-11",
        },
        {
            country: "FI",
            name: "Pohjanmaa",
            code: "FI-12",
        },
        {
            country: "FI",
            name: "Pohjois-Karjala",
            code: "FI-13",
        },
        {
            country: "FI",
            name: "Pohjois-Pohjanmaa",
            code: "FI-14",
        },
        {
            country: "FI",
            name: "Pohjois-Savo",
            code: "FI-15",
        },
        {
            country: "FI",
            name: "Satakunta",
            code: "FI-17",
        },
        {
            country: "FI",
            name: "Uusimaa",
            code: "FI-18",
        },
        {
            country: "FI",
            name: "Varsinais-Suomi",
            code: "FI-19",
        },
    ],
    FJ: [
        {
            country: "FJ",
            name: "Central",
            code: "FJ-C",
        },
        {
            country: "FJ",
            name: "Eastern",
            code: "FJ-E",
        },
        {
            country: "FJ",
            name: "Northern",
            code: "FJ-N",
        },
        {
            country: "FJ",
            name: "Rotuma",
            code: "FJ-R",
        },
        {
            country: "FJ",
            name: "Western",
            code: "FJ-W",
        },
    ],
    FK: [
        {
            country: "FK",
            name: "Falkland Islands (Malvinas)",
            code: "-",
        },
    ],
    FM: [
        {
            country: "FM",
            name: "Chuuk",
            code: "FM-TRK",
        },
        {
            country: "FM",
            name: "Kosrae",
            code: "FM-KSA",
        },
        {
            country: "FM",
            name: "Pohnpei",
            code: "FM-PNI",
        },
        {
            country: "FM",
            name: "Yap",
            code: "FM-YAP",
        },
    ],
    FO: [
        {
            country: "FO",
            name: "Eysturoy",
            code: "-",
        },
        {
            country: "FO",
            name: "Nordoyar",
            code: "-",
        },
        {
            country: "FO",
            name: "Streymoy",
            code: "-",
        },
        {
            country: "FO",
            name: "Suduroy",
            code: "-",
        },
        {
            country: "FO",
            name: "Vagar",
            code: "-",
        },
    ],
    FR: [
        {
            country: "FR",
            name: "Auvergne-Rhone-Alpes",
            code: "FR-ARA",
        },
        {
            country: "FR",
            name: "Bourgogne-Franche-Comte",
            code: "FR-BFC",
        },
        {
            country: "FR",
            name: "Bretagne",
            code: "FR-BRE",
        },
        {
            country: "FR",
            name: "Centre-Val de Loire",
            code: "FR-CVL",
        },
        {
            country: "FR",
            name: "Corse",
            code: "FR-20R",
        },
        {
            country: "FR",
            name: "Grand-Est",
            code: "FR-GES",
        },
        {
            country: "FR",
            name: "Hauts-de-France",
            code: "FR-HDF",
        },
        {
            country: "FR",
            name: "Ile-de-France",
            code: "FR-IDF",
        },
        {
            country: "FR",
            name: "Normandie",
            code: "FR-NOR",
        },
        {
            country: "FR",
            name: "Nouvelle-Aquitaine",
            code: "FR-NAQ",
        },
        {
            country: "FR",
            name: "Occitanie",
            code: "FR-OCC",
        },
        {
            country: "FR",
            name: "Pays-de-la-Loire",
            code: "FR-PDL",
        },
        {
            country: "FR",
            name: "Provence-Alpes-Cote-d'Azur",
            code: "FR-PAC",
        },
    ],
    GA: [
        {
            country: "GA",
            name: "Estuaire",
            code: "GA-1",
        },
        {
            country: "GA",
            name: "Haut-Ogooue",
            code: "GA-2",
        },
        {
            country: "GA",
            name: "Moyen-Ogooue",
            code: "GA-3",
        },
        {
            country: "GA",
            name: "Ngounie",
            code: "GA-4",
        },
        {
            country: "GA",
            name: "Nyanga",
            code: "GA-5",
        },
        {
            country: "GA",
            name: "Ogooue-Lolo",
            code: "GA-7",
        },
        {
            country: "GA",
            name: "Ogooue-Maritime",
            code: "GA-8",
        },
        {
            country: "GA",
            name: "Woleu-Ntem",
            code: "GA-9",
        },
    ],
    GB: [
        {
            country: "GB",
            name: "England",
            code: "GB-ENG",
        },
        {
            country: "GB",
            name: "Northern Ireland",
            code: "GB-NIR",
        },
        {
            country: "GB",
            name: "Scotland",
            code: "GB-SCT",
        },
        {
            country: "GB",
            name: "Wales",
            code: "GB-WLS",
        },
    ],
    GD: [
        {
            country: "GD",
            name: "Saint Andrew",
            code: "GD-01",
        },
        {
            country: "GD",
            name: "Saint David",
            code: "GD-02",
        },
        {
            country: "GD",
            name: "Saint George",
            code: "GD-03",
        },
        {
            country: "GD",
            name: "Saint John",
            code: "GD-04",
        },
        {
            country: "GD",
            name: "Saint Mark",
            code: "GD-05",
        },
        {
            country: "GD",
            name: "Saint Patrick",
            code: "GD-06",
        },
        {
            country: "GD",
            name: "Southern Grenadine Islands",
            code: "GD-10",
        },
    ],
    GE: [
        {
            country: "GE",
            name: "Abkhazia",
            code: "GE-AB",
        },
        {
            country: "GE",
            name: "Ajaria",
            code: "GE-AJ",
        },
        {
            country: "GE",
            name: "Guria",
            code: "GE-GU",
        },
        {
            country: "GE",
            name: "Imereti",
            code: "GE-IM",
        },
        {
            country: "GE",
            name: "K'akheti",
            code: "GE-KA",
        },
        {
            country: "GE",
            name: "Kvemo Kartli",
            code: "GE-KK",
        },
        {
            country: "GE",
            name: "Mtskheta-Mtianeti",
            code: "GE-MM",
        },
        {
            country: "GE",
            name: "Rach'a-Lechkhumi-Kvemo Svaneti",
            code: "GE-RL",
        },
        {
            country: "GE",
            name: "Samegrelo-Zemo Svaneti",
            code: "GE-SZ",
        },
        {
            country: "GE",
            name: "Samtskhe-Javakheti",
            code: "GE-SJ",
        },
        {
            country: "GE",
            name: "Shida Kartli",
            code: "GE-SK",
        },
        {
            country: "GE",
            name: "Tbilisi",
            code: "GE-TB",
        },
    ],
    GF: [
        {
            country: "GF",
            name: "Guyane",
            code: "-",
        },
    ],
    GG: [
        {
            country: "GG",
            name: "Guernsey",
            code: "-",
        },
    ],
    GH: [
        {
            country: "GH",
            name: "Ahafo",
            code: "GH-AF",
        },
        {
            country: "GH",
            name: "Ashanti",
            code: "GH-AH",
        },
        {
            country: "GH",
            name: "Bono",
            code: "GH-BO",
        },
        {
            country: "GH",
            name: "Bono East",
            code: "GH-BE",
        },
        {
            country: "GH",
            name: "Central",
            code: "GH-CP",
        },
        {
            country: "GH",
            name: "Eastern",
            code: "GH-EP",
        },
        {
            country: "GH",
            name: "Greater Accra",
            code: "GH-AA",
        },
        {
            country: "GH",
            name: "Northern",
            code: "GH-NP",
        },
        {
            country: "GH",
            name: "Upper East",
            code: "GH-UE",
        },
        {
            country: "GH",
            name: "Upper West",
            code: "GH-UW",
        },
        {
            country: "GH",
            name: "Volta",
            code: "GH-TV",
        },
        {
            country: "GH",
            name: "Western",
            code: "GH-WP",
        },
    ],
    GI: [
        {
            country: "GI",
            name: "Gibraltar",
            code: "-",
        },
    ],
    GL: [
        {
            country: "GL",
            name: "Avannaata Kommunia",
            code: "GL-AV",
        },
        {
            country: "GL",
            name: "Kommune Kujalleq",
            code: "GL-KU",
        },
        {
            country: "GL",
            name: "Kommune Qeqertalik",
            code: "GL-QT",
        },
        {
            country: "GL",
            name: "Kommuneqarfik Sermersooq",
            code: "GL-SM",
        },
        {
            country: "GL",
            name: "Qeqqata Kommunia",
            code: "GL-QE",
        },
    ],
    GM: [
        {
            country: "GM",
            name: "Banjul",
            code: "GM-B",
        },
        {
            country: "GM",
            name: "Central River",
            code: "GM-M",
        },
        {
            country: "GM",
            name: "Lower River",
            code: "GM-L",
        },
        {
            country: "GM",
            name: "North Bank",
            code: "GM-N",
        },
        {
            country: "GM",
            name: "Western",
            code: "GM-W",
        },
    ],
    GN: [
        {
            country: "GN",
            name: "Beyla",
            code: "GN-BE",
        },
        {
            country: "GN",
            name: "Boffa",
            code: "GN-BF",
        },
        {
            country: "GN",
            name: "Boke",
            code: "GN-BK",
        },
        {
            country: "GN",
            name: "Conakry",
            code: "GN-C",
        },
        {
            country: "GN",
            name: "Dabola",
            code: "GN-DB",
        },
        {
            country: "GN",
            name: "Dinguiraye",
            code: "GN-DI",
        },
        {
            country: "GN",
            name: "Dubreka",
            code: "GN-DU",
        },
        {
            country: "GN",
            name: "Fria",
            code: "GN-FR",
        },
        {
            country: "GN",
            name: "Kankan",
            code: "GN-KA",
        },
        {
            country: "GN",
            name: "Kouroussa",
            code: "GN-KO",
        },
        {
            country: "GN",
            name: "Labe",
            code: "GN-LA",
        },
        {
            country: "GN",
            name: "Mamou",
            code: "GN-MM",
        },
        {
            country: "GN",
            name: "Pita",
            code: "GN-PI",
        },
        {
            country: "GN",
            name: "Siguiri",
            code: "GN-SI",
        },
    ],
    GP: [
        {
            country: "GP",
            name: "Guadeloupe",
            code: "-",
        },
    ],
    GQ: [
        {
            country: "GQ",
            name: "Annobon",
            code: "GQ-AN",
        },
        {
            country: "GQ",
            name: "Bioko Norte",
            code: "GQ-BN",
        },
        {
            country: "GQ",
            name: "Centro Sur",
            code: "GQ-CS",
        },
        {
            country: "GQ",
            name: "Kie-Ntem",
            code: "GQ-KN",
        },
        {
            country: "GQ",
            name: "Litoral",
            code: "GQ-LI",
        },
        {
            country: "GQ",
            name: "Wele-Nzas",
            code: "GQ-WN",
        },
    ],
    GR: [
        {
            country: "GR",
            name: "Anatoliki Makedonia kai Thraki",
            code: "GR-A",
        },
        {
            country: "GR",
            name: "Attiki",
            code: "GR-I",
        },
        {
            country: "GR",
            name: "Dytiki Ellada",
            code: "GR-G",
        },
        {
            country: "GR",
            name: "Dytiki Makedonia",
            code: "GR-C",
        },
        {
            country: "GR",
            name: "Ionia Nisia",
            code: "GR-F",
        },
        {
            country: "GR",
            name: "Ipeiros",
            code: "GR-D",
        },
        {
            country: "GR",
            name: "Kentriki Makedonia",
            code: "GR-B",
        },
        {
            country: "GR",
            name: "Kriti",
            code: "GR-M",
        },
        {
            country: "GR",
            name: "Notio Aigaio",
            code: "GR-L",
        },
        {
            country: "GR",
            name: "Peloponnisos",
            code: "GR-J",
        },
        {
            country: "GR",
            name: "Sterea Ellada",
            code: "GR-H",
        },
        {
            country: "GR",
            name: "Thessalia",
            code: "GR-E",
        },
        {
            country: "GR",
            name: "Voreio Aigaio",
            code: "GR-K",
        },
    ],
    GS: [
        {
            country: "GS",
            name: "South Georgia and the South Sandwich Islands",
            code: "-",
        },
    ],
    GT: [
        {
            country: "GT",
            name: "Alta Verapaz",
            code: "GT-16",
        },
        {
            country: "GT",
            name: "Baja Verapaz",
            code: "GT-15",
        },
        {
            country: "GT",
            name: "Chimaltenango",
            code: "GT-04",
        },
        {
            country: "GT",
            name: "Chiquimula",
            code: "GT-20",
        },
        {
            country: "GT",
            name: "El Progreso",
            code: "GT-02",
        },
        {
            country: "GT",
            name: "Escuintla",
            code: "GT-05",
        },
        {
            country: "GT",
            name: "Guatemala",
            code: "GT-01",
        },
        {
            country: "GT",
            name: "Huehuetenango",
            code: "GT-13",
        },
        {
            country: "GT",
            name: "Izabal",
            code: "GT-18",
        },
        {
            country: "GT",
            name: "Jalapa",
            code: "GT-21",
        },
        {
            country: "GT",
            name: "Jutiapa",
            code: "GT-22",
        },
        {
            country: "GT",
            name: "Peten",
            code: "GT-17",
        },
        {
            country: "GT",
            name: "Quetzaltenango",
            code: "GT-09",
        },
        {
            country: "GT",
            name: "Quiche",
            code: "GT-14",
        },
        {
            country: "GT",
            name: "Retalhuleu",
            code: "GT-11",
        },
        {
            country: "GT",
            name: "Sacatepequez",
            code: "GT-03",
        },
        {
            country: "GT",
            name: "San Marcos",
            code: "GT-12",
        },
        {
            country: "GT",
            name: "Santa Rosa",
            code: "GT-06",
        },
        {
            country: "GT",
            name: "Solola",
            code: "GT-07",
        },
        {
            country: "GT",
            name: "Suchitepequez",
            code: "GT-10",
        },
        {
            country: "GT",
            name: "Totonicapan",
            code: "GT-08",
        },
        {
            country: "GT",
            name: "Zacapa",
            code: "GT-19",
        },
    ],
    GU: [
        {
            country: "GU",
            name: "Agana Heights",
            code: "-",
        },
        {
            country: "GU",
            name: "Agat",
            code: "-",
        },
        {
            country: "GU",
            name: "Barrigada",
            code: "-",
        },
        {
            country: "GU",
            name: "Chalan Pago-Ordot",
            code: "-",
        },
        {
            country: "GU",
            name: "Dededo",
            code: "-",
        },
        {
            country: "GU",
            name: "Hagatna",
            code: "-",
        },
        {
            country: "GU",
            name: "Inarajan",
            code: "-",
        },
        {
            country: "GU",
            name: "Mangilao",
            code: "-",
        },
        {
            country: "GU",
            name: "Mongmong-Toto-Maite",
            code: "-",
        },
        {
            country: "GU",
            name: "Piti",
            code: "-",
        },
        {
            country: "GU",
            name: "Santa Rita",
            code: "-",
        },
        {
            country: "GU",
            name: "Sinajana",
            code: "-",
        },
        {
            country: "GU",
            name: "Talofofo",
            code: "-",
        },
        {
            country: "GU",
            name: "Tamuning-Tumon-Harmon",
            code: "-",
        },
        {
            country: "GU",
            name: "Yigo",
            code: "-",
        },
        {
            country: "GU",
            name: "Yona",
            code: "-",
        },
    ],
    GW: [
        {
            country: "GW",
            name: "Bafata",
            code: "GW-BA",
        },
        {
            country: "GW",
            name: "Bissau",
            code: "GW-BS",
        },
        {
            country: "GW",
            name: "Cacheu",
            code: "GW-CA",
        },
        {
            country: "GW",
            name: "Gabu",
            code: "GW-GA",
        },
        {
            country: "GW",
            name: "Oio",
            code: "GW-OI",
        },
        {
            country: "GW",
            name: "Quinara",
            code: "GW-QU",
        },
    ],
    GY: [
        {
            country: "GY",
            name: "Barima-Waini",
            code: "GY-BA",
        },
        {
            country: "GY",
            name: "Cuyuni-Mazaruni",
            code: "GY-CU",
        },
        {
            country: "GY",
            name: "Demerara-Mahaica",
            code: "GY-DE",
        },
        {
            country: "GY",
            name: "East Berbice-Corentyne",
            code: "GY-EB",
        },
        {
            country: "GY",
            name: "Essequibo Islands-West Demerara",
            code: "GY-ES",
        },
        {
            country: "GY",
            name: "Mahaica-Berbice",
            code: "GY-MA",
        },
        {
            country: "GY",
            name: "Pomeroon-Supenaam",
            code: "GY-PM",
        },
        {
            country: "GY",
            name: "Upper Demerara-Berbice",
            code: "GY-UD",
        },
        {
            country: "GY",
            name: "Upper Takutu-Upper Essequibo",
            code: "GY-UT",
        },
    ],
    HK: [
        {
            country: "HK",
            name: "Hong Kong",
            code: "-",
        },
    ],
    HM: [
        {
            country: "HM",
            name: "Heard Island and McDonald Islands",
            code: "-",
        },
    ],
    HN: [
        {
            country: "HN",
            name: "Atlantida",
            code: "HN-AT",
        },
        {
            country: "HN",
            name: "Choluteca",
            code: "HN-CH",
        },
        {
            country: "HN",
            name: "Colon",
            code: "HN-CL",
        },
        {
            country: "HN",
            name: "Comayagua",
            code: "HN-CM",
        },
        {
            country: "HN",
            name: "Copan",
            code: "HN-CP",
        },
        {
            country: "HN",
            name: "Cortes",
            code: "HN-CR",
        },
        {
            country: "HN",
            name: "El Paraiso",
            code: "HN-EP",
        },
        {
            country: "HN",
            name: "Francisco Morazan",
            code: "HN-FM",
        },
        {
            country: "HN",
            name: "Intibuca",
            code: "HN-IN",
        },
        {
            country: "HN",
            name: "Islas de la Bahia",
            code: "HN-IB",
        },
        {
            country: "HN",
            name: "La Paz",
            code: "HN-LP",
        },
        {
            country: "HN",
            name: "Lempira",
            code: "HN-LE",
        },
        {
            country: "HN",
            name: "Ocotepeque",
            code: "HN-OC",
        },
        {
            country: "HN",
            name: "Olancho",
            code: "HN-OL",
        },
        {
            country: "HN",
            name: "Santa Barbara",
            code: "HN-SB",
        },
        {
            country: "HN",
            name: "Valle",
            code: "HN-VA",
        },
        {
            country: "HN",
            name: "Yoro",
            code: "HN-YO",
        },
    ],
    HR: [
        {
            country: "HR",
            name: "Bjelovarsko-bilogorska zupanija",
            code: "HR-07",
        },
        {
            country: "HR",
            name: "Brodsko-posavska zupanija",
            code: "HR-12",
        },
        {
            country: "HR",
            name: "Dubrovacko-neretvanska zupanija",
            code: "HR-19",
        },
        {
            country: "HR",
            name: "Grad Zagreb",
            code: "HR-21",
        },
        {
            country: "HR",
            name: "Istarska zupanija",
            code: "HR-18",
        },
        {
            country: "HR",
            name: "Karlovacka zupanija",
            code: "HR-04",
        },
        {
            country: "HR",
            name: "Koprivnicko-krizevacka zupanija",
            code: "HR-06",
        },
        {
            country: "HR",
            name: "Krapinsko-zagorska zupanija",
            code: "HR-02",
        },
        {
            country: "HR",
            name: "Licko-senjska zupanija",
            code: "HR-09",
        },
        {
            country: "HR",
            name: "Medimurska zupanija",
            code: "HR-20",
        },
        {
            country: "HR",
            name: "Osjecko-baranjska zupanija",
            code: "HR-14",
        },
        {
            country: "HR",
            name: "Pozesko-slavonska zupanija",
            code: "HR-11",
        },
        {
            country: "HR",
            name: "Primorsko-goranska zupanija",
            code: "HR-08",
        },
        {
            country: "HR",
            name: "Sibensko-kninska zupanija",
            code: "HR-15",
        },
        {
            country: "HR",
            name: "Sisacko-moslavacka zupanija",
            code: "HR-03",
        },
        {
            country: "HR",
            name: "Splitsko-dalmatinska zupanija",
            code: "HR-17",
        },
        {
            country: "HR",
            name: "Varazdinska zupanija",
            code: "HR-05",
        },
        {
            country: "HR",
            name: "Viroviticko-podravska zupanija",
            code: "HR-10",
        },
        {
            country: "HR",
            name: "Vukovarsko-srijemska zupanija",
            code: "HR-16",
        },
        {
            country: "HR",
            name: "Zadarska zupanija",
            code: "HR-13",
        },
        {
            country: "HR",
            name: "Zagrebacka zupanija",
            code: "HR-01",
        },
    ],
    HT: [
        {
            country: "HT",
            name: "Artibonite",
            code: "HT-AR",
        },
        {
            country: "HT",
            name: "Centre",
            code: "HT-CE",
        },
        {
            country: "HT",
            name: "Grande'Anse",
            code: "HT-GA",
        },
        {
            country: "HT",
            name: "Nord",
            code: "HT-ND",
        },
        {
            country: "HT",
            name: "Nord-Ouest",
            code: "HT-NO",
        },
        {
            country: "HT",
            name: "Ouest",
            code: "HT-OU",
        },
        {
            country: "HT",
            name: "Sud",
            code: "HT-SD",
        },
        {
            country: "HT",
            name: "Sud-Est",
            code: "HT-SE",
        },
    ],
    HU: [
        {
            country: "HU",
            name: "Bacs-Kiskun",
            code: "HU-BK",
        },
        {
            country: "HU",
            name: "Baranya",
            code: "HU-BA",
        },
        {
            country: "HU",
            name: "Bekes",
            code: "HU-BE",
        },
        {
            country: "HU",
            name: "Borsod-Abauj-Zemplen",
            code: "HU-BZ",
        },
        {
            country: "HU",
            name: "Budapest",
            code: "HU-BU",
        },
        {
            country: "HU",
            name: "Csongrad-Csanad",
            code: "HU-CS",
        },
        {
            country: "HU",
            name: "Fejer",
            code: "HU-FE",
        },
        {
            country: "HU",
            name: "Gyor-Moson-Sopron",
            code: "HU-GS",
        },
        {
            country: "HU",
            name: "Hajdu-Bihar",
            code: "HU-HB",
        },
        {
            country: "HU",
            name: "Heves",
            code: "HU-HE",
        },
        {
            country: "HU",
            name: "Jasz-Nagykun-Szolnok",
            code: "HU-JN",
        },
        {
            country: "HU",
            name: "Komarom-Esztergom",
            code: "HU-KE",
        },
        {
            country: "HU",
            name: "Nograd",
            code: "HU-NO",
        },
        {
            country: "HU",
            name: "Pest",
            code: "HU-PE",
        },
        {
            country: "HU",
            name: "Somogy",
            code: "HU-SO",
        },
        {
            country: "HU",
            name: "Szabolcs-Szatmar-Bereg",
            code: "HU-SZ",
        },
        {
            country: "HU",
            name: "Tolna",
            code: "HU-TO",
        },
        {
            country: "HU",
            name: "Vas",
            code: "HU-VA",
        },
        {
            country: "HU",
            name: "Veszprem",
            code: "HU-VE",
        },
        {
            country: "HU",
            name: "Zala",
            code: "HU-ZA",
        },
    ],
    ID: [
        {
            country: "ID",
            name: "Aceh",
            code: "ID-AC",
        },
        {
            country: "ID",
            name: "Bali",
            code: "ID-BA",
        },
        {
            country: "ID",
            name: "Banten",
            code: "ID-BT",
        },
        {
            country: "ID",
            name: "Bengkulu",
            code: "ID-BE",
        },
        {
            country: "ID",
            name: "Gorontalo",
            code: "ID-GO",
        },
        {
            country: "ID",
            name: "Jakarta Raya",
            code: "ID-JK",
        },
        {
            country: "ID",
            name: "Jambi",
            code: "ID-JA",
        },
        {
            country: "ID",
            name: "Jawa Barat",
            code: "ID-JB",
        },
        {
            country: "ID",
            name: "Jawa Tengah",
            code: "ID-JT",
        },
        {
            country: "ID",
            name: "Jawa Timur",
            code: "ID-JI",
        },
        {
            country: "ID",
            name: "Kalimantan Barat",
            code: "ID-KB",
        },
        {
            country: "ID",
            name: "Kalimantan Selatan",
            code: "ID-KS",
        },
        {
            country: "ID",
            name: "Kalimantan Tengah",
            code: "ID-KT",
        },
        {
            country: "ID",
            name: "Kalimantan Timur",
            code: "ID-KI",
        },
        {
            country: "ID",
            name: "Kalimantan Utara",
            code: "ID-KU",
        },
        {
            country: "ID",
            name: "Kepulauan Bangka Belitung",
            code: "ID-BB",
        },
        {
            country: "ID",
            name: "Kepulauan Riau",
            code: "ID-KR",
        },
        {
            country: "ID",
            name: "Lampung",
            code: "ID-LA",
        },
        {
            country: "ID",
            name: "Maluku",
            code: "ID-ML",
        },
        {
            country: "ID",
            name: "Maluku Utara",
            code: "ID-MU",
        },
        {
            country: "ID",
            name: "Nusa Tenggara Barat",
            code: "ID-NB",
        },
        {
            country: "ID",
            name: "Nusa Tenggara Timur",
            code: "ID-NT",
        },
        {
            country: "ID",
            name: "Papua",
            code: "ID-PP",
        },
        {
            country: "ID",
            name: "Papua Barat",
            code: "ID-PB",
        },
        {
            country: "ID",
            name: "Papua Barat Daya",
            code: "ID-PD",
        },
        {
            country: "ID",
            name: "Papua Pengunungan",
            code: "ID-PE",
        },
        {
            country: "ID",
            name: "Papua Selatan",
            code: "ID-PS",
        },
        {
            country: "ID",
            name: "Papua Tengah",
            code: "ID-PT",
        },
        {
            country: "ID",
            name: "Riau",
            code: "ID-RI",
        },
        {
            country: "ID",
            name: "Sulawesi Barat",
            code: "ID-SR",
        },
        {
            country: "ID",
            name: "Sulawesi Selatan",
            code: "ID-SN",
        },
        {
            country: "ID",
            name: "Sulawesi Tengah",
            code: "ID-ST",
        },
        {
            country: "ID",
            name: "Sulawesi Tenggara",
            code: "ID-SG",
        },
        {
            country: "ID",
            name: "Sulawesi Utara",
            code: "ID-SA",
        },
        {
            country: "ID",
            name: "Sumatera Barat",
            code: "ID-SB",
        },
        {
            country: "ID",
            name: "Sumatera Selatan",
            code: "ID-SS",
        },
        {
            country: "ID",
            name: "Sumatera Utara",
            code: "ID-SU",
        },
        {
            country: "ID",
            name: "Yogyakarta",
            code: "ID-YO",
        },
    ],
    IE: [
        {
            country: "IE",
            name: "Carlow",
            code: "IE-CW",
        },
        {
            country: "IE",
            name: "Cavan",
            code: "IE-CN",
        },
        {
            country: "IE",
            name: "Clare",
            code: "IE-CE",
        },
        {
            country: "IE",
            name: "Cork",
            code: "IE-CO",
        },
        {
            country: "IE",
            name: "Donegal",
            code: "IE-DL",
        },
        {
            country: "IE",
            name: "Dublin",
            code: "IE-D",
        },
        {
            country: "IE",
            name: "Galway",
            code: "IE-G",
        },
        {
            country: "IE",
            name: "Kerry",
            code: "IE-KY",
        },
        {
            country: "IE",
            name: "Kildare",
            code: "IE-KE",
        },
        {
            country: "IE",
            name: "Kilkenny",
            code: "IE-KK",
        },
        {
            country: "IE",
            name: "Laois",
            code: "IE-LS",
        },
        {
            country: "IE",
            name: "Leitrim",
            code: "IE-LM",
        },
        {
            country: "IE",
            name: "Limerick",
            code: "IE-LK",
        },
        {
            country: "IE",
            name: "Longford",
            code: "IE-LD",
        },
        {
            country: "IE",
            name: "Louth",
            code: "IE-LH",
        },
        {
            country: "IE",
            name: "Mayo",
            code: "IE-MO",
        },
        {
            country: "IE",
            name: "Meath",
            code: "IE-MH",
        },
        {
            country: "IE",
            name: "Monaghan",
            code: "IE-MN",
        },
        {
            country: "IE",
            name: "Offaly",
            code: "IE-OY",
        },
        {
            country: "IE",
            name: "Roscommon",
            code: "IE-RN",
        },
        {
            country: "IE",
            name: "Sligo",
            code: "IE-SO",
        },
        {
            country: "IE",
            name: "Tipperary",
            code: "IE-TA",
        },
        {
            country: "IE",
            name: "Waterford",
            code: "IE-WD",
        },
        {
            country: "IE",
            name: "Westmeath",
            code: "IE-WH",
        },
        {
            country: "IE",
            name: "Wexford",
            code: "IE-WX",
        },
        {
            country: "IE",
            name: "Wicklow",
            code: "IE-WW",
        },
    ],
    IL: [
        {
            country: "IL",
            name: "HaDarom",
            code: "IL-D",
        },
        {
            country: "IL",
            name: "HaMerkaz",
            code: "IL-M",
        },
        {
            country: "IL",
            name: "HaTsafon",
            code: "IL-Z",
        },
        {
            country: "IL",
            name: "Hefa",
            code: "IL-HA",
        },
        {
            country: "IL",
            name: "Tel Aviv",
            code: "IL-TA",
        },
        {
            country: "IL",
            name: "Yerushalayim",
            code: "IL-JM",
        },
    ],
    IM: [
        {
            country: "IM",
            name: "Isle of Man",
            code: "-",
        },
    ],
    IN: [
        {
            country: "IN",
            name: "Andaman and Nicobar Islands",
            code: "IN-AN",
        },
        {
            country: "IN",
            name: "Andhra Pradesh",
            code: "IN-AP",
        },
        {
            country: "IN",
            name: "Arunachal Pradesh",
            code: "IN-AR",
        },
        {
            country: "IN",
            name: "Assam",
            code: "IN-AS",
        },
        {
            country: "IN",
            name: "Bihar",
            code: "IN-BR",
        },
        {
            country: "IN",
            name: "Chandigarh",
            code: "IN-CH",
        },
        {
            country: "IN",
            name: "Chhattisgarh",
            code: "IN-CG",
        },
        {
            country: "IN",
            name: "Dadra and Nagar Haveli and Daman and Diu",
            code: "IN-DH",
        },
        {
            country: "IN",
            name: "Delhi",
            code: "IN-DL",
        },
        {
            country: "IN",
            name: "Goa",
            code: "IN-GA",
        },
        {
            country: "IN",
            name: "Gujarat",
            code: "IN-GJ",
        },
        {
            country: "IN",
            name: "Haryana",
            code: "IN-HR",
        },
        {
            country: "IN",
            name: "Himachal Pradesh",
            code: "IN-HP",
        },
        {
            country: "IN",
            name: "Jammu and Kashmir",
            code: "IN-JK",
        },
        {
            country: "IN",
            name: "Jharkhand",
            code: "IN-JH",
        },
        {
            country: "IN",
            name: "Karnataka",
            code: "IN-KA",
        },
        {
            country: "IN",
            name: "Kerala",
            code: "IN-KL",
        },
        {
            country: "IN",
            name: "Lakshadweep",
            code: "IN-LD",
        },
        {
            country: "IN",
            name: "Madhya Pradesh",
            code: "IN-MP",
        },
        {
            country: "IN",
            name: "Maharashtra",
            code: "IN-MH",
        },
        {
            country: "IN",
            name: "Manipur",
            code: "IN-MN",
        },
        {
            country: "IN",
            name: "Meghalaya",
            code: "IN-ML",
        },
        {
            country: "IN",
            name: "Mizoram",
            code: "IN-MZ",
        },
        {
            country: "IN",
            name: "Nagaland",
            code: "IN-NL",
        },
        {
            country: "IN",
            name: "Odisha",
            code: "IN-OD",
        },
        {
            country: "IN",
            name: "Puducherry",
            code: "IN-PY",
        },
        {
            country: "IN",
            name: "Punjab",
            code: "IN-PB",
        },
        {
            country: "IN",
            name: "Rajasthan",
            code: "IN-RJ",
        },
        {
            country: "IN",
            name: "Sikkim",
            code: "IN-SK",
        },
        {
            country: "IN",
            name: "Tamil Nadu",
            code: "IN-TN",
        },
        {
            country: "IN",
            name: "Telangana",
            code: "IN-TS",
        },
        {
            country: "IN",
            name: "Tripura",
            code: "IN-TR",
        },
        {
            country: "IN",
            name: "Uttar Pradesh",
            code: "IN-UP",
        },
        {
            country: "IN",
            name: "Uttarakhand",
            code: "IN-UK",
        },
        {
            country: "IN",
            name: "West Bengal",
            code: "IN-WB",
        },
    ],
    IO: [
        {
            country: "IO",
            name: "British Indian Ocean Territory",
            code: "-",
        },
    ],
    IQ: [
        {
            country: "IQ",
            name: "Al Anbar",
            code: "IQ-AN",
        },
        {
            country: "IQ",
            name: "Al Basrah",
            code: "IQ-BA",
        },
        {
            country: "IQ",
            name: "Al Muthanna",
            code: "IQ-MU",
        },
        {
            country: "IQ",
            name: "Al Qadisiyah",
            code: "IQ-QA",
        },
        {
            country: "IQ",
            name: "An Najaf",
            code: "IQ-NA",
        },
        {
            country: "IQ",
            name: "Arbil",
            code: "IQ-AR",
        },
        {
            country: "IQ",
            name: "As Sulaymaniyah",
            code: "IQ-SU",
        },
        {
            country: "IQ",
            name: "Babil",
            code: "IQ-BB",
        },
        {
            country: "IQ",
            name: "Baghdad",
            code: "IQ-BG",
        },
        {
            country: "IQ",
            name: "Dahuk",
            code: "IQ-DA",
        },
        {
            country: "IQ",
            name: "Dhi Qar",
            code: "IQ-DQ",
        },
        {
            country: "IQ",
            name: "Diyala",
            code: "IQ-DI",
        },
        {
            country: "IQ",
            name: "Karbala'",
            code: "IQ-KA",
        },
        {
            country: "IQ",
            name: "Kirkuk",
            code: "IQ-KI",
        },
        {
            country: "IQ",
            name: "Maysan",
            code: "IQ-MA",
        },
        {
            country: "IQ",
            name: "Ninawa",
            code: "IQ-NI",
        },
        {
            country: "IQ",
            name: "Salah ad Din",
            code: "IQ-SD",
        },
        {
            country: "IQ",
            name: "Wasit",
            code: "IQ-WA",
        },
    ],
    IR: [
        {
            country: "IR",
            name: "Alborz",
            code: "IR-30",
        },
        {
            country: "IR",
            name: "Ardabil",
            code: "IR-24",
        },
        {
            country: "IR",
            name: "Azarbayjan-e Gharbi",
            code: "IR-04",
        },
        {
            country: "IR",
            name: "Azarbayjan-e Sharqi",
            code: "IR-03",
        },
        {
            country: "IR",
            name: "Bushehr",
            code: "IR-18",
        },
        {
            country: "IR",
            name: "Chahar Mahal va Bakhtiari",
            code: "IR-14",
        },
        {
            country: "IR",
            name: "Esfahan",
            code: "IR-10",
        },
        {
            country: "IR",
            name: "Fars",
            code: "IR-07",
        },
        {
            country: "IR",
            name: "Gilan",
            code: "IR-01",
        },
        {
            country: "IR",
            name: "Golestan",
            code: "IR-27",
        },
        {
            country: "IR",
            name: "Hamadan",
            code: "IR-13",
        },
        {
            country: "IR",
            name: "Hormozgan",
            code: "IR-22",
        },
        {
            country: "IR",
            name: "Ilam",
            code: "IR-16",
        },
        {
            country: "IR",
            name: "Kerman",
            code: "IR-08",
        },
        {
            country: "IR",
            name: "Kermanshah",
            code: "IR-05",
        },
        {
            country: "IR",
            name: "Khorasan-e Jonubi",
            code: "IR-29",
        },
        {
            country: "IR",
            name: "Khorasan-e Razavi",
            code: "IR-09",
        },
        {
            country: "IR",
            name: "Khorasan-e Shomali",
            code: "IR-28",
        },
        {
            country: "IR",
            name: "Khuzestan",
            code: "IR-06",
        },
        {
            country: "IR",
            name: "Kohgiluyeh va Bowyer Ahmad",
            code: "IR-17",
        },
        {
            country: "IR",
            name: "Kordestan",
            code: "IR-12",
        },
        {
            country: "IR",
            name: "Lorestan",
            code: "IR-15",
        },
        {
            country: "IR",
            name: "Markazi",
            code: "IR-00",
        },
        {
            country: "IR",
            name: "Mazandaran",
            code: "IR-02",
        },
        {
            country: "IR",
            name: "Qazvin",
            code: "IR-26",
        },
        {
            country: "IR",
            name: "Qom",
            code: "IR-25",
        },
        {
            country: "IR",
            name: "Semnan",
            code: "IR-20",
        },
        {
            country: "IR",
            name: "Sistan va Baluchestan",
            code: "IR-11",
        },
        {
            country: "IR",
            name: "Tehran",
            code: "IR-23",
        },
        {
            country: "IR",
            name: "Yazd",
            code: "IR-21",
        },
        {
            country: "IR",
            name: "Zanjan",
            code: "IR-19",
        },
    ],
    IS: [
        {
            country: "IS",
            name: "Austurland",
            code: "IS-7",
        },
        {
            country: "IS",
            name: "Hofudborgarsvaedi",
            code: "IS-1",
        },
        {
            country: "IS",
            name: "Nordurland eystra",
            code: "IS-6",
        },
        {
            country: "IS",
            name: "Nordurland vestra",
            code: "IS-5",
        },
        {
            country: "IS",
            name: "Sudurland",
            code: "IS-8",
        },
        {
            country: "IS",
            name: "Sudurnes",
            code: "IS-2",
        },
        {
            country: "IS",
            name: "Vestfirdir",
            code: "IS-4",
        },
        {
            country: "IS",
            name: "Vesturland",
            code: "IS-3",
        },
    ],
    IT: [
        {
            country: "IT",
            name: "Abruzzo",
            code: "IT-65",
        },
        {
            country: "IT",
            name: "Basilicata",
            code: "IT-77",
        },
        {
            country: "IT",
            name: "Calabria",
            code: "IT-78",
        },
        {
            country: "IT",
            name: "Campania",
            code: "IT-72",
        },
        {
            country: "IT",
            name: "Emilia-Romagna",
            code: "IT-45",
        },
        {
            country: "IT",
            name: "Friuli-Venezia Giulia",
            code: "IT-36",
        },
        {
            country: "IT",
            name: "Lazio",
            code: "IT-62",
        },
        {
            country: "IT",
            name: "Liguria",
            code: "IT-42",
        },
        {
            country: "IT",
            name: "Lombardia",
            code: "IT-25",
        },
        {
            country: "IT",
            name: "Marche",
            code: "IT-57",
        },
        {
            country: "IT",
            name: "Molise",
            code: "IT-67",
        },
        {
            country: "IT",
            name: "Piemonte",
            code: "IT-21",
        },
        {
            country: "IT",
            name: "Puglia",
            code: "IT-75",
        },
        {
            country: "IT",
            name: "Sardegna",
            code: "IT-88",
        },
        {
            country: "IT",
            name: "Sicilia",
            code: "IT-82",
        },
        {
            country: "IT",
            name: "Toscana",
            code: "IT-52",
        },
        {
            country: "IT",
            name: "Trentino-Alto Adige",
            code: "IT-32",
        },
        {
            country: "IT",
            name: "Umbria",
            code: "IT-55",
        },
        {
            country: "IT",
            name: "Valle d'Aosta",
            code: "IT-23",
        },
        {
            country: "IT",
            name: "Veneto",
            code: "IT-34",
        },
    ],
    JE: [
        {
            country: "JE",
            name: "Jersey",
            code: "-",
        },
    ],
    JM: [
        {
            country: "JM",
            name: "Clarendon",
            code: "JM-13",
        },
        {
            country: "JM",
            name: "Hanover",
            code: "JM-09",
        },
        {
            country: "JM",
            name: "Kingston",
            code: "JM-01",
        },
        {
            country: "JM",
            name: "Manchester",
            code: "JM-12",
        },
        {
            country: "JM",
            name: "Portland",
            code: "JM-04",
        },
        {
            country: "JM",
            name: "Saint Andrew",
            code: "JM-02",
        },
        {
            country: "JM",
            name: "Saint Ann",
            code: "JM-06",
        },
        {
            country: "JM",
            name: "Saint Catherine",
            code: "JM-14",
        },
        {
            country: "JM",
            name: "Saint Elizabeth",
            code: "JM-11",
        },
        {
            country: "JM",
            name: "Saint James",
            code: "JM-08",
        },
        {
            country: "JM",
            name: "Saint Mary",
            code: "JM-05",
        },
        {
            country: "JM",
            name: "Saint Thomas",
            code: "JM-03",
        },
        {
            country: "JM",
            name: "Trelawny",
            code: "JM-07",
        },
        {
            country: "JM",
            name: "Westmoreland",
            code: "JM-10",
        },
    ],
    JO: [
        {
            country: "JO",
            name: "'Ajlun",
            code: "JO-AJ",
        },
        {
            country: "JO",
            name: "Al 'Aqabah",
            code: "JO-AQ",
        },
        {
            country: "JO",
            name: "Al 'Asimah",
            code: "JO-AM",
        },
        {
            country: "JO",
            name: "Al Balqa'",
            code: "JO-BA",
        },
        {
            country: "JO",
            name: "Al Karak",
            code: "JO-KA",
        },
        {
            country: "JO",
            name: "Al Mafraq",
            code: "JO-MA",
        },
        {
            country: "JO",
            name: "At Tafilah",
            code: "JO-AT",
        },
        {
            country: "JO",
            name: "Az Zarqa'",
            code: "JO-AZ",
        },
        {
            country: "JO",
            name: "Irbid",
            code: "JO-IR",
        },
        {
            country: "JO",
            name: "Jarash",
            code: "JO-JA",
        },
        {
            country: "JO",
            name: "Ma'an",
            code: "JO-MN",
        },
        {
            country: "JO",
            name: "Madaba",
            code: "JO-MD",
        },
    ],
    JP: [
        { country: "JP", name: "Hokkaido", code: "JP-01", label: "北海道" },
        { country: "JP", name: "Aomori", code: "JP-02", label: "青森" },
        { country: "JP", name: "Iwate", code: "JP-03", label: "岩手" },
        { country: "JP", name: "Miyagi", code: "JP-04", label: "宮城" },
        { country: "JP", name: "Akita", code: "JP-05", label: "秋田" },
        { country: "JP", name: "Yamagata", code: "JP-06", label: "山形" },
        { country: "JP", name: "Fukushima", code: "JP-07", label: "福島" },
        { country: "JP", name: "Gunma", code: "JP-10", label: "群馬" },
        { country: "JP", name: "Tochigi", code: "JP-09", label: "栃木" },
        { country: "JP", name: "Ibaraki", code: "JP-08", label: "茨城" },
        { country: "JP", name: "Saitama", code: "JP-11", label: "埼玉" },
        { country: "JP", name: "Chiba", code: "JP-12", label: "千葉" },
        { country: "JP", name: "Tokyo", code: "JP-13", label: "東京" },
        { country: "JP", name: "Kanagawa", code: "JP-14", label: "神奈川" },
        { country: "JP", name: "Niigata", code: "JP-15", label: "新潟" },
        { country: "JP", name: "Toyama", code: "JP-16", label: "富山" },
        { country: "JP", name: "Ishikawa", code: "JP-17", label: "石川" },
        { country: "JP", name: "Fukui", code: "JP-18", label: "福井" },
        { country: "JP", name: "Yamanashi", code: "JP-19", label: "山梨" },
        { country: "JP", name: "Nagano", code: "JP-20", label: "長野" },
        { country: "JP", name: "Gifu", code: "JP-21", label: "岐阜" },
        { country: "JP", name: "Shizuoka", code: "JP-22", label: "静岡" },
        { country: "JP", name: "Aichi", code: "JP-23", label: "愛知" },
        { country: "JP", name: "Mie", code: "JP-24", label: "三重" },
        { country: "JP", name: "Shiga", code: "JP-25", label: "滋賀" },
        { country: "JP", name: "Kyoto", code: "JP-26", label: "京都" },
        { country: "JP", name: "Osaka", code: "JP-27", label: "大阪" },
        { country: "JP", name: "Hyogo", code: "JP-28", label: "兵庫" },
        { country: "JP", name: "Nara", code: "JP-29", label: "奈良" },
        { country: "JP", name: "Wakayama", code: "JP-30", label: "和歌山" },
        { country: "JP", name: "Tottori", code: "JP-31", label: "鳥取" },
        { country: "JP", name: "Shimane", code: "JP-32", label: "島根" },
        { country: "JP", name: "Okayama", code: "JP-33", label: "岡山" },
        { country: "JP", name: "Hiroshima", code: "JP-34", label: "広島" },
        { country: "JP", name: "Yamaguchi", code: "JP-35", label: "山口" },
        { country: "JP", name: "Tokushima", code: "JP-36", label: "徳島" },
        { country: "JP", name: "Kagawa", code: "JP-37", label: "香川" },
        { country: "JP", name: "Ehime", code: "JP-38", label: "愛媛" },
        { country: "JP", name: "Kochi", code: "JP-39", label: "高知" },
        { country: "JP", name: "Fukuoka", code: "JP-40", label: "福岡" },
        { country: "JP", name: "Saga", code: "JP-41", label: "佐賀" },
        { country: "JP", name: "Nagasaki", code: "JP-42", label: "長崎" },
        { country: "JP", name: "Kumamoto", code: "JP-43", label: "熊本" },
        { country: "JP", name: "Oita", code: "JP-44", label: "大分" },
        { country: "JP", name: "Miyazaki", code: "JP-45", label: "宮崎" },
        { country: "JP", name: "Kagoshima", code: "JP-46", label: "鹿児島" },
        { country: "JP", name: "Okinawa", code: "JP-47", label: "沖縄" },
    ],
    KE: [
        {
            country: "KE",
            name: "Baringo",
            code: "KE-01",
        },
        {
            country: "KE",
            name: "Bomet",
            code: "KE-02",
        },
        {
            country: "KE",
            name: "Bungoma",
            code: "KE-03",
        },
        {
            country: "KE",
            name: "Busia",
            code: "KE-04",
        },
        {
            country: "KE",
            name: "Elgeyo/Marakwet",
            code: "KE-05",
        },
        {
            country: "KE",
            name: "Embu",
            code: "KE-06",
        },
        {
            country: "KE",
            name: "Garissa",
            code: "KE-07",
        },
        {
            country: "KE",
            name: "Homa Bay",
            code: "KE-08",
        },
        {
            country: "KE",
            name: "Isiolo",
            code: "KE-09",
        },
        {
            country: "KE",
            name: "Kajiado",
            code: "KE-10",
        },
        {
            country: "KE",
            name: "Kakamega",
            code: "KE-11",
        },
        {
            country: "KE",
            name: "Kericho",
            code: "KE-12",
        },
        {
            country: "KE",
            name: "Kiambu",
            code: "KE-13",
        },
        {
            country: "KE",
            name: "Kilifi",
            code: "KE-14",
        },
        {
            country: "KE",
            name: "Kirinyaga",
            code: "KE-15",
        },
        {
            country: "KE",
            name: "Kisii",
            code: "KE-16",
        },
        {
            country: "KE",
            name: "Kisumu",
            code: "KE-17",
        },
        {
            country: "KE",
            name: "Kitui",
            code: "KE-18",
        },
        {
            country: "KE",
            name: "Kwale",
            code: "KE-19",
        },
        {
            country: "KE",
            name: "Laikipia",
            code: "KE-20",
        },
        {
            country: "KE",
            name: "Lamu",
            code: "KE-21",
        },
        {
            country: "KE",
            name: "Machakos",
            code: "KE-22",
        },
        {
            country: "KE",
            name: "Makueni",
            code: "KE-23",
        },
        {
            country: "KE",
            name: "Mandera",
            code: "KE-24",
        },
        {
            country: "KE",
            name: "Marsabit",
            code: "KE-25",
        },
        {
            country: "KE",
            name: "Meru",
            code: "KE-26",
        },
        {
            country: "KE",
            name: "Migori",
            code: "KE-27",
        },
        {
            country: "KE",
            name: "Mombasa",
            code: "KE-28",
        },
        {
            country: "KE",
            name: "Murang'a",
            code: "KE-29",
        },
        {
            country: "KE",
            name: "Nairobi City",
            code: "KE-30",
        },
        {
            country: "KE",
            name: "Nakuru",
            code: "KE-31",
        },
        {
            country: "KE",
            name: "Nandi",
            code: "KE-32",
        },
        {
            country: "KE",
            name: "Narok",
            code: "KE-33",
        },
        {
            country: "KE",
            name: "Nyamira",
            code: "KE-34",
        },
        {
            country: "KE",
            name: "Nyandarua",
            code: "KE-35",
        },
        {
            country: "KE",
            name: "Nyeri",
            code: "KE-36",
        },
        {
            country: "KE",
            name: "Samburu",
            code: "KE-37",
        },
        {
            country: "KE",
            name: "Siaya",
            code: "KE-38",
        },
        {
            country: "KE",
            name: "Taita/Taveta",
            code: "KE-39",
        },
        {
            country: "KE",
            name: "Tana River",
            code: "KE-40",
        },
        {
            country: "KE",
            name: "Tharaka-Nithi",
            code: "KE-41",
        },
        {
            country: "KE",
            name: "Trans Nzoia",
            code: "KE-42",
        },
        {
            country: "KE",
            name: "Turkana",
            code: "KE-43",
        },
        {
            country: "KE",
            name: "Uasin Gishu",
            code: "KE-44",
        },
        {
            country: "KE",
            name: "Vihiga",
            code: "KE-45",
        },
        {
            country: "KE",
            name: "Wajir",
            code: "KE-46",
        },
        {
            country: "KE",
            name: "West Pokot",
            code: "KE-47",
        },
    ],
    KG: [
        {
            country: "KG",
            name: "Batken",
            code: "KG-B",
        },
        {
            country: "KG",
            name: "Bishkek Shaary",
            code: "KG-GB",
        },
        {
            country: "KG",
            name: "Chuy",
            code: "KG-C",
        },
        {
            country: "KG",
            name: "Jalal-Abad",
            code: "KG-J",
        },
        {
            country: "KG",
            name: "Naryn",
            code: "KG-N",
        },
        {
            country: "KG",
            name: "Osh Shaary",
            code: "KG-GO",
        },
        {
            country: "KG",
            name: "Talas",
            code: "KG-T",
        },
        {
            country: "KG",
            name: "Ysyk-Kol",
            code: "KG-Y",
        },
    ],
    KH: [
        {
            country: "KH",
            name: "Baat Dambang",
            code: "KH-2",
        },
        {
            country: "KH",
            name: "Banteay Mean Choay",
            code: "KH-1",
        },
        {
            country: "KH",
            name: "Kaeb",
            code: "KH-23",
        },
        {
            country: "KH",
            name: "Kampong Chaam",
            code: "KH-3",
        },
        {
            country: "KH",
            name: "Kampong Chhnang",
            code: "KH-4",
        },
        {
            country: "KH",
            name: "Kampong Spueu",
            code: "KH-5",
        },
        {
            country: "KH",
            name: "Kampong Thum",
            code: "KH-6",
        },
        {
            country: "KH",
            name: "Kampot",
            code: "KH-7",
        },
        {
            country: "KH",
            name: "Kandaal",
            code: "KH-8",
        },
        {
            country: "KH",
            name: "Kaoh Kong",
            code: "KH-9",
        },
        {
            country: "KH",
            name: "Kracheh",
            code: "KH-10",
        },
        {
            country: "KH",
            name: "Mondol Kiri",
            code: "KH-11",
        },
        {
            country: "KH",
            name: "Otdar Mean Chey",
            code: "KH-22",
        },
        {
            country: "KH",
            name: "Pailin",
            code: "KH-24",
        },
        {
            country: "KH",
            name: "Phnom Penh",
            code: "KH-12",
        },
        {
            country: "KH",
            name: "Preah Sihanouk",
            code: "KH-18",
        },
        {
            country: "KH",
            name: "Preah Vihear",
            code: "KH-13",
        },
        {
            country: "KH",
            name: "Prey Veaeng",
            code: "KH-14",
        },
        {
            country: "KH",
            name: "Rotanak Kiri",
            code: "KH-16",
        },
        {
            country: "KH",
            name: "Siem Reab",
            code: "KH-17",
        },
        {
            country: "KH",
            name: "Stueng Traeng",
            code: "KH-19",
        },
        {
            country: "KH",
            name: "Svaay Rieng",
            code: "KH-20",
        },
        {
            country: "KH",
            name: "Taakaev",
            code: "KH-21",
        },
    ],
    KI: [
        {
            country: "KI",
            name: "Gilbert Islands",
            code: "KI-G",
        },
        {
            country: "KI",
            name: "Line Islands",
            code: "KI-L",
        },
    ],
    KM: [
        {
            country: "KM",
            name: "Grande Comore",
            code: "KM-G",
        },
        {
            country: "KM",
            name: "Moheli",
            code: "KM-M",
        },
    ],
    KN: [
        {
            country: "KN",
            name: "Christ Church Nichola Town",
            code: "KN-01",
        },
        {
            country: "KN",
            name: "Saint Anne Sandy Point",
            code: "KN-02",
        },
        {
            country: "KN",
            name: "Saint George Basseterre",
            code: "KN-03",
        },
        {
            country: "KN",
            name: "Saint James Windward",
            code: "KN-05",
        },
        {
            country: "KN",
            name: "Saint John Capisterre",
            code: "KN-06",
        },
        {
            country: "KN",
            name: "Saint John Figtree",
            code: "KN-07",
        },
        {
            country: "KN",
            name: "Saint Mary Cayon",
            code: "KN-08",
        },
        {
            country: "KN",
            name: "Saint Paul Capisterre",
            code: "KN-09",
        },
        {
            country: "KN",
            name: "Saint Paul Charlestown",
            code: "KN-10",
        },
        {
            country: "KN",
            name: "Saint Peter Basseterre",
            code: "KN-11",
        },
        {
            country: "KN",
            name: "Saint Thomas Lowland",
            code: "KN-12",
        },
        {
            country: "KN",
            name: "Saint Thomas Middle Island",
            code: "KN-13",
        },
        {
            country: "KN",
            name: "Trinity Palmetto Point",
            code: "KN-15",
        },
    ],
    KP: [
        {
            country: "KP",
            name: "P'yongyang",
            code: "KP-01",
        },
    ],
    KR: [
        {
            country: "KR",
            name: "Busan-gwangyeoksi",
            code: "KR-26",
        },
        {
            country: "KR",
            name: "Chungcheongbuk-do",
            code: "KR-43",
        },
        {
            country: "KR",
            name: "Chungcheongnam-do",
            code: "KR-44",
        },
        {
            country: "KR",
            name: "Daegu-gwangyeoksi",
            code: "KR-27",
        },
        {
            country: "KR",
            name: "Daejeon-gwangyeoksi",
            code: "KR-30",
        },
        {
            country: "KR",
            name: "Gangwon-teukbyeoljachido",
            code: "KR-42",
        },
        {
            country: "KR",
            name: "Gwangju-gwangyeoksi",
            code: "KR-29",
        },
        {
            country: "KR",
            name: "Gyeonggi-do",
            code: "KR-41",
        },
        {
            country: "KR",
            name: "Gyeongsangbuk-do",
            code: "KR-47",
        },
        {
            country: "KR",
            name: "Gyeongsangnam-do",
            code: "KR-48",
        },
        {
            country: "KR",
            name: "Incheon-gwangyeoksi",
            code: "KR-28",
        },
        {
            country: "KR",
            name: "Jeju-teukbyeoljachido",
            code: "KR-49",
        },
        {
            country: "KR",
            name: "Jeollabuk-do",
            code: "KR-45",
        },
        {
            country: "KR",
            name: "Jeollanam-do",
            code: "KR-46",
        },
        {
            country: "KR",
            name: "Sejong",
            code: "KR-50",
        },
        {
            country: "KR",
            name: "Seoul-teukbyeolsi",
            code: "KR-11",
        },
        {
            country: "KR",
            name: "Ulsan-gwangyeoksi",
            code: "KR-31",
        },
    ],
    KW: [
        {
            country: "KW",
            name: "Al 'Asimah",
            code: "KW-KU",
        },
        {
            country: "KW",
            name: "Al Ahmadi",
            code: "KW-AH",
        },
        {
            country: "KW",
            name: "Al Farwaniyah",
            code: "KW-FA",
        },
        {
            country: "KW",
            name: "Al Jahra'",
            code: "KW-JA",
        },
        {
            country: "KW",
            name: "Hawalli",
            code: "KW-HA",
        },
        {
            country: "KW",
            name: "Mubarak al Kabir",
            code: "KW-MU",
        },
    ],
    KY: [
        {
            country: "KY",
            name: "Cayman Islands",
            code: "-",
        },
    ],
    KZ: [
        {
            country: "KZ",
            name: "Abay oblysy",
            code: "KZ-10",
        },
        {
            country: "KZ",
            name: "Almaty",
            code: "KZ-75",
        },
        {
            country: "KZ",
            name: "Almaty oblysy",
            code: "KZ-19",
        },
        {
            country: "KZ",
            name: "Aqmola oblysy",
            code: "KZ-11",
        },
        {
            country: "KZ",
            name: "Aqtobe oblysy",
            code: "KZ-15",
        },
        {
            country: "KZ",
            name: "Astana",
            code: "KZ-71",
        },
        {
            country: "KZ",
            name: "Atyrau oblysy",
            code: "KZ-23",
        },
        {
            country: "KZ",
            name: "Batys Qazaqstan oblysy",
            code: "KZ-27",
        },
        {
            country: "KZ",
            name: "Mangghystau oblysy",
            code: "KZ-47",
        },
        {
            country: "KZ",
            name: "Pavlodar oblysy",
            code: "KZ-55",
        },
        {
            country: "KZ",
            name: "Qaraghandy oblysy",
            code: "KZ-35",
        },
        {
            country: "KZ",
            name: "Qostanay oblysy",
            code: "KZ-39",
        },
        {
            country: "KZ",
            name: "Qyzylorda oblysy",
            code: "KZ-43",
        },
        {
            country: "KZ",
            name: "Shyghys Qazaqstan oblysy",
            code: "KZ-63",
        },
        {
            country: "KZ",
            name: "Shymkent",
            code: "KZ-79",
        },
        {
            country: "KZ",
            name: "Soltustik Qazaqstan oblysy",
            code: "KZ-59",
        },
        {
            country: "KZ",
            name: "Turkistan oblysy",
            code: "KZ-61",
        },
        {
            country: "KZ",
            name: "Ulytau oblysy",
            code: "KZ-62",
        },
        {
            country: "KZ",
            name: "Zhambyl oblysy",
            code: "KZ-31",
        },
        {
            country: "KZ",
            name: "Zhetisu oblysy",
            code: "KZ-33",
        },
    ],
    LA: [
        {
            country: "LA",
            name: "Attapu",
            code: "LA-AT",
        },
        {
            country: "LA",
            name: "Bokeo",
            code: "LA-BK",
        },
        {
            country: "LA",
            name: "Champasak",
            code: "LA-CH",
        },
        {
            country: "LA",
            name: "Houaphan",
            code: "LA-HO",
        },
        {
            country: "LA",
            name: "Khammouan",
            code: "LA-KH",
        },
        {
            country: "LA",
            name: "Louang Namtha",
            code: "LA-LM",
        },
        {
            country: "LA",
            name: "Louangphabang",
            code: "LA-LP",
        },
        {
            country: "LA",
            name: "Oudomxai",
            code: "LA-OU",
        },
        {
            country: "LA",
            name: "Phongsali",
            code: "LA-PH",
        },
        {
            country: "LA",
            name: "Savannakhet",
            code: "LA-SV",
        },
        {
            country: "LA",
            name: "Viangchan",
            code: "LA-VI",
        },
        {
            country: "LA",
            name: "Xaignabouli",
            code: "LA-XA",
        },
        {
            country: "LA",
            name: "Xekong",
            code: "LA-XE",
        },
        {
            country: "LA",
            name: "Xiangkhouang",
            code: "LA-XI",
        },
    ],
    LB: [
        {
            country: "LB",
            name: "Aakkar",
            code: "LB-AK",
        },
        {
            country: "LB",
            name: "Baalbek-Hermel",
            code: "LB-BH",
        },
        {
            country: "LB",
            name: "Beqaa",
            code: "LB-BI",
        },
        {
            country: "LB",
            name: "Beyrouth",
            code: "LB-BA",
        },
        {
            country: "LB",
            name: "Liban-Nord",
            code: "LB-AS",
        },
        {
            country: "LB",
            name: "Liban-Sud",
            code: "LB-JA",
        },
        {
            country: "LB",
            name: "Mont-Liban",
            code: "LB-JL",
        },
        {
            country: "LB",
            name: "Nabatiye",
            code: "LB-NA",
        },
    ],
    LC: [
        {
            country: "LC",
            name: "Anse la Raye",
            code: "LC-01",
        },
        {
            country: "LC",
            name: "Castries",
            code: "LC-02",
        },
        {
            country: "LC",
            name: "Choiseul",
            code: "LC-03",
        },
        {
            country: "LC",
            name: "Dennery",
            code: "LC-05",
        },
        {
            country: "LC",
            name: "Gros Islet",
            code: "LC-06",
        },
        {
            country: "LC",
            name: "Laborie",
            code: "LC-07",
        },
        {
            country: "LC",
            name: "Micoud",
            code: "LC-08",
        },
        {
            country: "LC",
            name: "Soufriere",
            code: "LC-10",
        },
        {
            country: "LC",
            name: "Vieux Fort",
            code: "LC-11",
        },
    ],
    LI: [
        {
            country: "LI",
            name: "Balzers",
            code: "LI-01",
        },
        {
            country: "LI",
            name: "Eschen",
            code: "LI-02",
        },
        {
            country: "LI",
            name: "Gamprin",
            code: "LI-03",
        },
        {
            country: "LI",
            name: "Mauren",
            code: "LI-04",
        },
        {
            country: "LI",
            name: "Ruggell",
            code: "LI-06",
        },
        {
            country: "LI",
            name: "Schaan",
            code: "LI-07",
        },
        {
            country: "LI",
            name: "Triesen",
            code: "LI-09",
        },
        {
            country: "LI",
            name: "Triesenberg",
            code: "LI-10",
        },
        {
            country: "LI",
            name: "Vaduz",
            code: "LI-11",
        },
    ],
    LK: [
        {
            country: "LK",
            name: "Central Province",
            code: "LK-2",
        },
        {
            country: "LK",
            name: "Eastern Province",
            code: "LK-5",
        },
        {
            country: "LK",
            name: "North Central Province",
            code: "LK-7",
        },
        {
            country: "LK",
            name: "North Western Province",
            code: "LK-6",
        },
        {
            country: "LK",
            name: "Northern Province",
            code: "LK-4",
        },
        {
            country: "LK",
            name: "Sabaragamuwa Province",
            code: "LK-9",
        },
        {
            country: "LK",
            name: "Southern Province",
            code: "LK-3",
        },
        {
            country: "LK",
            name: "Uva Province",
            code: "LK-8",
        },
        {
            country: "LK",
            name: "Western Province",
            code: "LK-1",
        },
    ],
    LR: [
        {
            country: "LR",
            name: "Bomi",
            code: "LR-BM",
        },
        {
            country: "LR",
            name: "Bong",
            code: "LR-BG",
        },
        {
            country: "LR",
            name: "Grand Cape Mount",
            code: "LR-CM",
        },
        {
            country: "LR",
            name: "Grand Gedeh",
            code: "LR-GG",
        },
        {
            country: "LR",
            name: "Margibi",
            code: "LR-MG",
        },
        {
            country: "LR",
            name: "Montserrado",
            code: "LR-MO",
        },
        {
            country: "LR",
            name: "Nimba",
            code: "LR-NI",
        },
        {
            country: "LR",
            name: "River Cess",
            code: "LR-RI",
        },
        {
            country: "LR",
            name: "River Gee",
            code: "LR-RG",
        },
        {
            country: "LR",
            name: "Sinoe",
            code: "LR-SI",
        },
    ],
    LS: [
        {
            country: "LS",
            name: "Berea",
            code: "LS-D",
        },
        {
            country: "LS",
            name: "Botha-Bothe",
            code: "LS-B",
        },
        {
            country: "LS",
            name: "Leribe",
            code: "LS-C",
        },
        {
            country: "LS",
            name: "Mafeteng",
            code: "LS-E",
        },
        {
            country: "LS",
            name: "Maseru",
            code: "LS-A",
        },
        {
            country: "LS",
            name: "Mohale's Hoek",
            code: "LS-F",
        },
        {
            country: "LS",
            name: "Mokhotlong",
            code: "LS-J",
        },
        {
            country: "LS",
            name: "Qacha's Nek",
            code: "LS-H",
        },
        {
            country: "LS",
            name: "Quthing",
            code: "LS-G",
        },
        {
            country: "LS",
            name: "Thaba-Tseka",
            code: "LS-K",
        },
    ],
    LT: [
        {
            country: "LT",
            name: "Alytaus apskritis",
            code: "LT-AL",
        },
        {
            country: "LT",
            name: "Kauno apskritis",
            code: "LT-KU",
        },
        {
            country: "LT",
            name: "Klaipedos apskritis",
            code: "LT-KL",
        },
        {
            country: "LT",
            name: "Marijampoles apskritis",
            code: "LT-MR",
        },
        {
            country: "LT",
            name: "Panevezio apskritis",
            code: "LT-PN",
        },
        {
            country: "LT",
            name: "Siauliu apskritis",
            code: "LT-SA",
        },
        {
            country: "LT",
            name: "Taurages apskritis",
            code: "LT-TA",
        },
        {
            country: "LT",
            name: "Telsiu apskritis",
            code: "LT-TE",
        },
        {
            country: "LT",
            name: "Utenos apskritis",
            code: "LT-UT",
        },
        {
            country: "LT",
            name: "Vilniaus apskritis",
            code: "LT-VL",
        },
    ],
    LU: [
        {
            country: "LU",
            name: "Capellen",
            code: "LU-CA",
        },
        {
            country: "LU",
            name: "Clervaux",
            code: "LU-CL",
        },
        {
            country: "LU",
            name: "Diekirch",
            code: "LU-DI",
        },
        {
            country: "LU",
            name: "Echternach",
            code: "LU-EC",
        },
        {
            country: "LU",
            name: "Esch-sur-Alzette",
            code: "LU-ES",
        },
        {
            country: "LU",
            name: "Grevenmacher",
            code: "LU-GR",
        },
        {
            country: "LU",
            name: "Luxembourg",
            code: "LU-LU",
        },
        {
            country: "LU",
            name: "Mersch",
            code: "LU-ME",
        },
        {
            country: "LU",
            name: "Redange",
            code: "LU-RD",
        },
        {
            country: "LU",
            name: "Remich",
            code: "LU-RM",
        },
        {
            country: "LU",
            name: "Vianden",
            code: "LU-VD",
        },
        {
            country: "LU",
            name: "Wiltz",
            code: "LU-WI",
        },
    ],
    LV: [
        {
            country: "LV",
            name: "Adazu novads",
            code: "LV-011",
        },
        {
            country: "LV",
            name: "Aizkraukles novads",
            code: "LV-002",
        },
        {
            country: "LV",
            name: "Aluksnes novads",
            code: "LV-007",
        },
        {
            country: "LV",
            name: "Balvu novads",
            code: "LV-015",
        },
        {
            country: "LV",
            name: "Bauskas novads",
            code: "LV-016",
        },
        {
            country: "LV",
            name: "Cesu novads",
            code: "LV-022",
        },
        {
            country: "LV",
            name: "Daugavpils",
            code: "LV-DGV",
        },
        {
            country: "LV",
            name: "Dienvidkurzemes novads",
            code: "LV-112",
        },
        {
            country: "LV",
            name: "Dobeles novads",
            code: "LV-026",
        },
        {
            country: "LV",
            name: "Gulbenes novads",
            code: "LV-033",
        },
        {
            country: "LV",
            name: "Jekabpils novads",
            code: "LV-042",
        },
        {
            country: "LV",
            name: "Jelgava",
            code: "LV-JEL",
        },
        {
            country: "LV",
            name: "Jelgavas novads",
            code: "LV-041",
        },
        {
            country: "LV",
            name: "Jurmala",
            code: "LV-JUR",
        },
        {
            country: "LV",
            name: "Kekavas novads",
            code: "LV-052",
        },
        {
            country: "LV",
            name: "Kraslavas novads",
            code: "LV-047",
        },
        {
            country: "LV",
            name: "Kuldigas novads",
            code: "LV-050",
        },
        {
            country: "LV",
            name: "Liepaja",
            code: "LV-LPX",
        },
        {
            country: "LV",
            name: "Limbazu novads",
            code: "LV-054",
        },
        {
            country: "LV",
            name: "Livanu novads",
            code: "LV-056",
        },
        {
            country: "LV",
            name: "Ludzas novads",
            code: "LV-058",
        },
        {
            country: "LV",
            name: "Madonas novads",
            code: "LV-059",
        },
        {
            country: "LV",
            name: "Marupes novads",
            code: "LV-062",
        },
        {
            country: "LV",
            name: "Ogres novads",
            code: "LV-067",
        },
        {
            country: "LV",
            name: "Olaines novads",
            code: "LV-068",
        },
        {
            country: "LV",
            name: "Preilu novads",
            code: "LV-073",
        },
        {
            country: "LV",
            name: "Rezeknes novads",
            code: "LV-077",
        },
        {
            country: "LV",
            name: "Riga",
            code: "LV-RIX",
        },
        {
            country: "LV",
            name: "Ropazu novads",
            code: "LV-080",
        },
        {
            country: "LV",
            name: "Salaspils novads",
            code: "LV-087",
        },
        {
            country: "LV",
            name: "Saldus novads",
            code: "LV-088",
        },
        {
            country: "LV",
            name: "Saulkrastu novads",
            code: "LV-089",
        },
        {
            country: "LV",
            name: "Siguldas novads",
            code: "LV-091",
        },
        {
            country: "LV",
            name: "Smiltenes novads",
            code: "LV-094",
        },
        {
            country: "LV",
            name: "Talsu novads",
            code: "LV-097",
        },
        {
            country: "LV",
            name: "Tukuma novads",
            code: "LV-099",
        },
        {
            country: "LV",
            name: "Valkas novads",
            code: "LV-101",
        },
        {
            country: "LV",
            name: "Valmieras novads",
            code: "LV-113",
        },
        {
            country: "LV",
            name: "Varaklanu novads",
            code: "LV-102",
        },
        {
            country: "LV",
            name: "Ventspils novads",
            code: "LV-106",
        },
    ],
    LY: [
        {
            country: "LY",
            name: "Al Butnan",
            code: "LY-BU",
        },
        {
            country: "LY",
            name: "Al Jabal al Akhdar",
            code: "LY-JA",
        },
        {
            country: "LY",
            name: "Al Jabal al Gharbi",
            code: "LY-JG",
        },
        {
            country: "LY",
            name: "Al Jafarah",
            code: "LY-JI",
        },
        {
            country: "LY",
            name: "Al Jufrah",
            code: "LY-JU",
        },
        {
            country: "LY",
            name: "Al Kufrah",
            code: "LY-KF",
        },
        {
            country: "LY",
            name: "Al Marj",
            code: "LY-MJ",
        },
        {
            country: "LY",
            name: "Al Marqab",
            code: "LY-MB",
        },
        {
            country: "LY",
            name: "Al Wahat",
            code: "LY-WA",
        },
        {
            country: "LY",
            name: "An Nuqat al Khams",
            code: "LY-NQ",
        },
        {
            country: "LY",
            name: "Az Zawiyah",
            code: "LY-ZA",
        },
        {
            country: "LY",
            name: "Banghazi",
            code: "LY-BA",
        },
        {
            country: "LY",
            name: "Darnah",
            code: "LY-DR",
        },
        {
            country: "LY",
            name: "Misratah",
            code: "LY-MI",
        },
        {
            country: "LY",
            name: "Murzuq",
            code: "LY-MQ",
        },
        {
            country: "LY",
            name: "Nalut",
            code: "LY-NL",
        },
        {
            country: "LY",
            name: "Sabha",
            code: "LY-SB",
        },
        {
            country: "LY",
            name: "Surt",
            code: "LY-SR",
        },
        {
            country: "LY",
            name: "Tarabulus",
            code: "LY-TB",
        },
        {
            country: "LY",
            name: "Wadi al Hayat",
            code: "LY-WD",
        },
        {
            country: "LY",
            name: "Wadi ash Shati'",
            code: "LY-WS",
        },
    ],
    MA: [
        {
            country: "MA",
            name: "Beni-Mellal-Khenifra",
            code: "MA-05",
        },
        {
            country: "MA",
            name: "Casablanca-Settat",
            code: "MA-06",
        },
        {
            country: "MA",
            name: "Draa-Tafilalet",
            code: "MA-08",
        },
        {
            country: "MA",
            name: "Fes- Meknes",
            code: "MA-03",
        },
        {
            country: "MA",
            name: "Guelmim-Oued Noun (EH-partial)",
            code: "MA-10",
        },
        {
            country: "MA",
            name: "L'Oriental",
            code: "MA-02",
        },
        {
            country: "MA",
            name: "Laayoune-Sakia El Hamra (EH-partial)",
            code: "MA-11",
        },
        {
            country: "MA",
            name: "Marrakech-Safi",
            code: "MA-07",
        },
        {
            country: "MA",
            name: "Rabat-Sale-Kenitra",
            code: "MA-04",
        },
        {
            country: "MA",
            name: "Souss-Massa",
            code: "MA-09",
        },
        {
            country: "MA",
            name: "Tanger-Tetouan-Al Hoceima",
            code: "MA-01",
        },
    ],
    MC: [
        {
            country: "MC",
            name: "Fontvieille",
            code: "MC-FO",
        },
        {
            country: "MC",
            name: "La Condamine",
            code: "MC-CO",
        },
        {
            country: "MC",
            name: "Monaco-Ville",
            code: "MC-MO",
        },
        {
            country: "MC",
            name: "Moneghetti",
            code: "MC-MG",
        },
        {
            country: "MC",
            name: "Monte-Carlo",
            code: "MC-MC",
        },
        {
            country: "MC",
            name: "Saint-Roman",
            code: "MC-SR",
        },
    ],
    MD: [
        {
            country: "MD",
            name: "Anenii Noi",
            code: "MD-AN",
        },
        {
            country: "MD",
            name: "Balti",
            code: "MD-BA",
        },
        {
            country: "MD",
            name: "Basarabeasca",
            code: "MD-BS",
        },
        {
            country: "MD",
            name: "Bender",
            code: "MD-BD",
        },
        {
            country: "MD",
            name: "Briceni",
            code: "MD-BR",
        },
        {
            country: "MD",
            name: "Cahul",
            code: "MD-CA",
        },
        {
            country: "MD",
            name: "Calarasi",
            code: "MD-CL",
        },
        {
            country: "MD",
            name: "Cantemir",
            code: "MD-CT",
        },
        {
            country: "MD",
            name: "Causeni",
            code: "MD-CS",
        },
        {
            country: "MD",
            name: "Chisinau",
            code: "MD-CU",
        },
        {
            country: "MD",
            name: "Cimislia",
            code: "MD-CM",
        },
        {
            country: "MD",
            name: "Criuleni",
            code: "MD-CR",
        },
        {
            country: "MD",
            name: "Donduseni",
            code: "MD-DO",
        },
        {
            country: "MD",
            name: "Drochia",
            code: "MD-DR",
        },
        {
            country: "MD",
            name: "Dubasari",
            code: "MD-DU",
        },
        {
            country: "MD",
            name: "Edinet",
            code: "MD-ED",
        },
        {
            country: "MD",
            name: "Falesti",
            code: "MD-FA",
        },
        {
            country: "MD",
            name: "Floresti",
            code: "MD-FL",
        },
        {
            country: "MD",
            name: "Gagauzia, Unitatea teritoriala autonoma",
            code: "MD-GA",
        },
        {
            country: "MD",
            name: "Glodeni",
            code: "MD-GL",
        },
        {
            country: "MD",
            name: "Hincesti",
            code: "MD-HI",
        },
        {
            country: "MD",
            name: "Ialoveni",
            code: "MD-IA",
        },
        {
            country: "MD",
            name: "Leova",
            code: "MD-LE",
        },
        {
            country: "MD",
            name: "Nisporeni",
            code: "MD-NI",
        },
        {
            country: "MD",
            name: "Ocnita",
            code: "MD-OC",
        },
        {
            country: "MD",
            name: "Orhei",
            code: "MD-OR",
        },
        {
            country: "MD",
            name: "Rezina",
            code: "MD-RE",
        },
        {
            country: "MD",
            name: "Riscani",
            code: "MD-RI",
        },
        {
            country: "MD",
            name: "Singerei",
            code: "MD-SI",
        },
        {
            country: "MD",
            name: "Soldanesti",
            code: "MD-SD",
        },
        {
            country: "MD",
            name: "Soroca",
            code: "MD-SO",
        },
        {
            country: "MD",
            name: "Stefan Voda",
            code: "MD-SV",
        },
        {
            country: "MD",
            name: "Stinga Nistrului, unitatea teritoriala din",
            code: "MD-SN",
        },
        {
            country: "MD",
            name: "Straseni",
            code: "MD-ST",
        },
        {
            country: "MD",
            name: "Taraclia",
            code: "MD-TA",
        },
        {
            country: "MD",
            name: "Telenesti",
            code: "MD-TE",
        },
        {
            country: "MD",
            name: "Ungheni",
            code: "MD-UN",
        },
    ],
    ME: [
        {
            country: "ME",
            name: "Bar",
            code: "ME-02",
        },
        {
            country: "ME",
            name: "Berane",
            code: "ME-03",
        },
        {
            country: "ME",
            name: "Bijelo Polje",
            code: "ME-04",
        },
        {
            country: "ME",
            name: "Budva",
            code: "ME-05",
        },
        {
            country: "ME",
            name: "Cetinje",
            code: "ME-06",
        },
        {
            country: "ME",
            name: "Danilovgrad",
            code: "ME-07",
        },
        {
            country: "ME",
            name: "Gusinje",
            code: "ME-22",
        },
        {
            country: "ME",
            name: "Herceg-Novi",
            code: "ME-08",
        },
        {
            country: "ME",
            name: "Kolasin",
            code: "ME-09",
        },
        {
            country: "ME",
            name: "Kotor",
            code: "ME-10",
        },
        {
            country: "ME",
            name: "Niksic",
            code: "ME-12",
        },
        {
            country: "ME",
            name: "Plav",
            code: "ME-13",
        },
        {
            country: "ME",
            name: "Pljevlja",
            code: "ME-14",
        },
        {
            country: "ME",
            name: "Pluzine",
            code: "ME-15",
        },
        {
            country: "ME",
            name: "Podgorica",
            code: "ME-16",
        },
        {
            country: "ME",
            name: "Rozaje",
            code: "ME-17",
        },
        {
            country: "ME",
            name: "Tivat",
            code: "ME-19",
        },
        {
            country: "ME",
            name: "Tuzi",
            code: "ME-24",
        },
        {
            country: "ME",
            name: "Ulcinj",
            code: "ME-20",
        },
        {
            country: "ME",
            name: "Zabljak",
            code: "ME-21",
        },
        {
            country: "ME",
            name: "Zeta",
            code: "ME-25",
        },
    ],
    MF: [
        {
            country: "MF",
            name: "Saint Martin (French Part)",
            code: "-",
        },
    ],
    MG: [
        {
            country: "MG",
            name: "Antananarivo",
            code: "MG-T",
        },
        {
            country: "MG",
            name: "Antsiranana",
            code: "MG-D",
        },
        {
            country: "MG",
            name: "Fianarantsoa",
            code: "MG-F",
        },
        {
            country: "MG",
            name: "Mahajanga",
            code: "MG-M",
        },
        {
            country: "MG",
            name: "Toamasina",
            code: "MG-A",
        },
        {
            country: "MG",
            name: "Toliara",
            code: "MG-U",
        },
    ],
    MH: [
        {
            country: "MH",
            name: "Kwajalein",
            code: "MH-KWA",
        },
        {
            country: "MH",
            name: "Majuro",
            code: "MH-MAJ",
        },
    ],
    MK: [
        {
            country: "MK",
            name: "Berovo",
            code: "MK-201",
        },
        {
            country: "MK",
            name: "Bitola",
            code: "MK-501",
        },
        {
            country: "MK",
            name: "Bogdanci",
            code: "MK-401",
        },
        {
            country: "MK",
            name: "Bogovinje",
            code: "MK-601",
        },
        {
            country: "MK",
            name: "Bosilovo",
            code: "MK-402",
        },
        {
            country: "MK",
            name: "Brvenica",
            code: "MK-602",
        },
        {
            country: "MK",
            name: "Butel",
            code: "MK-803",
        },
        {
            country: "MK",
            name: "Caska",
            code: "MK-109",
        },
        {
            country: "MK",
            name: "Centar",
            code: "MK-814",
        },
        {
            country: "MK",
            name: "Centar Zupa",
            code: "MK-313",
        },
        {
            country: "MK",
            name: "Cucer Sandevo",
            code: "MK-816",
        },
        {
            country: "MK",
            name: "Debar",
            code: "MK-303",
        },
        {
            country: "MK",
            name: "Debarca",
            code: "MK-304",
        },
        {
            country: "MK",
            name: "Delcevo",
            code: "MK-203",
        },
        {
            country: "MK",
            name: "Demir Hisar",
            code: "MK-502",
        },
        {
            country: "MK",
            name: "Dojran",
            code: "MK-406",
        },
        {
            country: "MK",
            name: "Dolneni",
            code: "MK-503",
        },
        {
            country: "MK",
            name: "Gazi Baba",
            code: "MK-804",
        },
        {
            country: "MK",
            name: "Gevgelija",
            code: "MK-405",
        },
        {
            country: "MK",
            name: "Gostivar",
            code: "MK-604",
        },
        {
            country: "MK",
            name: "Ilinden",
            code: "MK-807",
        },
        {
            country: "MK",
            name: "Jegunovce",
            code: "MK-606",
        },
        {
            country: "MK",
            name: "Karbinci",
            code: "MK-205",
        },
        {
            country: "MK",
            name: "Kavadarci",
            code: "MK-104",
        },
        {
            country: "MK",
            name: "Kicevo",
            code: "MK-307",
        },
        {
            country: "MK",
            name: "Kisela Voda",
            code: "MK-809",
        },
        {
            country: "MK",
            name: "Kocani",
            code: "MK-206",
        },
        {
            country: "MK",
            name: "Konce",
            code: "MK-407",
        },
        {
            country: "MK",
            name: "Kratovo",
            code: "MK-701",
        },
        {
            country: "MK",
            name: "Kriva Palanka",
            code: "MK-702",
        },
        {
            country: "MK",
            name: "Krivogastani",
            code: "MK-504",
        },
        {
            country: "MK",
            name: "Kumanovo",
            code: "MK-703",
        },
        {
            country: "MK",
            name: "Lipkovo",
            code: "MK-704",
        },
        {
            country: "MK",
            name: "Lozovo",
            code: "MK-105",
        },
        {
            country: "MK",
            name: "Makedonska Kamenica",
            code: "MK-207",
        },
        {
            country: "MK",
            name: "Makedonski Brod",
            code: "MK-308",
        },
        {
            country: "MK",
            name: "Mavrovo i Rostusa",
            code: "MK-607",
        },
        {
            country: "MK",
            name: "Mogila",
            code: "MK-506",
        },
        {
            country: "MK",
            name: "Negotino",
            code: "MK-106",
        },
        {
            country: "MK",
            name: "Novaci",
            code: "MK-507",
        },
        {
            country: "MK",
            name: "Novo Selo",
            code: "MK-408",
        },
        {
            country: "MK",
            name: "Ohrid",
            code: "MK-310",
        },
        {
            country: "MK",
            name: "Petrovec",
            code: "MK-810",
        },
        {
            country: "MK",
            name: "Plasnica",
            code: "MK-311",
        },
        {
            country: "MK",
            name: "Prilep",
            code: "MK-508",
        },
        {
            country: "MK",
            name: "Probistip",
            code: "MK-209",
        },
        {
            country: "MK",
            name: "Radovis",
            code: "MK-409",
        },
        {
            country: "MK",
            name: "Rankovce",
            code: "MK-705",
        },
        {
            country: "MK",
            name: "Resen",
            code: "MK-509",
        },
        {
            country: "MK",
            name: "Rosoman",
            code: "MK-107",
        },
        {
            country: "MK",
            name: "Saraj",
            code: "MK-811",
        },
        {
            country: "MK",
            name: "Sopiste",
            code: "MK-812",
        },
        {
            country: "MK",
            name: "Stip",
            code: "MK-211",
        },
        {
            country: "MK",
            name: "Struga",
            code: "MK-312",
        },
        {
            country: "MK",
            name: "Strumica",
            code: "MK-410",
        },
        {
            country: "MK",
            name: "Studenicani",
            code: "MK-813",
        },
        {
            country: "MK",
            name: "Sveti Nikole",
            code: "MK-108",
        },
        {
            country: "MK",
            name: "Tearce",
            code: "MK-608",
        },
        {
            country: "MK",
            name: "Tetovo",
            code: "MK-609",
        },
        {
            country: "MK",
            name: "Valandovo",
            code: "MK-403",
        },
        {
            country: "MK",
            name: "Vasilevo",
            code: "MK-404",
        },
        {
            country: "MK",
            name: "Veles",
            code: "MK-101",
        },
        {
            country: "MK",
            name: "Vevcani",
            code: "MK-301",
        },
        {
            country: "MK",
            name: "Vinica",
            code: "MK-202",
        },
        {
            country: "MK",
            name: "Vrapciste",
            code: "MK-603",
        },
        {
            country: "MK",
            name: "Zelenikovo",
            code: "MK-806",
        },
        {
            country: "MK",
            name: "Zelino",
            code: "MK-605",
        },
        {
            country: "MK",
            name: "Zrnovci",
            code: "MK-204",
        },
    ],
    ML: [
        {
            country: "ML",
            name: "Bamako",
            code: "ML-BKO",
        },
        {
            country: "ML",
            name: "Gao",
            code: "ML-7",
        },
        {
            country: "ML",
            name: "Kayes",
            code: "ML-1",
        },
        {
            country: "ML",
            name: "Kidal",
            code: "ML-8",
        },
        {
            country: "ML",
            name: "Koulikoro",
            code: "ML-2",
        },
        {
            country: "ML",
            name: "Mopti",
            code: "ML-5",
        },
        {
            country: "ML",
            name: "Segou",
            code: "ML-4",
        },
        {
            country: "ML",
            name: "Sikasso",
            code: "ML-3",
        },
        {
            country: "ML",
            name: "Tombouctou",
            code: "ML-6",
        },
    ],
    MM: [
        {
            country: "MM",
            name: "Ayeyarwady",
            code: "MM-07",
        },
        {
            country: "MM",
            name: "Bago",
            code: "MM-02",
        },
        {
            country: "MM",
            name: "Chin",
            code: "MM-14",
        },
        {
            country: "MM",
            name: "Kachin",
            code: "MM-11",
        },
        {
            country: "MM",
            name: "Kayah",
            code: "MM-12",
        },
        {
            country: "MM",
            name: "Kayin",
            code: "MM-13",
        },
        {
            country: "MM",
            name: "Magway",
            code: "MM-03",
        },
        {
            country: "MM",
            name: "Mandalay",
            code: "MM-04",
        },
        {
            country: "MM",
            name: "Mon",
            code: "MM-15",
        },
        {
            country: "MM",
            name: "Nay Pyi Taw",
            code: "MM-18",
        },
        {
            country: "MM",
            name: "Rakhine",
            code: "MM-16",
        },
        {
            country: "MM",
            name: "Sagaing",
            code: "MM-01",
        },
        {
            country: "MM",
            name: "Shan",
            code: "MM-17",
        },
        {
            country: "MM",
            name: "Tanintharyi",
            code: "MM-05",
        },
        {
            country: "MM",
            name: "Yangon",
            code: "MM-06",
        },
    ],
    MN: [
        {
            country: "MN",
            name: "Bayan-Olgiy",
            code: "MN-071",
        },
        {
            country: "MN",
            name: "Bayanhongor",
            code: "MN-069",
        },
        {
            country: "MN",
            name: "Darhan uul",
            code: "MN-037",
        },
        {
            country: "MN",
            name: "Dornod",
            code: "MN-061",
        },
        {
            country: "MN",
            name: "Dundgovi",
            code: "MN-059",
        },
        {
            country: "MN",
            name: "Dzavhan",
            code: "MN-057",
        },
        {
            country: "MN",
            name: "Govi-Altay",
            code: "MN-065",
        },
        {
            country: "MN",
            name: "Govi-Sumber",
            code: "MN-064",
        },
        {
            country: "MN",
            name: "Hovd",
            code: "MN-043",
        },
        {
            country: "MN",
            name: "Hovsgol",
            code: "MN-041",
        },
        {
            country: "MN",
            name: "Omnogovi",
            code: "MN-053",
        },
        {
            country: "MN",
            name: "Orhon",
            code: "MN-035",
        },
        {
            country: "MN",
            name: "Ovorhangay",
            code: "MN-055",
        },
        {
            country: "MN",
            name: "Selenge",
            code: "MN-049",
        },
        {
            country: "MN",
            name: "Tov",
            code: "MN-047",
        },
        {
            country: "MN",
            name: "Ulaanbaatar",
            code: "MN-1",
        },
    ],
    MO: [
        {
            country: "MO",
            name: "Macao",
            code: "-",
        },
    ],
    MP: [
        {
            country: "MP",
            name: "Northern Mariana Islands",
            code: "-",
        },
    ],
    MQ: [
        {
            country: "MQ",
            name: "Martinique",
            code: "-",
        },
    ],
    MR: [
        {
            country: "MR",
            name: "Adrar",
            code: "MR-07",
        },
        {
            country: "MR",
            name: "Assaba",
            code: "MR-03",
        },
        {
            country: "MR",
            name: "Brakna",
            code: "MR-05",
        },
        {
            country: "MR",
            name: "Dakhlet Nouadhibou",
            code: "MR-08",
        },
        {
            country: "MR",
            name: "Gorgol",
            code: "MR-04",
        },
        {
            country: "MR",
            name: "Guidimaka",
            code: "MR-10",
        },
        {
            country: "MR",
            name: "Hodh el Gharbi",
            code: "MR-02",
        },
        {
            country: "MR",
            name: "Inchiri",
            code: "MR-12",
        },
        {
            country: "MR",
            name: "Nouakchott Ouest",
            code: "MR-13",
        },
        {
            country: "MR",
            name: "Tagant",
            code: "MR-09",
        },
        {
            country: "MR",
            name: "Tiris Zemmour",
            code: "MR-11",
        },
        {
            country: "MR",
            name: "Trarza",
            code: "MR-06",
        },
    ],
    MS: [
        {
            country: "MS",
            name: "Saint Anthony",
            code: "-",
        },
        {
            country: "MS",
            name: "Saint Peter",
            code: "-",
        },
    ],
    MT: [
        {
            country: "MT",
            name: "Attard",
            code: "MT-01",
        },
        {
            country: "MT",
            name: "Balzan",
            code: "MT-02",
        },
        {
            country: "MT",
            name: "Birgu",
            code: "MT-03",
        },
        {
            country: "MT",
            name: "Birkirkara",
            code: "MT-04",
        },
        {
            country: "MT",
            name: "Birzebbuga",
            code: "MT-05",
        },
        {
            country: "MT",
            name: "Bormla",
            code: "MT-06",
        },
        {
            country: "MT",
            name: "Dingli",
            code: "MT-07",
        },
        {
            country: "MT",
            name: "Fgura",
            code: "MT-08",
        },
        {
            country: "MT",
            name: "Floriana",
            code: "MT-09",
        },
        {
            country: "MT",
            name: "Fontana",
            code: "MT-10",
        },
        {
            country: "MT",
            name: "Ghajnsielem",
            code: "MT-13",
        },
        {
            country: "MT",
            name: "Gharb",
            code: "MT-14",
        },
        {
            country: "MT",
            name: "Gharghur",
            code: "MT-15",
        },
        {
            country: "MT",
            name: "Ghasri",
            code: "MT-16",
        },
        {
            country: "MT",
            name: "Ghaxaq",
            code: "MT-17",
        },
        {
            country: "MT",
            name: "Gudja",
            code: "MT-11",
        },
        {
            country: "MT",
            name: "Gzira",
            code: "MT-12",
        },
        {
            country: "MT",
            name: "Hamrun",
            code: "MT-18",
        },
        {
            country: "MT",
            name: "Iklin",
            code: "MT-19",
        },
        {
            country: "MT",
            name: "Isla",
            code: "MT-20",
        },
        {
            country: "MT",
            name: "Kalkara",
            code: "MT-21",
        },
        {
            country: "MT",
            name: "Kirkop",
            code: "MT-23",
        },
        {
            country: "MT",
            name: "Lija",
            code: "MT-24",
        },
        {
            country: "MT",
            name: "Luqa",
            code: "MT-25",
        },
        {
            country: "MT",
            name: "Marsa",
            code: "MT-26",
        },
        {
            country: "MT",
            name: "Marsaskala",
            code: "MT-27",
        },
        {
            country: "MT",
            name: "Marsaxlokk",
            code: "MT-28",
        },
        {
            country: "MT",
            name: "Mdina",
            code: "MT-29",
        },
        {
            country: "MT",
            name: "Mellieha",
            code: "MT-30",
        },
        {
            country: "MT",
            name: "Mgarr",
            code: "MT-31",
        },
        {
            country: "MT",
            name: "Mosta",
            code: "MT-32",
        },
        {
            country: "MT",
            name: "Mqabba",
            code: "MT-33",
        },
        {
            country: "MT",
            name: "Msida",
            code: "MT-34",
        },
        {
            country: "MT",
            name: "Mtarfa",
            code: "MT-35",
        },
        {
            country: "MT",
            name: "Munxar",
            code: "MT-36",
        },
        {
            country: "MT",
            name: "Nadur",
            code: "MT-37",
        },
        {
            country: "MT",
            name: "Naxxar",
            code: "MT-38",
        },
        {
            country: "MT",
            name: "Paola",
            code: "MT-39",
        },
        {
            country: "MT",
            name: "Pembroke",
            code: "MT-40",
        },
        {
            country: "MT",
            name: "Pieta",
            code: "MT-41",
        },
        {
            country: "MT",
            name: "Qala",
            code: "MT-42",
        },
        {
            country: "MT",
            name: "Qormi",
            code: "MT-43",
        },
        {
            country: "MT",
            name: "Qrendi",
            code: "MT-44",
        },
        {
            country: "MT",
            name: "Rabat Gozo",
            code: "MT-45",
        },
        {
            country: "MT",
            name: "Rabat Malta",
            code: "MT-46",
        },
        {
            country: "MT",
            name: "Safi",
            code: "MT-47",
        },
        {
            country: "MT",
            name: "Saint John",
            code: "MT-49",
        },
        {
            country: "MT",
            name: "Saint Julian's",
            code: "MT-48",
        },
        {
            country: "MT",
            name: "Saint Lawrence",
            code: "MT-50",
        },
        {
            country: "MT",
            name: "Saint Lucia's",
            code: "MT-53",
        },
        {
            country: "MT",
            name: "Saint Paul's Bay",
            code: "MT-51",
        },
        {
            country: "MT",
            name: "Sannat",
            code: "MT-52",
        },
        {
            country: "MT",
            name: "Santa Venera",
            code: "MT-54",
        },
        {
            country: "MT",
            name: "Siggiewi",
            code: "MT-55",
        },
        {
            country: "MT",
            name: "Sliema",
            code: "MT-56",
        },
        {
            country: "MT",
            name: "Swieqi",
            code: "MT-57",
        },
        {
            country: "MT",
            name: "Ta' Xbiex",
            code: "MT-58",
        },
        {
            country: "MT",
            name: "Tarxien",
            code: "MT-59",
        },
        {
            country: "MT",
            name: "Valletta",
            code: "MT-60",
        },
        {
            country: "MT",
            name: "Xaghra",
            code: "MT-61",
        },
        {
            country: "MT",
            name: "Xewkija",
            code: "MT-62",
        },
        {
            country: "MT",
            name: "Xghajra",
            code: "MT-63",
        },
        {
            country: "MT",
            name: "Zabbar",
            code: "MT-64",
        },
        {
            country: "MT",
            name: "Zebbug Gozo",
            code: "MT-65",
        },
        {
            country: "MT",
            name: "Zejtun",
            code: "MT-67",
        },
        {
            country: "MT",
            name: "Zurrieq",
            code: "MT-68",
        },
    ],
    MU: [
        {
            country: "MU",
            name: "Black River",
            code: "MU-BL",
        },
        {
            country: "MU",
            name: "Flacq",
            code: "MU-FL",
        },
        {
            country: "MU",
            name: "Grand Port",
            code: "MU-GP",
        },
        {
            country: "MU",
            name: "Moka",
            code: "MU-MO",
        },
        {
            country: "MU",
            name: "Pamplemousses",
            code: "MU-PA",
        },
        {
            country: "MU",
            name: "Plaines Wilhems",
            code: "MU-PW",
        },
        {
            country: "MU",
            name: "Port Louis",
            code: "MU-PL",
        },
        {
            country: "MU",
            name: "Riviere du Rempart",
            code: "MU-RR",
        },
        {
            country: "MU",
            name: "Rodrigues Islands",
            code: "MU-RO",
        },
        {
            country: "MU",
            name: "Savanne",
            code: "MU-SA",
        },
    ],
    MV: [
        {
            country: "MV",
            name: "Addu City",
            code: "MV-01",
        },
        {
            country: "MV",
            name: "Faadhippolhu",
            code: "MV-03",
        },
        {
            country: "MV",
            name: "Felidhu Atoll",
            code: "MV-04",
        },
        {
            country: "MV",
            name: "Fuvammulah",
            code: "MV-29",
        },
        {
            country: "MV",
            name: "Hahdhunmathi",
            code: "MV-05",
        },
        {
            country: "MV",
            name: "Male",
            code: "MV-MLE",
        },
        {
            country: "MV",
            name: "Mulaku Atoll",
            code: "MV-12",
        },
        {
            country: "MV",
            name: "North Ari Atoll",
            code: "MV-02",
        },
        {
            country: "MV",
            name: "North Huvadhu Atoll",
            code: "MV-27",
        },
        {
            country: "MV",
            name: "North Maalhosmadulu",
            code: "MV-13",
        },
        {
            country: "MV",
            name: "North Miladhunmadulu",
            code: "MV-24",
        },
        {
            country: "MV",
            name: "North Nilandhe Atoll",
            code: "MV-14",
        },
        {
            country: "MV",
            name: "North Thiladhunmathi",
            code: "MV-07",
        },
        {
            country: "MV",
            name: "South Ari Atoll",
            code: "MV-00",
        },
        {
            country: "MV",
            name: "South Huvadhu Atoll",
            code: "MV-28",
        },
        {
            country: "MV",
            name: "South Maalhosmadulu",
            code: "MV-20",
        },
        {
            country: "MV",
            name: "South Miladhunmadulu",
            code: "MV-25",
        },
        {
            country: "MV",
            name: "South Nilandhe Atoll",
            code: "MV-17",
        },
        {
            country: "MV",
            name: "South Thiladhunmathi",
            code: "MV-23",
        },
    ],
    MW: [
        {
            country: "MW",
            name: "Balaka",
            code: "MW-BA",
        },
        {
            country: "MW",
            name: "Blantyre",
            code: "MW-BL",
        },
        {
            country: "MW",
            name: "Chikwawa",
            code: "MW-CK",
        },
        {
            country: "MW",
            name: "Chiradzulu",
            code: "MW-CR",
        },
        {
            country: "MW",
            name: "Dedza",
            code: "MW-DE",
        },
        {
            country: "MW",
            name: "Dowa",
            code: "MW-DO",
        },
        {
            country: "MW",
            name: "Karonga",
            code: "MW-KR",
        },
        {
            country: "MW",
            name: "Likoma",
            code: "MW-LK",
        },
        {
            country: "MW",
            name: "Lilongwe",
            code: "MW-LI",
        },
        {
            country: "MW",
            name: "Machinga",
            code: "MW-MH",
        },
        {
            country: "MW",
            name: "Mangochi",
            code: "MW-MG",
        },
        {
            country: "MW",
            name: "Mwanza",
            code: "MW-MW",
        },
        {
            country: "MW",
            name: "Mzimba",
            code: "MW-MZ",
        },
        {
            country: "MW",
            name: "Neno",
            code: "MW-NE",
        },
        {
            country: "MW",
            name: "Nkhotakota",
            code: "MW-NK",
        },
        {
            country: "MW",
            name: "Ntchisi",
            code: "MW-NI",
        },
        {
            country: "MW",
            name: "Salima",
            code: "MW-SA",
        },
        {
            country: "MW",
            name: "Thyolo",
            code: "MW-TH",
        },
        {
            country: "MW",
            name: "Zomba",
            code: "MW-ZO",
        },
    ],
    MX: [
        {
            country: "MX",
            name: "Aguascalientes",
            code: "MX-AGU",
        },
        {
            country: "MX",
            name: "Baja California",
            code: "MX-BCN",
        },
        {
            country: "MX",
            name: "Baja California Sur",
            code: "MX-BCS",
        },
        {
            country: "MX",
            name: "Campeche",
            code: "MX-CAM",
        },
        {
            country: "MX",
            name: "Chiapas",
            code: "MX-CHP",
        },
        {
            country: "MX",
            name: "Chihuahua",
            code: "MX-CHH",
        },
        {
            country: "MX",
            name: "Ciudad de Mexico",
            code: "MX-CMX",
        },
        {
            country: "MX",
            name: "Coahuila de Zaragoza",
            code: "MX-COA",
        },
        {
            country: "MX",
            name: "Colima",
            code: "MX-COL",
        },
        {
            country: "MX",
            name: "Durango",
            code: "MX-DUR",
        },
        {
            country: "MX",
            name: "Guanajuato",
            code: "MX-GUA",
        },
        {
            country: "MX",
            name: "Guerrero",
            code: "MX-GRO",
        },
        {
            country: "MX",
            name: "Hidalgo",
            code: "MX-HID",
        },
        {
            country: "MX",
            name: "Jalisco",
            code: "MX-JAL",
        },
        {
            country: "MX",
            name: "Mexico",
            code: "MX-MEX",
        },
        {
            country: "MX",
            name: "Michoacan de Ocampo",
            code: "MX-MIC",
        },
        {
            country: "MX",
            name: "Morelos",
            code: "MX-MOR",
        },
        {
            country: "MX",
            name: "Nayarit",
            code: "MX-NAY",
        },
        {
            country: "MX",
            name: "Nuevo Leon",
            code: "MX-NLE",
        },
        {
            country: "MX",
            name: "Oaxaca",
            code: "MX-OAX",
        },
        {
            country: "MX",
            name: "Puebla",
            code: "MX-PUE",
        },
        {
            country: "MX",
            name: "Queretaro",
            code: "MX-QUE",
        },
        {
            country: "MX",
            name: "Quintana Roo",
            code: "MX-ROO",
        },
        {
            country: "MX",
            name: "San Luis Potosi",
            code: "MX-SLP",
        },
        {
            country: "MX",
            name: "Sinaloa",
            code: "MX-SIN",
        },
        {
            country: "MX",
            name: "Sonora",
            code: "MX-SON",
        },
        {
            country: "MX",
            name: "Tabasco",
            code: "MX-TAB",
        },
        {
            country: "MX",
            name: "Tamaulipas",
            code: "MX-TAM",
        },
        {
            country: "MX",
            name: "Tlaxcala",
            code: "MX-TLA",
        },
        {
            country: "MX",
            name: "Veracruz de Ignacio de la Llave",
            code: "MX-VER",
        },
        {
            country: "MX",
            name: "Yucatan",
            code: "MX-YUC",
        },
        {
            country: "MX",
            name: "Zacatecas",
            code: "MX-ZAC",
        },
    ],
    MY: [
        {
            country: "MY",
            name: "Johor",
            code: "MY-01",
        },
        {
            country: "MY",
            name: "Kedah",
            code: "MY-02",
        },
        {
            country: "MY",
            name: "Kelantan",
            code: "MY-03",
        },
        {
            country: "MY",
            name: "Melaka",
            code: "MY-04",
        },
        {
            country: "MY",
            name: "Negeri Sembilan",
            code: "MY-05",
        },
        {
            country: "MY",
            name: "Pahang",
            code: "MY-06",
        },
        {
            country: "MY",
            name: "Perak",
            code: "MY-08",
        },
        {
            country: "MY",
            name: "Perlis",
            code: "MY-09",
        },
        {
            country: "MY",
            name: "Pulau Pinang",
            code: "MY-07",
        },
        {
            country: "MY",
            name: "Sabah",
            code: "MY-12",
        },
        {
            country: "MY",
            name: "Sarawak",
            code: "MY-13",
        },
        {
            country: "MY",
            name: "Selangor",
            code: "MY-10",
        },
        {
            country: "MY",
            name: "Terengganu",
            code: "MY-11",
        },
        {
            country: "MY",
            name: "Wilayah Persekutuan Kuala Lumpur",
            code: "MY-14",
        },
        {
            country: "MY",
            name: "Wilayah Persekutuan Labuan",
            code: "MY-15",
        },
        {
            country: "MY",
            name: "Wilayah Persekutuan Putrajaya",
            code: "MY-16",
        },
    ],
    MZ: [
        {
            country: "MZ",
            name: "Cabo Delgado",
            code: "MZ-P",
        },
        {
            country: "MZ",
            name: "Gaza",
            code: "MZ-G",
        },
        {
            country: "MZ",
            name: "Inhambane",
            code: "MZ-I",
        },
        {
            country: "MZ",
            name: "Manica",
            code: "MZ-B",
        },
        {
            country: "MZ",
            name: "Maputo",
            code: "MZ-L",
        },
        {
            country: "MZ",
            name: "Nampula",
            code: "MZ-N",
        },
        {
            country: "MZ",
            name: "Niassa",
            code: "MZ-A",
        },
        {
            country: "MZ",
            name: "Sofala",
            code: "MZ-S",
        },
        {
            country: "MZ",
            name: "Tete",
            code: "MZ-T",
        },
        {
            country: "MZ",
            name: "Zambezia",
            code: "MZ-Q",
        },
    ],
    NA: [
        {
            country: "NA",
            name: "Erongo",
            code: "NA-ER",
        },
        {
            country: "NA",
            name: "Hardap",
            code: "NA-HA",
        },
        {
            country: "NA",
            name: "Karas",
            code: "NA-KA",
        },
        {
            country: "NA",
            name: "Kavango East",
            code: "NA-KE",
        },
        {
            country: "NA",
            name: "Kavango West",
            code: "NA-KW",
        },
        {
            country: "NA",
            name: "Khomas",
            code: "NA-KH",
        },
        {
            country: "NA",
            name: "Kunene",
            code: "NA-KU",
        },
        {
            country: "NA",
            name: "Ohangwena",
            code: "NA-OW",
        },
        {
            country: "NA",
            name: "Omaheke",
            code: "NA-OH",
        },
        {
            country: "NA",
            name: "Omusati",
            code: "NA-OS",
        },
        {
            country: "NA",
            name: "Oshana",
            code: "NA-ON",
        },
        {
            country: "NA",
            name: "Oshikoto",
            code: "NA-OT",
        },
        {
            country: "NA",
            name: "Otjozondjupa",
            code: "NA-OD",
        },
        {
            country: "NA",
            name: "Zambezi",
            code: "NA-CA",
        },
    ],
    NC: [
        {
            country: "NC",
            name: "Province Nord",
            code: "-",
        },
        {
            country: "NC",
            name: "Province Sud",
            code: "-",
        },
        {
            country: "NC",
            name: "Province des iles Loyaute",
            code: "-",
        },
    ],
    NE: [
        {
            country: "NE",
            name: "Agadez",
            code: "NE-1",
        },
        {
            country: "NE",
            name: "Diffa",
            code: "NE-2",
        },
        {
            country: "NE",
            name: "Dosso",
            code: "NE-3",
        },
        {
            country: "NE",
            name: "Maradi",
            code: "NE-4",
        },
        {
            country: "NE",
            name: "Niamey",
            code: "NE-8",
        },
        {
            country: "NE",
            name: "Tahoua",
            code: "NE-5",
        },
        {
            country: "NE",
            name: "Tillaberi",
            code: "NE-6",
        },
        {
            country: "NE",
            name: "Zinder",
            code: "NE-7",
        },
    ],
    NF: [
        {
            country: "NF",
            name: "Norfolk Island",
            code: "-",
        },
    ],
    NG: [
        {
            country: "NG",
            name: "Abia",
            code: "NG-AB",
        },
        {
            country: "NG",
            name: "Abuja Federal Capital Territory",
            code: "NG-FC",
        },
        {
            country: "NG",
            name: "Adamawa",
            code: "NG-AD",
        },
        {
            country: "NG",
            name: "Akwa Ibom",
            code: "NG-AK",
        },
        {
            country: "NG",
            name: "Anambra",
            code: "NG-AN",
        },
        {
            country: "NG",
            name: "Bauchi",
            code: "NG-BA",
        },
        {
            country: "NG",
            name: "Bayelsa",
            code: "NG-BY",
        },
        {
            country: "NG",
            name: "Benue",
            code: "NG-BE",
        },
        {
            country: "NG",
            name: "Borno",
            code: "NG-BO",
        },
        {
            country: "NG",
            name: "Cross River",
            code: "NG-CR",
        },
        {
            country: "NG",
            name: "Delta",
            code: "NG-DE",
        },
        {
            country: "NG",
            name: "Ebonyi",
            code: "NG-EB",
        },
        {
            country: "NG",
            name: "Edo",
            code: "NG-ED",
        },
        {
            country: "NG",
            name: "Ekiti",
            code: "NG-EK",
        },
        {
            country: "NG",
            name: "Enugu",
            code: "NG-EN",
        },
        {
            country: "NG",
            name: "Gombe",
            code: "NG-GO",
        },
        {
            country: "NG",
            name: "Imo",
            code: "NG-IM",
        },
        {
            country: "NG",
            name: "Jigawa",
            code: "NG-JI",
        },
        {
            country: "NG",
            name: "Kaduna",
            code: "NG-KD",
        },
        {
            country: "NG",
            name: "Kano",
            code: "NG-KN",
        },
        {
            country: "NG",
            name: "Katsina",
            code: "NG-KT",
        },
        {
            country: "NG",
            name: "Kebbi",
            code: "NG-KE",
        },
        {
            country: "NG",
            name: "Kogi",
            code: "NG-KO",
        },
        {
            country: "NG",
            name: "Kwara",
            code: "NG-KW",
        },
        {
            country: "NG",
            name: "Lagos",
            code: "NG-LA",
        },
        {
            country: "NG",
            name: "Nasarawa",
            code: "NG-NA",
        },
        {
            country: "NG",
            name: "Niger",
            code: "NG-NI",
        },
        {
            country: "NG",
            name: "Ogun",
            code: "NG-OG",
        },
        {
            country: "NG",
            name: "Ondo",
            code: "NG-ON",
        },
        {
            country: "NG",
            name: "Osun",
            code: "NG-OS",
        },
        {
            country: "NG",
            name: "Oyo",
            code: "NG-OY",
        },
        {
            country: "NG",
            name: "Plateau",
            code: "NG-PL",
        },
        {
            country: "NG",
            name: "Rivers",
            code: "NG-RI",
        },
        {
            country: "NG",
            name: "Sokoto",
            code: "NG-SO",
        },
        {
            country: "NG",
            name: "Taraba",
            code: "NG-TA",
        },
        {
            country: "NG",
            name: "Yobe",
            code: "NG-YO",
        },
        {
            country: "NG",
            name: "Zamfara",
            code: "NG-ZA",
        },
    ],
    NI: [
        {
            country: "NI",
            name: "Boaco",
            code: "NI-BO",
        },
        {
            country: "NI",
            name: "Carazo",
            code: "NI-CA",
        },
        {
            country: "NI",
            name: "Chinandega",
            code: "NI-CI",
        },
        {
            country: "NI",
            name: "Chontales",
            code: "NI-CO",
        },
        {
            country: "NI",
            name: "Costa Caribe Norte",
            code: "NI-AN",
        },
        {
            country: "NI",
            name: "Costa Caribe Sur",
            code: "NI-AS",
        },
        {
            country: "NI",
            name: "Esteli",
            code: "NI-ES",
        },
        {
            country: "NI",
            name: "Granada",
            code: "NI-GR",
        },
        {
            country: "NI",
            name: "Jinotega",
            code: "NI-JI",
        },
        {
            country: "NI",
            name: "Leon",
            code: "NI-LE",
        },
        {
            country: "NI",
            name: "Madriz",
            code: "NI-MD",
        },
        {
            country: "NI",
            name: "Managua",
            code: "NI-MN",
        },
        {
            country: "NI",
            name: "Masaya",
            code: "NI-MS",
        },
        {
            country: "NI",
            name: "Matagalpa",
            code: "NI-MT",
        },
        {
            country: "NI",
            name: "Nueva Segovia",
            code: "NI-NS",
        },
        {
            country: "NI",
            name: "Rio San Juan",
            code: "NI-SJ",
        },
        {
            country: "NI",
            name: "Rivas",
            code: "NI-RI",
        },
    ],
    NL: [
        {
            country: "NL",
            name: "Drenthe",
            code: "NL-DR",
        },
        {
            country: "NL",
            name: "Flevoland",
            code: "NL-FL",
        },
        {
            country: "NL",
            name: "Fryslan",
            code: "NL-FR",
        },
        {
            country: "NL",
            name: "Gelderland",
            code: "NL-GE",
        },
        {
            country: "NL",
            name: "Groningen",
            code: "NL-GR",
        },
        {
            country: "NL",
            name: "Limburg",
            code: "NL-LI",
        },
        {
            country: "NL",
            name: "Noord-Brabant",
            code: "NL-NB",
        },
        {
            country: "NL",
            name: "Noord-Holland",
            code: "NL-NH",
        },
        {
            country: "NL",
            name: "Overijssel",
            code: "NL-OV",
        },
        {
            country: "NL",
            name: "Utrecht",
            code: "NL-UT",
        },
        {
            country: "NL",
            name: "Zeeland",
            code: "NL-ZE",
        },
        {
            country: "NL",
            name: "Zuid-Holland",
            code: "NL-ZH",
        },
    ],
    NO: [
        {
            country: "NO",
            name: "Agder",
            code: "NO-42",
        },
        {
            country: "NO",
            name: "Innlandet",
            code: "NO-34",
        },
        {
            country: "NO",
            name: "More og Romsdal",
            code: "NO-15",
        },
        {
            country: "NO",
            name: "Nordland",
            code: "NO-18",
        },
        {
            country: "NO",
            name: "Oslo",
            code: "NO-03",
        },
        {
            country: "NO",
            name: "Rogaland",
            code: "NO-11",
        },
        {
            country: "NO",
            name: "Troms og Finnmark",
            code: "NO-54",
        },
        {
            country: "NO",
            name: "Trondelag",
            code: "NO-50",
        },
        {
            country: "NO",
            name: "Vestfold og Telemark",
            code: "NO-38",
        },
        {
            country: "NO",
            name: "Vestland",
            code: "NO-46",
        },
        {
            country: "NO",
            name: "Viken",
            code: "NO-30",
        },
    ],
    NP: [
        {
            country: "NP",
            name: "Bagmati",
            code: "NP-P3",
        },
        {
            country: "NP",
            name: "Gandaki",
            code: "NP-P4",
        },
        {
            country: "NP",
            name: "Karnali",
            code: "NP-P6",
        },
        {
            country: "NP",
            name: "Koshi",
            code: "NP-P1",
        },
        {
            country: "NP",
            name: "Lumbini",
            code: "NP-P5",
        },
        {
            country: "NP",
            name: "Madhesh",
            code: "NP-P2",
        },
        {
            country: "NP",
            name: "Sudurpashchim",
            code: " NP-P7",
        },
    ],
    NR: [
        {
            country: "NR",
            name: "Aiwo",
            code: "NR-01",
        },
        {
            country: "NR",
            name: "Anetan",
            code: "NR-03",
        },
        {
            country: "NR",
            name: "Yaren",
            code: "NR-14",
        },
    ],
    NU: [
        {
            country: "NU",
            name: "Niue",
            code: "-",
        },
    ],
    NZ: [
        {
            country: "NZ",
            name: "Auckland",
            code: "NZ-AUK",
        },
        {
            country: "NZ",
            name: "Bay of Plenty",
            code: "NZ-BOP",
        },
        {
            country: "NZ",
            name: "Canterbury",
            code: "NZ-CAN",
        },
        {
            country: "NZ",
            name: "Chatham Islands Territory",
            code: "NZ-CIT",
        },
        {
            country: "NZ",
            name: "Gisborne",
            code: "NZ-GIS",
        },
        {
            country: "NZ",
            name: "Greater Wellington",
            code: "NZ-WGN",
        },
        {
            country: "NZ",
            name: "Hawke's Bay",
            code: "NZ-HKB",
        },
        {
            country: "NZ",
            name: "Manawatu-Whanganui",
            code: "NZ-MWT",
        },
        {
            country: "NZ",
            name: "Marlborough",
            code: "NZ-MBH",
        },
        {
            country: "NZ",
            name: "Nelson",
            code: "NZ-NSN",
        },
        {
            country: "NZ",
            name: "Northland",
            code: "NZ-NTL",
        },
        {
            country: "NZ",
            name: "Otago",
            code: "NZ-OTA",
        },
        {
            country: "NZ",
            name: "Southland",
            code: "NZ-STL",
        },
        {
            country: "NZ",
            name: "Taranaki",
            code: "NZ-TKI",
        },
        {
            country: "NZ",
            name: "Tasman",
            code: "NZ-TAS",
        },
        {
            country: "NZ",
            name: "Waikato",
            code: "NZ-WKO",
        },
        {
            country: "NZ",
            name: "West Coast",
            code: "NZ-WTC",
        },
    ],
    OM: [
        {
            country: "OM",
            name: "Ad Dakhiliyah",
            code: "OM-DA",
        },
        {
            country: "OM",
            name: "Al Buraymi",
            code: "OM-BU",
        },
        {
            country: "OM",
            name: "Al Wusta",
            code: "OM-WU",
        },
        {
            country: "OM",
            name: "Az Zahirah",
            code: "OM-ZA",
        },
        {
            country: "OM",
            name: "Janub al Batinah",
            code: "OM-BJ",
        },
        {
            country: "OM",
            name: "Janub ash Sharqiyah",
            code: "OM-SJ",
        },
        {
            country: "OM",
            name: "Masqat",
            code: "OM-MA",
        },
        {
            country: "OM",
            name: "Musandam",
            code: "OM-MU",
        },
        {
            country: "OM",
            name: "Shamal al Batinah",
            code: "OM-BS",
        },
        {
            country: "OM",
            name: "Shamal ash Sharqiyah",
            code: "OM-SS",
        },
        {
            country: "OM",
            name: "Zufar",
            code: "OM-ZU",
        },
    ],
    PA: [
        {
            country: "PA",
            name: "Bocas del Toro",
            code: "PA-1",
        },
        {
            country: "PA",
            name: "Chiriqui",
            code: "PA-4",
        },
        {
            country: "PA",
            name: "Cocle",
            code: "PA-2",
        },
        {
            country: "PA",
            name: "Colon",
            code: "PA-3",
        },
        {
            country: "PA",
            name: "Darien",
            code: "PA-5",
        },
        {
            country: "PA",
            name: "Herrera",
            code: "PA-6",
        },
        {
            country: "PA",
            name: "Los Santos",
            code: "PA-7",
        },
        {
            country: "PA",
            name: "Ngobe-Bugle",
            code: "PA-NB",
        },
        {
            country: "PA",
            name: "Panama",
            code: "PA-8",
        },
        {
            country: "PA",
            name: "Veraguas",
            code: "PA-9",
        },
    ],
    PE: [
        {
            country: "PE",
            name: "Amazonas",
            code: "PE-AMA",
        },
        {
            country: "PE",
            name: "Ancash",
            code: "PE-ANC",
        },
        {
            country: "PE",
            name: "Apurimac",
            code: "PE-APU",
        },
        {
            country: "PE",
            name: "Arequipa",
            code: "PE-ARE",
        },
        {
            country: "PE",
            name: "Ayacucho",
            code: "PE-AYA",
        },
        {
            country: "PE",
            name: "Cajamarca",
            code: "PE-CAJ",
        },
        {
            country: "PE",
            name: "Cusco",
            code: "PE-CUS",
        },
        {
            country: "PE",
            name: "El Callao",
            code: "PE-CAL",
        },
        {
            country: "PE",
            name: "Huancavelica",
            code: "PE-HUV",
        },
        {
            country: "PE",
            name: "Huanuco",
            code: "PE-HUC",
        },
        {
            country: "PE",
            name: "Ica",
            code: "PE-ICA",
        },
        {
            country: "PE",
            name: "Junin",
            code: "PE-JUN",
        },
        {
            country: "PE",
            name: "La Libertad",
            code: "PE-LAL",
        },
        {
            country: "PE",
            name: "Lambayeque",
            code: "PE-LAM",
        },
        {
            country: "PE",
            name: "Lima",
            code: "PE-LIM",
        },
        {
            country: "PE",
            name: "Loreto",
            code: "PE-LOR",
        },
        {
            country: "PE",
            name: "Madre de Dios",
            code: "PE-MDD",
        },
        {
            country: "PE",
            name: "Moquegua",
            code: "PE-MOQ",
        },
        {
            country: "PE",
            name: "Pasco",
            code: "PE-PAS",
        },
        {
            country: "PE",
            name: "Piura",
            code: "PE-PIU",
        },
        {
            country: "PE",
            name: "Puno",
            code: "PE-PUN",
        },
        {
            country: "PE",
            name: "San Martin",
            code: "PE-SAM",
        },
        {
            country: "PE",
            name: "Tacna",
            code: "PE-TAC",
        },
        {
            country: "PE",
            name: "Tumbes",
            code: "PE-TUM",
        },
        {
            country: "PE",
            name: "Ucayali",
            code: "PE-UCA",
        },
    ],
    PF: [
        {
            country: "PF",
            name: "Iles Australes",
            code: "-",
        },
        {
            country: "PF",
            name: "Iles Marquises",
            code: "-",
        },
        {
            country: "PF",
            name: "Iles Sous-le-Vent",
            code: "-",
        },
        {
            country: "PF",
            name: "Iles Tuamotu-Gambier",
            code: "-",
        },
        {
            country: "PF",
            name: "Iles du Vent",
            code: "-",
        },
    ],
    PG: [
        {
            country: "PG",
            name: "Bougainville",
            code: "PG-NSB",
        },
        {
            country: "PG",
            name: "Central",
            code: "PG-CPM",
        },
        {
            country: "PG",
            name: "East New Britain",
            code: "PG-EBR",
        },
        {
            country: "PG",
            name: "Eastern Highlands",
            code: "PG-EHG",
        },
        {
            country: "PG",
            name: "Enga",
            code: "PG-EPW",
        },
        {
            country: "PG",
            name: "Madang",
            code: "PG-MPM",
        },
        {
            country: "PG",
            name: "Manus",
            code: "PG-MRL",
        },
        {
            country: "PG",
            name: "Milne Bay",
            code: "PG-MBA",
        },
        {
            country: "PG",
            name: "Morobe",
            code: "PG-MPL",
        },
        {
            country: "PG",
            name: "National Capital District (Port Moresby)",
            code: "PG-NCD",
        },
        {
            country: "PG",
            name: "New Ireland",
            code: "PG-NIK",
        },
        {
            country: "PG",
            name: "Northern",
            code: "PG-NPP",
        },
        {
            country: "PG",
            name: "Southern Highlands",
            code: "PG-SHM",
        },
        {
            country: "PG",
            name: "West New Britain",
            code: "PG-WBK",
        },
        {
            country: "PG",
            name: "West Sepik",
            code: "PG-SAN",
        },
        {
            country: "PG",
            name: "Western",
            code: "PG-WPD",
        },
        {
            country: "PG",
            name: "Western Highlands",
            code: "PG-WHM",
        },
    ],
    PH: [
        {
            country: "PH",
            name: "Abra",
            code: "PH-ABR",
        },
        {
            country: "PH",
            name: "Agusan del Norte",
            code: "PH-AGN",
        },
        {
            country: "PH",
            name: "Agusan del Sur",
            code: "PH-AGS",
        },
        {
            country: "PH",
            name: "Aklan",
            code: "PH-AKL",
        },
        {
            country: "PH",
            name: "Albay",
            code: "PH-ALB",
        },
        {
            country: "PH",
            name: "Antique",
            code: "PH-ANT",
        },
        {
            country: "PH",
            name: "Apayao",
            code: "PH-APA",
        },
        {
            country: "PH",
            name: "Aurora",
            code: "PH-AUR",
        },
        {
            country: "PH",
            name: "Basilan",
            code: "PH-BAS",
        },
        {
            country: "PH",
            name: "Bataan",
            code: "PH-BAN",
        },
        {
            country: "PH",
            name: "Batanes",
            code: "PH-BTN",
        },
        {
            country: "PH",
            name: "Batangas",
            code: "PH-BTG",
        },
        {
            country: "PH",
            name: "Benguet",
            code: "PH-BEN",
        },
        {
            country: "PH",
            name: "Biliran",
            code: "PH-BIL",
        },
        {
            country: "PH",
            name: "Bohol",
            code: "PH-BOH",
        },
        {
            country: "PH",
            name: "Bukidnon",
            code: "PH-BUK",
        },
        {
            country: "PH",
            name: "Bulacan",
            code: "PH-BUL",
        },
        {
            country: "PH",
            name: "Cagayan",
            code: "PH-CAG",
        },
        {
            country: "PH",
            name: "Camarines Norte",
            code: "PH-CAN",
        },
        {
            country: "PH",
            name: "Camarines Sur",
            code: "PH-CAS",
        },
        {
            country: "PH",
            name: "Camiguin",
            code: "PH-CAM",
        },
        {
            country: "PH",
            name: "Capiz",
            code: "PH-CAP",
        },
        {
            country: "PH",
            name: "Catanduanes",
            code: "PH-CAT",
        },
        {
            country: "PH",
            name: "Cavite",
            code: "PH-CAV",
        },
        {
            country: "PH",
            name: "Cebu",
            code: "PH-CEB",
        },
        {
            country: "PH",
            name: "Cotabato",
            code: "PH-NCO",
        },
        {
            country: "PH",
            name: "Davao Oriental",
            code: "PH-DAO",
        },
        {
            country: "PH",
            name: "Davao de Oro",
            code: "PH-COM",
        },
        {
            country: "PH",
            name: "Davao del Norte",
            code: "PH-DAV",
        },
        {
            country: "PH",
            name: "Davao del Sur",
            code: "PH-DAS",
        },
        {
            country: "PH",
            name: "Dinagat Islands",
            code: "PH-DIN",
        },
        {
            country: "PH",
            name: "Eastern Samar",
            code: "PH-EAS",
        },
        {
            country: "PH",
            name: "Guimaras",
            code: "PH-GUI",
        },
        {
            country: "PH",
            name: "Ifugao",
            code: "PH-IFU",
        },
        {
            country: "PH",
            name: "Ilocos Norte",
            code: "PH-ILN",
        },
        {
            country: "PH",
            name: "Ilocos Sur",
            code: "PH-ILS",
        },
        {
            country: "PH",
            name: "Iloilo",
            code: "PH-ILI",
        },
        {
            country: "PH",
            name: "Isabela",
            code: "PH-ISA",
        },
        {
            country: "PH",
            name: "Kalinga",
            code: "PH-KAL",
        },
        {
            country: "PH",
            name: "La Union",
            code: "PH-LUN",
        },
        {
            country: "PH",
            name: "Laguna",
            code: "PH-LAG",
        },
        {
            country: "PH",
            name: "Lanao del Norte",
            code: "PH-LAN",
        },
        {
            country: "PH",
            name: "Lanao del Sur",
            code: "PH-LAS",
        },
        {
            country: "PH",
            name: "Leyte",
            code: "PH-LEY",
        },
        {
            country: "PH",
            name: "Maguindanao",
            code: "PH-MAG",
        },
        {
            country: "PH",
            name: "Marinduque",
            code: "PH-MAD",
        },
        {
            country: "PH",
            name: "Masbate",
            code: "PH-MAS",
        },
        {
            country: "PH",
            name: "Mindoro Occidental",
            code: "PH-MDC",
        },
        {
            country: "PH",
            name: "Mindoro Oriental",
            code: "PH-MDR",
        },
        {
            country: "PH",
            name: "Misamis Occidental",
            code: "PH-MSC",
        },
        {
            country: "PH",
            name: "Misamis Oriental",
            code: "PH-MSR",
        },
        {
            country: "PH",
            name: "Mountain Province",
            code: "PH-MOU",
        },
        {
            country: "PH",
            name: "National Capital Region",
            code: "PH-00",
        },
        {
            country: "PH",
            name: "Negros Occidental",
            code: "PH-NEC",
        },
        {
            country: "PH",
            name: "Negros Oriental",
            code: "PH-NER",
        },
        {
            country: "PH",
            name: "Northern Samar",
            code: "PH-NSA",
        },
        {
            country: "PH",
            name: "Nueva Ecija",
            code: "PH-NUE",
        },
        {
            country: "PH",
            name: "Nueva Vizcaya",
            code: "PH-NUV",
        },
        {
            country: "PH",
            name: "Palawan",
            code: "PH-PLW",
        },
        {
            country: "PH",
            name: "Pampanga",
            code: "PH-PAM",
        },
        {
            country: "PH",
            name: "Pangasinan",
            code: "PH-PAN",
        },
        {
            country: "PH",
            name: "Quezon",
            code: "PH-QUE",
        },
        {
            country: "PH",
            name: "Quirino",
            code: "PH-QUI",
        },
        {
            country: "PH",
            name: "Rizal",
            code: "PH-RIZ",
        },
        {
            country: "PH",
            name: "Romblon",
            code: "PH-ROM",
        },
        {
            country: "PH",
            name: "Samar",
            code: "PH-WSA",
        },
        {
            country: "PH",
            name: "Sarangani",
            code: "PH-SAR",
        },
        {
            country: "PH",
            name: "Siquijor",
            code: "PH-SIG",
        },
        {
            country: "PH",
            name: "Sorsogon",
            code: "PH-SOR",
        },
        {
            country: "PH",
            name: "South Cotabato",
            code: "PH-SCO",
        },
        {
            country: "PH",
            name: "Southern Leyte",
            code: "PH-SLE",
        },
        {
            country: "PH",
            name: "Sultan Kudarat",
            code: "PH-SUK",
        },
        {
            country: "PH",
            name: "Sulu",
            code: "PH-SLU",
        },
        {
            country: "PH",
            name: "Surigao del Norte",
            code: "PH-SUN",
        },
        {
            country: "PH",
            name: "Surigao del Sur",
            code: "PH-SUR",
        },
        {
            country: "PH",
            name: "Tarlac",
            code: "PH-TAR",
        },
        {
            country: "PH",
            name: "Tawi-Tawi",
            code: "PH-TAW",
        },
        {
            country: "PH",
            name: "Zambales",
            code: "PH-ZMB",
        },
        {
            country: "PH",
            name: "Zamboanga Sibugay",
            code: "PH-ZSI",
        },
        {
            country: "PH",
            name: "Zamboanga del Norte",
            code: "PH-ZAN",
        },
        {
            country: "PH",
            name: "Zamboanga del Sur",
            code: "PH-ZAS",
        },
    ],
    PK: [
        {
            country: "PK",
            name: "Azad Jammu and Kashmir",
            code: "PK-JK",
        },
        {
            country: "PK",
            name: "Balochistan",
            code: "PK-BA",
        },
        {
            country: "PK",
            name: "Gilgit-Baltistan",
            code: "PK-GB",
        },
        {
            country: "PK",
            name: "Islamabad",
            code: "PK-IS",
        },
        {
            country: "PK",
            name: "Khyber Pakhtunkhwa",
            code: "PK-KP",
        },
        {
            country: "PK",
            name: "Punjab",
            code: "PK-PB",
        },
        {
            country: "PK",
            name: "Sindh",
            code: "PK-SD",
        },
    ],
    PL: [
        {
            country: "PL",
            name: "Dolnoslaskie",
            code: "PL-02",
        },
        {
            country: "PL",
            name: "Kujawsko-Pomorskie",
            code: "PL-04",
        },
        {
            country: "PL",
            name: "Lodzkie",
            code: "PL-10",
        },
        {
            country: "PL",
            name: "Lubelskie",
            code: "PL-06",
        },
        {
            country: "PL",
            name: "Lubuskie",
            code: "PL-08",
        },
        {
            country: "PL",
            name: "Malopolskie",
            code: "PL-12",
        },
        {
            country: "PL",
            name: "Mazowieckie",
            code: "PL-14",
        },
        {
            country: "PL",
            name: "Opolskie",
            code: "PL-16",
        },
        {
            country: "PL",
            name: "Podkarpackie",
            code: "PL-18",
        },
        {
            country: "PL",
            name: "Podlaskie",
            code: "PL-20",
        },
        {
            country: "PL",
            name: "Pomorskie",
            code: "PL-22",
        },
        {
            country: "PL",
            name: "Slaskie",
            code: "PL-24",
        },
        {
            country: "PL",
            name: "Swietokrzyskie",
            code: "PL-26",
        },
        {
            country: "PL",
            name: "Warminsko-Mazurskie",
            code: "PL-28",
        },
        {
            country: "PL",
            name: "Wielkopolskie",
            code: "PL-30",
        },
        {
            country: "PL",
            name: "Zachodniopomorskie",
            code: "PL-32",
        },
    ],
    PM: [
        {
            country: "PM",
            name: "Saint Pierre and Miquelon",
            code: "-",
        },
    ],
    PN: [
        {
            country: "PN",
            name: "Pitcairn",
            code: "-",
        },
    ],
    PR: [
        {
            country: "PR",
            name: "Adjuntas",
            code: "-",
        },
        {
            country: "PR",
            name: "Aguada",
            code: "-",
        },
        {
            country: "PR",
            name: "Aguadilla",
            code: "-",
        },
        {
            country: "PR",
            name: "Aguas Buenas",
            code: "-",
        },
        {
            country: "PR",
            name: "Aibonito",
            code: "-",
        },
        {
            country: "PR",
            name: "Anasco",
            code: "-",
        },
        {
            country: "PR",
            name: "Arecibo",
            code: "-",
        },
        {
            country: "PR",
            name: "Arroyo",
            code: "-",
        },
        {
            country: "PR",
            name: "Barceloneta",
            code: "-",
        },
        {
            country: "PR",
            name: "Barranquitas",
            code: "-",
        },
        {
            country: "PR",
            name: "Bayamon",
            code: "-",
        },
        {
            country: "PR",
            name: "Cabo Rojo",
            code: "-",
        },
        {
            country: "PR",
            name: "Caguas",
            code: "-",
        },
        {
            country: "PR",
            name: "Camuy",
            code: "-",
        },
        {
            country: "PR",
            name: "Canovanas",
            code: "-",
        },
        {
            country: "PR",
            name: "Carolina",
            code: "-",
        },
        {
            country: "PR",
            name: "Catano",
            code: "-",
        },
        {
            country: "PR",
            name: "Cayey",
            code: "-",
        },
        {
            country: "PR",
            name: "Ceiba",
            code: "-",
        },
        {
            country: "PR",
            name: "Ciales",
            code: "-",
        },
        {
            country: "PR",
            name: "Cidra",
            code: "-",
        },
        {
            country: "PR",
            name: "Coamo",
            code: "-",
        },
        {
            country: "PR",
            name: "Comerio",
            code: "-",
        },
        {
            country: "PR",
            name: "Corozal",
            code: "-",
        },
        {
            country: "PR",
            name: "Culebra",
            code: "-",
        },
        {
            country: "PR",
            name: "Dorado",
            code: "-",
        },
        {
            country: "PR",
            name: "Fajardo",
            code: "-",
        },
        {
            country: "PR",
            name: "Florida",
            code: "-",
        },
        {
            country: "PR",
            name: "Guanica",
            code: "-",
        },
        {
            country: "PR",
            name: "Guayama",
            code: "-",
        },
        {
            country: "PR",
            name: "Guayanilla",
            code: "-",
        },
        {
            country: "PR",
            name: "Guaynabo",
            code: "-",
        },
        {
            country: "PR",
            name: "Gurabo",
            code: "-",
        },
        {
            country: "PR",
            name: "Hatillo",
            code: "-",
        },
        {
            country: "PR",
            name: "Hormigueros",
            code: "-",
        },
        {
            country: "PR",
            name: "Humacao",
            code: "-",
        },
        {
            country: "PR",
            name: "Isabela",
            code: "-",
        },
        {
            country: "PR",
            name: "Juana Diaz",
            code: "-",
        },
        {
            country: "PR",
            name: "Lajas",
            code: "-",
        },
        {
            country: "PR",
            name: "Lares",
            code: "-",
        },
        {
            country: "PR",
            name: "Las Piedras",
            code: "-",
        },
        {
            country: "PR",
            name: "Loiza",
            code: "-",
        },
        {
            country: "PR",
            name: "Luquillo",
            code: "-",
        },
        {
            country: "PR",
            name: "Manati",
            code: "-",
        },
        {
            country: "PR",
            name: "Maunabo",
            code: "-",
        },
        {
            country: "PR",
            name: "Mayaguez",
            code: "-",
        },
        {
            country: "PR",
            name: "Moca",
            code: "-",
        },
        {
            country: "PR",
            name: "Morovis",
            code: "-",
        },
        {
            country: "PR",
            name: "Municipio de Jayuya",
            code: "-",
        },
        {
            country: "PR",
            name: "Municipio de Juncos",
            code: "-",
        },
        {
            country: "PR",
            name: "Naguabo",
            code: "-",
        },
        {
            country: "PR",
            name: "Naranjito",
            code: "-",
        },
        {
            country: "PR",
            name: "Patillas",
            code: "-",
        },
        {
            country: "PR",
            name: "Penuelas",
            code: "-",
        },
        {
            country: "PR",
            name: "Ponce",
            code: "-",
        },
        {
            country: "PR",
            name: "Quebradillas",
            code: "-",
        },
        {
            country: "PR",
            name: "Rincon",
            code: "-",
        },
        {
            country: "PR",
            name: "Rio Grande",
            code: "-",
        },
        {
            country: "PR",
            name: "Sabana Grande",
            code: "-",
        },
        {
            country: "PR",
            name: "Salinas",
            code: "-",
        },
        {
            country: "PR",
            name: "San German",
            code: "-",
        },
        {
            country: "PR",
            name: "San Juan",
            code: "-",
        },
        {
            country: "PR",
            name: "San Lorenzo",
            code: "-",
        },
        {
            country: "PR",
            name: "San Sebastian",
            code: "-",
        },
        {
            country: "PR",
            name: "Santa Isabel Municipio",
            code: "-",
        },
        {
            country: "PR",
            name: "Toa Alta",
            code: "-",
        },
        {
            country: "PR",
            name: "Toa Baja",
            code: "-",
        },
        {
            country: "PR",
            name: "Trujillo Alto",
            code: "-",
        },
        {
            country: "PR",
            name: "Utuado",
            code: "-",
        },
        {
            country: "PR",
            name: "Vega Alta",
            code: "-",
        },
        {
            country: "PR",
            name: "Vega Baja",
            code: "-",
        },
        {
            country: "PR",
            name: "Vieques",
            code: "-",
        },
        {
            country: "PR",
            name: "Villalba",
            code: "-",
        },
        {
            country: "PR",
            name: "Yabucoa",
            code: "-",
        },
        {
            country: "PR",
            name: "Yauco",
            code: "-",
        },
    ],
    PS: [
        {
            country: "PS",
            name: "Bethlehem",
            code: "PS-BTH",
        },
        {
            country: "PS",
            name: "Deir El Balah",
            code: "PS-DEB",
        },
        {
            country: "PS",
            name: "Gaza",
            code: "PS-GZA",
        },
        {
            country: "PS",
            name: "Hebron",
            code: "PS-HBN",
        },
        {
            country: "PS",
            name: "Jenin",
            code: "PS-JEN",
        },
        {
            country: "PS",
            name: "Jericho and Al Aghwar",
            code: "PS-JRH",
        },
        {
            country: "PS",
            name: "Jerusalem",
            code: "PS-JEM",
        },
        {
            country: "PS",
            name: "Khan Yunis",
            code: "PS-KYS",
        },
        {
            country: "PS",
            name: "Nablus",
            code: "PS-NBS",
        },
        {
            country: "PS",
            name: "Qalqilya",
            code: "PS-QQA",
        },
        {
            country: "PS",
            name: "Rafah",
            code: "PS-RFH",
        },
        {
            country: "PS",
            name: "Ramallah",
            code: "PS-RBH",
        },
        {
            country: "PS",
            name: "Salfit",
            code: "PS-SLT",
        },
        {
            country: "PS",
            name: "Tubas",
            code: "PS-TBS",
        },
        {
            country: "PS",
            name: "Tulkarm",
            code: "PS-TKM",
        },
    ],
    PT: [
        {
            country: "PT",
            name: "Aveiro",
            code: "PT-01",
        },
        {
            country: "PT",
            name: "Beja",
            code: "PT-02",
        },
        {
            country: "PT",
            name: "Braga",
            code: "PT-03",
        },
        {
            country: "PT",
            name: "Braganca",
            code: "PT-04",
        },
        {
            country: "PT",
            name: "Castelo Branco",
            code: "PT-05",
        },
        {
            country: "PT",
            name: "Coimbra",
            code: "PT-06",
        },
        {
            country: "PT",
            name: "Evora",
            code: "PT-07",
        },
        {
            country: "PT",
            name: "Faro",
            code: "PT-08",
        },
        {
            country: "PT",
            name: "Guarda",
            code: "PT-09",
        },
        {
            country: "PT",
            name: "Leiria",
            code: "PT-10",
        },
        {
            country: "PT",
            name: "Lisboa",
            code: "PT-11",
        },
        {
            country: "PT",
            name: "Portalegre",
            code: "PT-12",
        },
        {
            country: "PT",
            name: "Porto",
            code: "PT-13",
        },
        {
            country: "PT",
            name: "Regiao Autonoma da Madeira",
            code: "PT-30",
        },
        {
            country: "PT",
            name: "Regiao Autonoma dos Acores",
            code: "PT-20",
        },
        {
            country: "PT",
            name: "Santarem",
            code: "PT-14",
        },
        {
            country: "PT",
            name: "Setubal",
            code: "PT-15",
        },
        {
            country: "PT",
            name: "Viana do Castelo",
            code: "PT-16",
        },
        {
            country: "PT",
            name: "Vila Real",
            code: "PT-17",
        },
        {
            country: "PT",
            name: "Viseu",
            code: "PT-18",
        },
    ],
    PW: [
        {
            country: "PW",
            name: "Airai",
            code: "PW-004",
        },
        {
            country: "PW",
            name: "Koror",
            code: "PW-150",
        },
        {
            country: "PW",
            name: "Melekeok",
            code: "PW-212",
        },
        {
            country: "PW",
            name: "Ngaraard",
            code: "PW-214",
        },
        {
            country: "PW",
            name: "Ngardmau",
            code: "PW-222",
        },
        {
            country: "PW",
            name: "Ngatpang",
            code: "PW-224",
        },
        {
            country: "PW",
            name: "Sonsorol",
            code: "PW-370",
        },
    ],
    PY: [
        {
            country: "PY",
            name: "Alto Parana",
            code: "PY-10",
        },
        {
            country: "PY",
            name: "Amambay",
            code: "PY-13",
        },
        {
            country: "PY",
            name: "Asuncion",
            code: "PY-ASU",
        },
        {
            country: "PY",
            name: "Boqueron",
            code: "PY-19",
        },
        {
            country: "PY",
            name: "Caaguazu",
            code: "PY-5",
        },
        {
            country: "PY",
            name: "Caazapa",
            code: "PY-6",
        },
        {
            country: "PY",
            name: "Canindeyu",
            code: "PY-14",
        },
        {
            country: "PY",
            name: "Central",
            code: "PY-11",
        },
        {
            country: "PY",
            name: "Concepcion",
            code: "PY-1",
        },
        {
            country: "PY",
            name: "Cordillera",
            code: "PY-3",
        },
        {
            country: "PY",
            name: "Guaira",
            code: "PY-4",
        },
        {
            country: "PY",
            name: "Itapua",
            code: "PY-7",
        },
        {
            country: "PY",
            name: "Misiones",
            code: "PY-8",
        },
        {
            country: "PY",
            name: "Neembucu",
            code: "PY-12",
        },
        {
            country: "PY",
            name: "Paraguari",
            code: "PY-9",
        },
        {
            country: "PY",
            name: "Presidente Hayes",
            code: "PY-15",
        },
        {
            country: "PY",
            name: "San Pedro",
            code: "PY-2",
        },
    ],
    QA: [
        {
            country: "QA",
            name: "Ad Dawhah",
            code: "QA-DA",
        },
        {
            country: "QA",
            name: "Al Khawr wa adh Dhakhirah",
            code: "QA-KH",
        },
        {
            country: "QA",
            name: "Al Wakrah",
            code: "QA-WA",
        },
        {
            country: "QA",
            name: "Ar Rayyan",
            code: "QA-RA",
        },
        {
            country: "QA",
            name: "Ash Shamal",
            code: "QA-MS",
        },
        {
            country: "QA",
            name: "Az Za'ayin",
            code: "QA-ZA",
        },
        {
            country: "QA",
            name: "Umm Salal",
            code: "QA-US",
        },
    ],
    RE: [
        {
            country: "RE",
            name: "Reunion",
            code: "-",
        },
    ],
    RO: [
        {
            country: "RO",
            name: "Alba",
            code: "RO-AB",
        },
        {
            country: "RO",
            name: "Arad",
            code: "RO-AR",
        },
        {
            country: "RO",
            name: "Arges",
            code: "RO-AG",
        },
        {
            country: "RO",
            name: "Bacau",
            code: "RO-BC",
        },
        {
            country: "RO",
            name: "Bihor",
            code: "RO-BH",
        },
        {
            country: "RO",
            name: "Bistrita-Nasaud",
            code: "RO-BN",
        },
        {
            country: "RO",
            name: "Botosani",
            code: "RO-BT",
        },
        {
            country: "RO",
            name: "Braila",
            code: "RO-BR",
        },
        {
            country: "RO",
            name: "Brasov",
            code: "RO-BV",
        },
        {
            country: "RO",
            name: "Bucuresti",
            code: "RO-B",
        },
        {
            country: "RO",
            name: "Buzau",
            code: "RO-BZ",
        },
        {
            country: "RO",
            name: "Calarasi",
            code: "RO-CL",
        },
        {
            country: "RO",
            name: "Caras-Severin",
            code: "RO-CS",
        },
        {
            country: "RO",
            name: "Cluj",
            code: "RO-CJ",
        },
        {
            country: "RO",
            name: "Constanta",
            code: "RO-CT",
        },
        {
            country: "RO",
            name: "Covasna",
            code: "RO-CV",
        },
        {
            country: "RO",
            name: "Dambovita",
            code: "RO-DB",
        },
        {
            country: "RO",
            name: "Dolj",
            code: "RO-DJ",
        },
        {
            country: "RO",
            name: "Galati",
            code: "RO-GL",
        },
        {
            country: "RO",
            name: "Giurgiu",
            code: "RO-GR",
        },
        {
            country: "RO",
            name: "Gorj",
            code: "RO-GJ",
        },
        {
            country: "RO",
            name: "Harghita",
            code: "RO-HR",
        },
        {
            country: "RO",
            name: "Hunedoara",
            code: "RO-HD",
        },
        {
            country: "RO",
            name: "Ialomita",
            code: "RO-IL",
        },
        {
            country: "RO",
            name: "Iasi",
            code: "RO-IS",
        },
        {
            country: "RO",
            name: "Ilfov",
            code: "RO-IF",
        },
        {
            country: "RO",
            name: "Maramures",
            code: "RO-MM",
        },
        {
            country: "RO",
            name: "Mehedinti",
            code: "RO-MH",
        },
        {
            country: "RO",
            name: "Mures",
            code: "RO-MS",
        },
        {
            country: "RO",
            name: "Neamt",
            code: "RO-NT",
        },
        {
            country: "RO",
            name: "Olt",
            code: "RO-OT",
        },
        {
            country: "RO",
            name: "Prahova",
            code: "RO-PH",
        },
        {
            country: "RO",
            name: "Salaj",
            code: "RO-SJ",
        },
        {
            country: "RO",
            name: "Satu Mare",
            code: "RO-SM",
        },
        {
            country: "RO",
            name: "Sibiu",
            code: "RO-SB",
        },
        {
            country: "RO",
            name: "Suceava",
            code: "RO-SV",
        },
        {
            country: "RO",
            name: "Teleorman",
            code: "RO-TR",
        },
        {
            country: "RO",
            name: "Timis",
            code: "RO-TM",
        },
        {
            country: "RO",
            name: "Tulcea",
            code: "RO-TL",
        },
        {
            country: "RO",
            name: "Valcea",
            code: "RO-VL",
        },
        {
            country: "RO",
            name: "Vaslui",
            code: "RO-VS",
        },
        {
            country: "RO",
            name: "Vrancea",
            code: "RO-VN",
        },
    ],
    RS: [
        {
            country: "RS",
            name: "Beograd",
            code: "RS-00",
        },
        {
            country: "RS",
            name: "Borski okrug",
            code: "RS-14",
        },
        {
            country: "RS",
            name: "Branicevski okrug",
            code: "RS-11",
        },
        {
            country: "RS",
            name: "Jablanicki okrug",
            code: "RS-23",
        },
        {
            country: "RS",
            name: "Juznobacki okrug",
            code: "RS-06",
        },
        {
            country: "RS",
            name: "Juznobanatski okrug",
            code: "RS-04",
        },
        {
            country: "RS",
            name: "Kolubarski okrug",
            code: "RS-09",
        },
        {
            country: "RS",
            name: "Kosovsko-Mitrovacki okrug",
            code: "RS-28",
        },
        {
            country: "RS",
            name: "Macvanski okrug",
            code: "RS-08",
        },
        {
            country: "RS",
            name: "Moravicki okrug",
            code: "RS-17",
        },
        {
            country: "RS",
            name: "Nisavski okrug",
            code: "RS-20",
        },
        {
            country: "RS",
            name: "Pcinjski okrug",
            code: "RS-24",
        },
        {
            country: "RS",
            name: "Pecki okrug",
            code: "RS-26",
        },
        {
            country: "RS",
            name: "Pirotski okrug",
            code: "RS-22",
        },
        {
            country: "RS",
            name: "Podunavski okrug",
            code: "RS-10",
        },
        {
            country: "RS",
            name: "Pomoravski okrug",
            code: "RS-13",
        },
        {
            country: "RS",
            name: "Prizrenski okrug",
            code: "RS-27",
        },
        {
            country: "RS",
            name: "Rasinski okrug",
            code: "RS-19",
        },
        {
            country: "RS",
            name: "Raski okrug",
            code: "RS-18",
        },
        {
            country: "RS",
            name: "Severnobacki okrug",
            code: "RS-01",
        },
        {
            country: "RS",
            name: "Severnobanatski okrug",
            code: "RS-03",
        },
        {
            country: "RS",
            name: "Srednjebanatski okrug",
            code: "RS-02",
        },
        {
            country: "RS",
            name: "Sremski okrug",
            code: "RS-07",
        },
        {
            country: "RS",
            name: "Sumadijski okrug",
            code: "RS-12",
        },
        {
            country: "RS",
            name: "Toplicki okrug",
            code: "RS-21",
        },
        {
            country: "RS",
            name: "Zajecarski okrug",
            code: "RS-15",
        },
        {
            country: "RS",
            name: "Zapadnobacki okrug",
            code: "RS-05",
        },
        {
            country: "RS",
            name: "Zlatiborski okrug",
            code: "RS-16",
        },
    ],
    RU: [
        {
            country: "RU",
            name: "Adygeya, Respublika",
            code: "RU-AD",
        },
        {
            country: "RU",
            name: "Altay, Respublika",
            code: "RU-AL",
        },
        {
            country: "RU",
            name: "Altayskiy kray",
            code: "RU-ALT",
        },
        {
            country: "RU",
            name: "Amurskaya oblast'",
            code: "RU-AMU",
        },
        {
            country: "RU",
            name: "Arkhangel'skaya oblast'",
            code: "RU-ARK",
        },
        {
            country: "RU",
            name: "Astrakhanskaya oblast'",
            code: "RU-AST",
        },
        {
            country: "RU",
            name: "Bashkortostan, Respublika",
            code: "RU-BA",
        },
        {
            country: "RU",
            name: "Belgorodskaya oblast'",
            code: "RU-BEL",
        },
        {
            country: "RU",
            name: "Bryanskaya oblast'",
            code: "RU-BRY",
        },
        {
            country: "RU",
            name: "Buryatiya, Respublika",
            code: "RU-BU",
        },
        {
            country: "RU",
            name: "Chechenskaya Respublika",
            code: "RU-CE",
        },
        {
            country: "RU",
            name: "Chelyabinskaya oblast'",
            code: "RU-CHE",
        },
        {
            country: "RU",
            name: "Chukotskiy avtonomnyy okrug",
            code: "RU-CHU",
        },
        {
            country: "RU",
            name: "Chuvashskaya Respublika",
            code: "RU-CU",
        },
        {
            country: "RU",
            name: "Dagestan, Respublika",
            code: "RU-DA",
        },
        {
            country: "RU",
            name: "Ingushetiya, Respublika",
            code: "RU-IN",
        },
        {
            country: "RU",
            name: "Irkutskaya oblast'",
            code: "RU-IRK",
        },
        {
            country: "RU",
            name: "Ivanovskaya oblast'",
            code: "RU-IVA",
        },
        {
            country: "RU",
            name: "Kabardino-Balkarskaya Respublika",
            code: "RU-KB",
        },
        {
            country: "RU",
            name: "Kaliningradskaya oblast'",
            code: "RU-KGD",
        },
        {
            country: "RU",
            name: "Kalmykiya, Respublika",
            code: "RU-KL",
        },
        {
            country: "RU",
            name: "Kaluzhskaya oblast'",
            code: "RU-KLU",
        },
        {
            country: "RU",
            name: "Kamchatskiy kray",
            code: "RU-KAM",
        },
        {
            country: "RU",
            name: "Karachayevo-Cherkesskaya Respublika",
            code: "RU-KC",
        },
        {
            country: "RU",
            name: "Kareliya, Respublika",
            code: "RU-KR",
        },
        {
            country: "RU",
            name: "Kemerovskaya oblast'",
            code: "RU-KEM",
        },
        {
            country: "RU",
            name: "Khabarovskiy kray",
            code: "RU-KHA",
        },
        {
            country: "RU",
            name: "Khakasiya, Respublika",
            code: "RU-KK",
        },
        {
            country: "RU",
            name: "Khanty-Mansiyskiy avtonomnyy okrug",
            code: "RU-KHM",
        },
        {
            country: "RU",
            name: "Kirovskaya oblast'",
            code: "RU-KIR",
        },
        {
            country: "RU",
            name: "Komi, Respublika",
            code: "RU-KO",
        },
        {
            country: "RU",
            name: "Kostromskaya oblast'",
            code: "RU-KOS",
        },
        {
            country: "RU",
            name: "Krasnodarskiy kray",
            code: "RU-KDA",
        },
        {
            country: "RU",
            name: "Krasnoyarskiy kray",
            code: "RU-KYA",
        },
        {
            country: "RU",
            name: "Kurganskaya oblast'",
            code: "RU-KGN",
        },
        {
            country: "RU",
            name: "Kurskaya oblast'",
            code: "RU-KRS",
        },
        {
            country: "RU",
            name: "Leningradskaya oblast'",
            code: "RU-LEN",
        },
        {
            country: "RU",
            name: "Lipetskaya oblast'",
            code: "RU-LIP",
        },
        {
            country: "RU",
            name: "Magadanskaya oblast'",
            code: "RU-MAG",
        },
        {
            country: "RU",
            name: "Mariy El, Respublika",
            code: "RU-ME",
        },
        {
            country: "RU",
            name: "Mordoviya, Respublika",
            code: "RU-MO",
        },
        {
            country: "RU",
            name: "Moskovskaya oblast'",
            code: "RU-MOS",
        },
        {
            country: "RU",
            name: "Moskva",
            code: "RU-MOW",
        },
        {
            country: "RU",
            name: "Murmanskaya oblast'",
            code: "RU-MUR",
        },
        {
            country: "RU",
            name: "Nenetskiy avtonomnyy okrug",
            code: "RU-NEN",
        },
        {
            country: "RU",
            name: "Nizhegorodskaya oblast'",
            code: "RU-NIZ",
        },
        {
            country: "RU",
            name: "Novgorodskaya oblast'",
            code: "RU-NGR",
        },
        {
            country: "RU",
            name: "Novosibirskaya oblast'",
            code: "RU-NVS",
        },
        {
            country: "RU",
            name: "Omskaya oblast'",
            code: "RU-OMS",
        },
        {
            country: "RU",
            name: "Orenburgskaya oblast'",
            code: "RU-ORE",
        },
        {
            country: "RU",
            name: "Orlovskaya oblast'",
            code: "RU-ORL",
        },
        {
            country: "RU",
            name: "Penzenskaya oblast'",
            code: "RU-PNZ",
        },
        {
            country: "RU",
            name: "Permskiy kray",
            code: "RU-PER",
        },
        {
            country: "RU",
            name: "Primorskiy kray",
            code: "RU-PRI",
        },
        {
            country: "RU",
            name: "Pskovskaya oblast'",
            code: "RU-PSK",
        },
        {
            country: "RU",
            name: "Rostovskaya oblast'",
            code: "RU-ROS",
        },
        {
            country: "RU",
            name: "Ryazanskaya oblast'",
            code: "RU-RYA",
        },
        {
            country: "RU",
            name: "Saha, Respublika",
            code: "RU-SA",
        },
        {
            country: "RU",
            name: "Sakhalinskaya oblast'",
            code: "RU-SAK",
        },
        {
            country: "RU",
            name: "Samarskaya oblast'",
            code: "RU-SAM",
        },
        {
            country: "RU",
            name: "Sankt-Peterburg",
            code: "RU-SPE",
        },
        {
            country: "RU",
            name: "Saratovskaya oblast'",
            code: "RU-SAR",
        },
        {
            country: "RU",
            name: "Severnaya Osetiya, Respublika",
            code: "RU-SE",
        },
        {
            country: "RU",
            name: "Smolenskaya oblast'",
            code: "RU-SMO",
        },
        {
            country: "RU",
            name: "Stavropol'skiy kray",
            code: "RU-STA",
        },
        {
            country: "RU",
            name: "Sverdlovskaya oblast'",
            code: "RU-SVE",
        },
        {
            country: "RU",
            name: "Tambovskaya oblast'",
            code: "RU-TAM",
        },
        {
            country: "RU",
            name: "Tatarstan, Respublika",
            code: "RU-TA",
        },
        {
            country: "RU",
            name: "Tomskaya oblast'",
            code: "RU-TOM",
        },
        {
            country: "RU",
            name: "Tul'skaya oblast'",
            code: "RU-TUL",
        },
        {
            country: "RU",
            name: "Tverskaya oblast'",
            code: "RU-TVE",
        },
        {
            country: "RU",
            name: "Tyumenskaya oblast'",
            code: "RU-TYU",
        },
        {
            country: "RU",
            name: "Tyva, Respublika",
            code: "RU-TY",
        },
        {
            country: "RU",
            name: "Udmurtskaya Respublika",
            code: "RU-UD",
        },
        {
            country: "RU",
            name: "Ul'yanovskaya oblast'",
            code: "RU-ULY",
        },
        {
            country: "RU",
            name: "Vladimirskaya oblast'",
            code: "RU-VLA",
        },
        {
            country: "RU",
            name: "Volgogradskaya oblast'",
            code: "RU-VGG",
        },
        {
            country: "RU",
            name: "Vologodskaya oblast'",
            code: "RU-VLG",
        },
        {
            country: "RU",
            name: "Voronezhskaya oblast'",
            code: "RU-VOR",
        },
        {
            country: "RU",
            name: "Yamalo-Nenetskiy avtonomnyy okrug",
            code: "RU-YAN",
        },
        {
            country: "RU",
            name: "Yaroslavskaya oblast'",
            code: "RU-YAR",
        },
        {
            country: "RU",
            name: "Yevreyskaya avtonomnaya oblast'",
            code: "RU-YEV",
        },
        {
            country: "RU",
            name: "Zabaykal'skiy kray",
            code: "RU-ZAB",
        },
    ],
    RW: [
        {
            country: "RW",
            name: "Est",
            code: "RW-02",
        },
        {
            country: "RW",
            name: "Nord",
            code: "RW-03",
        },
        {
            country: "RW",
            name: "Ouest",
            code: "RW-04",
        },
        {
            country: "RW",
            name: "Sud",
            code: "RW-05",
        },
        {
            country: "RW",
            name: "Ville de Kigali",
            code: "RW-01",
        },
    ],
    SA: [
        {
            country: "SA",
            name: "'Asir",
            code: "SA-14",
        },
        {
            country: "SA",
            name: "Al Bahah",
            code: "SA-11",
        },
        {
            country: "SA",
            name: "Al Hudud ash Shamaliyah",
            code: "SA-08",
        },
        {
            country: "SA",
            name: "Al Jawf",
            code: "SA-12",
        },
        {
            country: "SA",
            name: "Al Madinah al Munawwarah",
            code: "SA-03",
        },
        {
            country: "SA",
            name: "Al Qasim",
            code: "SA-05",
        },
        {
            country: "SA",
            name: "Ar Riyad",
            code: "SA-01",
        },
        {
            country: "SA",
            name: "Ash Sharqiyah",
            code: "SA-04",
        },
        {
            country: "SA",
            name: "Ha'il",
            code: "SA-06",
        },
        {
            country: "SA",
            name: "Jazan",
            code: "SA-09",
        },
        {
            country: "SA",
            name: "Makkah al Mukarramah",
            code: "SA-02",
        },
        {
            country: "SA",
            name: "Najran",
            code: "SA-10",
        },
        {
            country: "SA",
            name: "Tabuk",
            code: "SA-07",
        },
    ],
    SB: [
        {
            country: "SB",
            name: "Guadalcanal",
            code: "SB-GU",
        },
        {
            country: "SB",
            name: "Makira-Ulawa",
            code: "SB-MK",
        },
        {
            country: "SB",
            name: "Western",
            code: "SB-WE",
        },
    ],
    SC: [
        {
            country: "SC",
            name: "Anse Boileau",
            code: "SC-02",
        },
        {
            country: "SC",
            name: "Anse Royale",
            code: "SC-05",
        },
        {
            country: "SC",
            name: "Anse aux Pins",
            code: "SC-01",
        },
        {
            country: "SC",
            name: "Baie Lazare",
            code: "SC-06",
        },
        {
            country: "SC",
            name: "Baie Sainte Anne",
            code: "SC-07",
        },
        {
            country: "SC",
            name: "Beau Vallon",
            code: "SC-08",
        },
        {
            country: "SC",
            name: "Bel Ombre",
            code: "SC-10",
        },
        {
            country: "SC",
            name: "Cascade",
            code: "SC-11",
        },
        {
            country: "SC",
            name: "English River",
            code: "SC-16",
        },
        {
            country: "SC",
            name: "Grand Anse Mahe",
            code: "SC-13",
        },
        {
            country: "SC",
            name: "Grand Anse Praslin",
            code: "SC-14",
        },
        {
            country: "SC",
            name: "La Digue",
            code: "SC-15",
        },
        {
            country: "SC",
            name: "Pointe Larue",
            code: "SC-20",
        },
        {
            country: "SC",
            name: "Takamaka",
            code: "SC-23",
        },
    ],
    SD: [
        {
            country: "SD",
            name: "Blue Nile",
            code: "SD-NB",
        },
        {
            country: "SD",
            name: "Central Darfur",
            code: "SD-DC",
        },
        {
            country: "SD",
            name: "Gedaref",
            code: "SD-GD",
        },
        {
            country: "SD",
            name: "Gezira",
            code: "SD-GZ",
        },
        {
            country: "SD",
            name: "Kassala",
            code: "SD-KA",
        },
        {
            country: "SD",
            name: "Khartoum",
            code: "SD-KH",
        },
        {
            country: "SD",
            name: "North Darfur",
            code: "SD-DN",
        },
        {
            country: "SD",
            name: "North Kordofan",
            code: "SD-KN",
        },
        {
            country: "SD",
            name: "Northern",
            code: "SD-NO",
        },
        {
            country: "SD",
            name: "Red Sea",
            code: "SD-RS",
        },
        {
            country: "SD",
            name: "River Nile",
            code: "SD-NR",
        },
        {
            country: "SD",
            name: "Sennar",
            code: "SD-SI",
        },
        {
            country: "SD",
            name: "South Darfur",
            code: "SD-DS",
        },
        {
            country: "SD",
            name: "South Kordofan",
            code: "SD-KS",
        },
        {
            country: "SD",
            name: "West Darfur",
            code: "SD-DW",
        },
        {
            country: "SD",
            name: "West Kordofan",
            code: "SD-GK",
        },
        {
            country: "SD",
            name: "White Nile",
            code: "SD-NW",
        },
    ],
    SE: [
        {
            country: "SE",
            name: "Blekinge lan",
            code: "SE-K",
        },
        {
            country: "SE",
            name: "Dalarnas lan",
            code: "SE-W",
        },
        {
            country: "SE",
            name: "Gavleborgs lan",
            code: "SE-X",
        },
        {
            country: "SE",
            name: "Gotlands lan",
            code: "SE-I",
        },
        {
            country: "SE",
            name: "Hallands lan",
            code: "SE-N",
        },
        {
            country: "SE",
            name: "Jamtlands lan",
            code: "SE-Z",
        },
        {
            country: "SE",
            name: "Jonkopings lan",
            code: "SE-F",
        },
        {
            country: "SE",
            name: "Kalmar lan",
            code: "SE-H",
        },
        {
            country: "SE",
            name: "Kronobergs lan",
            code: "SE-G",
        },
        {
            country: "SE",
            name: "Norrbottens lan",
            code: "SE-BD",
        },
        {
            country: "SE",
            name: "Orebro lan",
            code: "SE-T",
        },
        {
            country: "SE",
            name: "Ostergotlands lan",
            code: "SE-E",
        },
        {
            country: "SE",
            name: "Skane lan",
            code: "SE-M",
        },
        {
            country: "SE",
            name: "Sodermanlands lan",
            code: "SE-D",
        },
        {
            country: "SE",
            name: "Stockholms lan",
            code: "SE-AB",
        },
        {
            country: "SE",
            name: "Uppsala lan",
            code: "SE-C",
        },
        {
            country: "SE",
            name: "Varmlands lan",
            code: "SE-S",
        },
        {
            country: "SE",
            name: "Vasterbottens lan",
            code: "SE-AC",
        },
        {
            country: "SE",
            name: "Vasternorrlands lan",
            code: "SE-Y",
        },
        {
            country: "SE",
            name: "Vastmanlands lan",
            code: "SE-U",
        },
        {
            country: "SE",
            name: "Vastra Gotalands lan",
            code: "SE-O",
        },
    ],
    SG: [
        {
            country: "SG",
            name: "Singapore",
            code: "-",
        },
    ],
    SH: [
        {
            country: "SH",
            name: "Saint Helena",
            code: "SH-HL",
        },
    ],
    SI: [
        {
            country: "SI",
            name: "Ajdovscina",
            code: "SI-001",
        },
        {
            country: "SI",
            name: "Ankaran",
            code: "SI-213",
        },
        {
            country: "SI",
            name: "Apace",
            code: "SI-195",
        },
        {
            country: "SI",
            name: "Beltinci",
            code: "SI-002",
        },
        {
            country: "SI",
            name: "Benedikt",
            code: "SI-148",
        },
        {
            country: "SI",
            name: "Bistrica ob Sotli",
            code: "SI-149",
        },
        {
            country: "SI",
            name: "Bled",
            code: "SI-003",
        },
        {
            country: "SI",
            name: "Bloke",
            code: "SI-150",
        },
        {
            country: "SI",
            name: "Bohinj",
            code: "SI-004",
        },
        {
            country: "SI",
            name: "Borovnica",
            code: "SI-005",
        },
        {
            country: "SI",
            name: "Bovec",
            code: "SI-006",
        },
        {
            country: "SI",
            name: "Braslovce",
            code: "SI-151",
        },
        {
            country: "SI",
            name: "Brda",
            code: "SI-007",
        },
        {
            country: "SI",
            name: "Brezice",
            code: "SI-009",
        },
        {
            country: "SI",
            name: "Brezovica",
            code: "SI-008",
        },
        {
            country: "SI",
            name: "Cankova",
            code: "SI-152",
        },
        {
            country: "SI",
            name: "Celje",
            code: "SI-011",
        },
        {
            country: "SI",
            name: "Cerklje na Gorenjskem",
            code: "SI-012",
        },
        {
            country: "SI",
            name: "Cerknica",
            code: "SI-013",
        },
        {
            country: "SI",
            name: "Cerkno",
            code: "SI-014",
        },
        {
            country: "SI",
            name: "Cirkulane",
            code: "SI-196",
        },
        {
            country: "SI",
            name: "Crensovci",
            code: "SI-015",
        },
        {
            country: "SI",
            name: "Crnomelj",
            code: "SI-017",
        },
        {
            country: "SI",
            name: "Destrnik",
            code: "SI-018",
        },
        {
            country: "SI",
            name: "Divaca",
            code: "SI-019",
        },
        {
            country: "SI",
            name: "Dobje",
            code: "SI-154",
        },
        {
            country: "SI",
            name: "Dobrepolje",
            code: "SI-020",
        },
        {
            country: "SI",
            name: "Dobrna",
            code: "SI-155",
        },
        {
            country: "SI",
            name: "Dobrova-Polhov Gradec",
            code: "SI-021",
        },
        {
            country: "SI",
            name: "Dobrovnik",
            code: "SI-156",
        },
        {
            country: "SI",
            name: "Domzale",
            code: "SI-023",
        },
        {
            country: "SI",
            name: "Dornava",
            code: "SI-024",
        },
        {
            country: "SI",
            name: "Dravograd",
            code: "SI-025",
        },
        {
            country: "SI",
            name: "Duplek",
            code: "SI-026",
        },
        {
            country: "SI",
            name: "Gorje",
            code: "SI-207",
        },
        {
            country: "SI",
            name: "Gornja Radgona",
            code: "SI-029",
        },
        {
            country: "SI",
            name: "Gornji Petrovci",
            code: "SI-031",
        },
        {
            country: "SI",
            name: "Grad",
            code: "SI-158",
        },
        {
            country: "SI",
            name: "Grosuplje",
            code: "SI-032",
        },
        {
            country: "SI",
            name: "Hajdina",
            code: "SI-159",
        },
        {
            country: "SI",
            name: "Hoce-Slivnica",
            code: "SI-160",
        },
        {
            country: "SI",
            name: "Hodos",
            code: "SI-161",
        },
        {
            country: "SI",
            name: "Horjul",
            code: "SI-162",
        },
        {
            country: "SI",
            name: "Hrastnik",
            code: "SI-034",
        },
        {
            country: "SI",
            name: "Hrpelje-Kozina",
            code: "SI-035",
        },
        {
            country: "SI",
            name: "Idrija",
            code: "SI-036",
        },
        {
            country: "SI",
            name: "Ig",
            code: "SI-037",
        },
        {
            country: "SI",
            name: "Ilirska Bistrica",
            code: "SI-038",
        },
        {
            country: "SI",
            name: "Ivancna Gorica",
            code: "SI-039",
        },
        {
            country: "SI",
            name: "Izola",
            code: "SI-040",
        },
        {
            country: "SI",
            name: "Jesenice",
            code: "SI-041",
        },
        {
            country: "SI",
            name: "Jursinci",
            code: "SI-042",
        },
        {
            country: "SI",
            name: "Kamnik",
            code: "SI-043",
        },
        {
            country: "SI",
            name: "Kanal",
            code: "SI-044",
        },
        {
            country: "SI",
            name: "Kidricevo",
            code: "SI-045",
        },
        {
            country: "SI",
            name: "Kobarid",
            code: "SI-046",
        },
        {
            country: "SI",
            name: "Kobilje",
            code: "SI-047",
        },
        {
            country: "SI",
            name: "Kocevje",
            code: "SI-048",
        },
        {
            country: "SI",
            name: "Komen",
            code: "SI-049",
        },
        {
            country: "SI",
            name: "Komenda",
            code: "SI-164",
        },
        {
            country: "SI",
            name: "Koper",
            code: "SI-050",
        },
        {
            country: "SI",
            name: "Kosanjevica na Krki",
            code: "SI-197",
        },
        {
            country: "SI",
            name: "Kostel",
            code: "SI-165",
        },
        {
            country: "SI",
            name: "Kranj",
            code: "SI-052",
        },
        {
            country: "SI",
            name: "Kranjska Gora",
            code: "SI-053",
        },
        {
            country: "SI",
            name: "Krizevci",
            code: "SI-166",
        },
        {
            country: "SI",
            name: "Krsko",
            code: "SI-054",
        },
        {
            country: "SI",
            name: "Kungota",
            code: "SI-055",
        },
        {
            country: "SI",
            name: "Kuzma",
            code: "SI-056",
        },
        {
            country: "SI",
            name: "Lasko",
            code: "SI-057",
        },
        {
            country: "SI",
            name: "Lenart",
            code: "SI-058",
        },
        {
            country: "SI",
            name: "Lendava",
            code: "SI-059",
        },
        {
            country: "SI",
            name: "Litija",
            code: "SI-060",
        },
        {
            country: "SI",
            name: "Ljubljana",
            code: "SI-061",
        },
        {
            country: "SI",
            name: "Ljutomer",
            code: "SI-063",
        },
        {
            country: "SI",
            name: "Log-Dragomer",
            code: "SI-208",
        },
        {
            country: "SI",
            name: "Logatec",
            code: "SI-064",
        },
        {
            country: "SI",
            name: "Loska dolina",
            code: "SI-065",
        },
        {
            country: "SI",
            name: "Loski Potok",
            code: "SI-066",
        },
        {
            country: "SI",
            name: "Lovrenc na Pohorju",
            code: "SI-167",
        },
        {
            country: "SI",
            name: "Luce",
            code: "SI-067",
        },
        {
            country: "SI",
            name: "Lukovica",
            code: "SI-068",
        },
        {
            country: "SI",
            name: "Majsperk",
            code: "SI-069",
        },
        {
            country: "SI",
            name: "Makole",
            code: "SI-198",
        },
        {
            country: "SI",
            name: "Maribor",
            code: "SI-070",
        },
        {
            country: "SI",
            name: "Markovci",
            code: "SI-168",
        },
        {
            country: "SI",
            name: "Medvode",
            code: "SI-071",
        },
        {
            country: "SI",
            name: "Menges",
            code: "SI-072",
        },
        {
            country: "SI",
            name: "Metlika",
            code: "SI-073",
        },
        {
            country: "SI",
            name: "Mezica",
            code: "SI-074",
        },
        {
            country: "SI",
            name: "Miklavz na Dravskem polju",
            code: "SI-169",
        },
        {
            country: "SI",
            name: "Miren-Kostanjevica",
            code: "SI-075",
        },
        {
            country: "SI",
            name: "Mirna",
            code: "SI-212",
        },
        {
            country: "SI",
            name: "Mirna Pec",
            code: "SI-170",
        },
        {
            country: "SI",
            name: "Mislinja",
            code: "SI-076",
        },
        {
            country: "SI",
            name: "Mokronog-Trebelno",
            code: "SI-199",
        },
        {
            country: "SI",
            name: "Moravce",
            code: "SI-077",
        },
        {
            country: "SI",
            name: "Mozirje",
            code: "SI-079",
        },
        {
            country: "SI",
            name: "Murska Sobota",
            code: "SI-080",
        },
        {
            country: "SI",
            name: "Muta",
            code: "SI-081",
        },
        {
            country: "SI",
            name: "Naklo",
            code: "SI-082",
        },
        {
            country: "SI",
            name: "Nazarje",
            code: "SI-083",
        },
        {
            country: "SI",
            name: "Nova Gorica",
            code: "SI-084",
        },
        {
            country: "SI",
            name: "Novo Mesto",
            code: "SI-085",
        },
        {
            country: "SI",
            name: "Odranci",
            code: "SI-086",
        },
        {
            country: "SI",
            name: "Oplotnica",
            code: "SI-171",
        },
        {
            country: "SI",
            name: "Ormoz",
            code: "SI-087",
        },
        {
            country: "SI",
            name: "Piran",
            code: "SI-090",
        },
        {
            country: "SI",
            name: "Pivka",
            code: "SI-091",
        },
        {
            country: "SI",
            name: "Podcetrtek",
            code: "SI-092",
        },
        {
            country: "SI",
            name: "Podlehnik",
            code: "SI-172",
        },
        {
            country: "SI",
            name: "Poljcane",
            code: "SI-200",
        },
        {
            country: "SI",
            name: "Polzela",
            code: "SI-173",
        },
        {
            country: "SI",
            name: "Postojna",
            code: "SI-094",
        },
        {
            country: "SI",
            name: "Prebold",
            code: "SI-174",
        },
        {
            country: "SI",
            name: "Preddvor",
            code: "SI-095",
        },
        {
            country: "SI",
            name: "Prevalje",
            code: "SI-175",
        },
        {
            country: "SI",
            name: "Ptuj",
            code: "SI-096",
        },
        {
            country: "SI",
            name: "Puconci",
            code: "SI-097",
        },
        {
            country: "SI",
            name: "Race-Fram",
            code: "SI-098",
        },
        {
            country: "SI",
            name: "Radece",
            code: "SI-099",
        },
        {
            country: "SI",
            name: "Radenci",
            code: "SI-100",
        },
        {
            country: "SI",
            name: "Radlje ob Dravi",
            code: "SI-101",
        },
        {
            country: "SI",
            name: "Radovljica",
            code: "SI-102",
        },
        {
            country: "SI",
            name: "Ravne na Koroskem",
            code: "SI-103",
        },
        {
            country: "SI",
            name: "Razkrizje",
            code: "SI-176",
        },
        {
            country: "SI",
            name: "Recica ob Savinji",
            code: "SI-209",
        },
        {
            country: "SI",
            name: "Rence-Vogrsko",
            code: "SI-201",
        },
        {
            country: "SI",
            name: "Ribnica",
            code: "SI-104",
        },
        {
            country: "SI",
            name: "Rogaska Slatina",
            code: "SI-106",
        },
        {
            country: "SI",
            name: "Rogasovci",
            code: "SI-105",
        },
        {
            country: "SI",
            name: "Ruse",
            code: "SI-108",
        },
        {
            country: "SI",
            name: "Salovci",
            code: "SI-033",
        },
        {
            country: "SI",
            name: "Semic",
            code: "SI-109",
        },
        {
            country: "SI",
            name: "Sempeter-Vrtojba",
            code: "SI-183",
        },
        {
            country: "SI",
            name: "Sencur",
            code: "SI-117",
        },
        {
            country: "SI",
            name: "Sentilj",
            code: "SI-118",
        },
        {
            country: "SI",
            name: "Sentjernej",
            code: "SI-119",
        },
        {
            country: "SI",
            name: "Sentjur",
            code: "SI-120",
        },
        {
            country: "SI",
            name: "Sentrupert",
            code: "SI-211",
        },
        {
            country: "SI",
            name: "Sevnica",
            code: "SI-110",
        },
        {
            country: "SI",
            name: "Sezana",
            code: "SI-111",
        },
        {
            country: "SI",
            name: "Skocjan",
            code: "SI-121",
        },
        {
            country: "SI",
            name: "Skofja Loka",
            code: "SI-122",
        },
        {
            country: "SI",
            name: "Skofljica",
            code: "SI-123",
        },
        {
            country: "SI",
            name: "Slovenj Gradec",
            code: "SI-112",
        },
        {
            country: "SI",
            name: "Slovenska Bistrica",
            code: "SI-113",
        },
        {
            country: "SI",
            name: "Slovenske Konjice",
            code: "SI-114",
        },
        {
            country: "SI",
            name: "Smarje pri Jelsah",
            code: "SI-124",
        },
        {
            country: "SI",
            name: "Smarjeske Toplice",
            code: "SI-206",
        },
        {
            country: "SI",
            name: "Smartno ob Paki",
            code: "SI-125",
        },
        {
            country: "SI",
            name: "Smartno pri Litiji",
            code: "SI-194",
        },
        {
            country: "SI",
            name: "Sodrazica",
            code: "SI-179",
        },
        {
            country: "SI",
            name: "Solcava",
            code: "SI-180",
        },
        {
            country: "SI",
            name: "Sostanj",
            code: "SI-126",
        },
        {
            country: "SI",
            name: "Starse",
            code: "SI-115",
        },
        {
            country: "SI",
            name: "Store",
            code: "SI-127",
        },
        {
            country: "SI",
            name: "Straza",
            code: "SI-203",
        },
        {
            country: "SI",
            name: "Sveta Trojica v Slovenskih goricah",
            code: "SI-204",
        },
        {
            country: "SI",
            name: "Sveti Andraz v Slovenskih Goricah",
            code: "SI-182",
        },
        {
            country: "SI",
            name: "Sveti Jurij ob Scavnici",
            code: "SI-116",
        },
        {
            country: "SI",
            name: "Sveti Jurij v Slovenskih goricah",
            code: "SI-210",
        },
        {
            country: "SI",
            name: "Sveti Tomaz",
            code: "SI-205",
        },
        {
            country: "SI",
            name: "Tabor",
            code: "SI-184",
        },
        {
            country: "SI",
            name: "Tisina",
            code: "SI-010",
        },
        {
            country: "SI",
            name: "Tolmin",
            code: "SI-128",
        },
        {
            country: "SI",
            name: "Trbovlje",
            code: "SI-129",
        },
        {
            country: "SI",
            name: "Trebnje",
            code: "SI-130",
        },
        {
            country: "SI",
            name: "Trnovska Vas",
            code: "SI-185",
        },
        {
            country: "SI",
            name: "Trzic",
            code: "SI-131",
        },
        {
            country: "SI",
            name: "Trzin",
            code: "SI-186",
        },
        {
            country: "SI",
            name: "Turnisce",
            code: "SI-132",
        },
        {
            country: "SI",
            name: "Velenje",
            code: "SI-133",
        },
        {
            country: "SI",
            name: "Velika Polana",
            code: "SI-187",
        },
        {
            country: "SI",
            name: "Velike Lasce",
            code: "SI-134",
        },
        {
            country: "SI",
            name: "Verzej",
            code: "SI-188",
        },
        {
            country: "SI",
            name: "Videm",
            code: "SI-135",
        },
        {
            country: "SI",
            name: "Vipava",
            code: "SI-136",
        },
        {
            country: "SI",
            name: "Vitanje",
            code: "SI-137",
        },
        {
            country: "SI",
            name: "Vodice",
            code: "SI-138",
        },
        {
            country: "SI",
            name: "Vojnik",
            code: "SI-139",
        },
        {
            country: "SI",
            name: "Vransko",
            code: "SI-189",
        },
        {
            country: "SI",
            name: "Vrhnika",
            code: "SI-140",
        },
        {
            country: "SI",
            name: "Vuzenica",
            code: "SI-141",
        },
        {
            country: "SI",
            name: "Zagorje ob Savi",
            code: "SI-142",
        },
        {
            country: "SI",
            name: "Zalec",
            code: "SI-190",
        },
        {
            country: "SI",
            name: "Zavrc",
            code: "SI-143",
        },
        {
            country: "SI",
            name: "Zelezniki",
            code: "SI-146",
        },
        {
            country: "SI",
            name: "Zetale",
            code: "SI-191",
        },
        {
            country: "SI",
            name: "Ziri",
            code: "SI-147",
        },
        {
            country: "SI",
            name: "Zrece",
            code: "SI-144",
        },
        {
            country: "SI",
            name: "Zuzemberk",
            code: "SI-193",
        },
    ],
    SJ: [
        {
            country: "SJ",
            name: "Svalbard and Jan Mayen",
            code: "-",
        },
    ],
    SK: [
        {
            country: "SK",
            name: "Banskobystricky kraj",
            code: "SK-BC",
        },
        {
            country: "SK",
            name: "Bratislavsky kraj",
            code: "SK-BL",
        },
        {
            country: "SK",
            name: "Kosicky kraj",
            code: "SK-KI",
        },
        {
            country: "SK",
            name: "Nitriansky kraj",
            code: "SK-NI",
        },
        {
            country: "SK",
            name: "Presovsky kraj",
            code: "SK-PV",
        },
        {
            country: "SK",
            name: "Trenciansky kraj",
            code: "SK-TC",
        },
        {
            country: "SK",
            name: "Trnavsky kraj",
            code: "SK-TA",
        },
        {
            country: "SK",
            name: "Zilinsky kraj",
            code: "SK-ZI",
        },
    ],
    SL: [
        {
            country: "SL",
            name: "Eastern",
            code: "SL-E",
        },
        {
            country: "SL",
            name: "North Western",
            code: "SL-NW",
        },
        {
            country: "SL",
            name: "Northern",
            code: "SL-N",
        },
        {
            country: "SL",
            name: "Southern",
            code: "SL-S",
        },
        {
            country: "SL",
            name: "Western Area",
            code: "SL-W",
        },
    ],
    SM: [
        {
            country: "SM",
            name: "Chiesanuova",
            code: "SM-02",
        },
        {
            country: "SM",
            name: "Citta di San Marino",
            code: "SM-07",
        },
        {
            country: "SM",
            name: "Faetano",
            code: "SM-04",
        },
        {
            country: "SM",
            name: "Serravalle",
            code: "SM-09",
        },
    ],
    SN: [
        {
            country: "SN",
            name: "Dakar",
            code: "SN-DK",
        },
        {
            country: "SN",
            name: "Diourbel",
            code: "SN-DB",
        },
        {
            country: "SN",
            name: "Fatick",
            code: "SN-FK",
        },
        {
            country: "SN",
            name: "Kaffrine",
            code: "SN-KA",
        },
        {
            country: "SN",
            name: "Kaolack",
            code: "SN-KL",
        },
        {
            country: "SN",
            name: "Kedougou",
            code: "SN-KE",
        },
        {
            country: "SN",
            name: "Louga",
            code: "SN-LG",
        },
        {
            country: "SN",
            name: "Matam",
            code: "SN-MT",
        },
        {
            country: "SN",
            name: "Saint-Louis",
            code: "SN-SL",
        },
        {
            country: "SN",
            name: "Tambacounda",
            code: "SN-TC",
        },
        {
            country: "SN",
            name: "Thies",
            code: "SN-TH",
        },
        {
            country: "SN",
            name: "Ziguinchor",
            code: "SN-ZG",
        },
    ],
    SO: [
        {
            country: "SO",
            name: "Awdal",
            code: "SO-AW",
        },
        {
            country: "SO",
            name: "Banaadir",
            code: "SO-BN",
        },
        {
            country: "SO",
            name: "Bari",
            code: "SO-BR",
        },
        {
            country: "SO",
            name: "Bay",
            code: "SO-BY",
        },
        {
            country: "SO",
            name: "Galguduud",
            code: "SO-GA",
        },
        {
            country: "SO",
            name: "Hiiraan",
            code: "SO-HI",
        },
        {
            country: "SO",
            name: "Jubbada Hoose",
            code: "SO-JH",
        },
        {
            country: "SO",
            name: "Mudug",
            code: "SO-MU",
        },
        {
            country: "SO",
            name: "Nugaal",
            code: "SO-NU",
        },
        {
            country: "SO",
            name: "Sanaag",
            code: "SO-SA",
        },
        {
            country: "SO",
            name: "Sool",
            code: "SO-SO",
        },
        {
            country: "SO",
            name: "Togdheer",
            code: "SO-TO",
        },
        {
            country: "SO",
            name: "Woqooyi Galbeed",
            code: "SO-WO",
        },
    ],
    SR: [
        {
            country: "SR",
            name: "Brokopondo",
            code: "SR-BR",
        },
        {
            country: "SR",
            name: "Commewijne",
            code: "SR-CM",
        },
        {
            country: "SR",
            name: "Coronie",
            code: "SR-CR",
        },
        {
            country: "SR",
            name: "Nickerie",
            code: "SR-NI",
        },
        {
            country: "SR",
            name: "Para",
            code: "SR-PR",
        },
        {
            country: "SR",
            name: "Paramaribo",
            code: "SR-PM",
        },
        {
            country: "SR",
            name: "Saramacca",
            code: "SR-SA",
        },
        {
            country: "SR",
            name: "Sipaliwini",
            code: "SR-SI",
        },
        {
            country: "SR",
            name: "Wanica",
            code: "SR-WA",
        },
    ],
    SS: [
        {
            country: "SS",
            name: "Central Equatoria",
            code: "SS-EC",
        },
        {
            country: "SS",
            name: "Eastern Equatoria",
            code: "SS-EE",
        },
        {
            country: "SS",
            name: "Jonglei",
            code: "SS-JG",
        },
        {
            country: "SS",
            name: "Northern Bahr el Ghazal",
            code: "SS-BN",
        },
        {
            country: "SS",
            name: "Unity",
            code: "SS-UY",
        },
        {
            country: "SS",
            name: "Upper Nile",
            code: "SS-NU",
        },
        {
            country: "SS",
            name: "Warrap",
            code: "SS-WR",
        },
        {
            country: "SS",
            name: "Western Bahr el Ghazal",
            code: "SS-BW",
        },
        {
            country: "SS",
            name: "Western Equatoria",
            code: "SS-EW",
        },
    ],
    ST: [
        {
            country: "ST",
            name: "Agua Grande",
            code: "ST-01",
        },
        {
            country: "ST",
            name: "Principe",
            code: "ST-P",
        },
    ],
    SV: [
        {
            country: "SV",
            name: "Ahuachapan",
            code: "SV-AH",
        },
        {
            country: "SV",
            name: "Cabanas",
            code: "SV-CA",
        },
        {
            country: "SV",
            name: "Chalatenango",
            code: "SV-CH",
        },
        {
            country: "SV",
            name: "Cuscatlan",
            code: "SV-CU",
        },
        {
            country: "SV",
            name: "La Libertad",
            code: "SV-LI",
        },
        {
            country: "SV",
            name: "La Paz",
            code: "SV-PA",
        },
        {
            country: "SV",
            name: "La Union",
            code: "SV-UN",
        },
        {
            country: "SV",
            name: "Morazan",
            code: "SV-MO",
        },
        {
            country: "SV",
            name: "San Miguel",
            code: "SV-SM",
        },
        {
            country: "SV",
            name: "San Salvador",
            code: "SV-SS",
        },
        {
            country: "SV",
            name: "San Vicente",
            code: "SV-SV",
        },
        {
            country: "SV",
            name: "Santa Ana",
            code: "SV-SA",
        },
        {
            country: "SV",
            name: "Sonsonate",
            code: "SV-SO",
        },
        {
            country: "SV",
            name: "Usulutan",
            code: "SV-US",
        },
    ],
    SX: [
        {
            country: "SX",
            name: "Sint Maarten (Dutch Part)",
            code: "-",
        },
    ],
    SY: [
        {
            country: "SY",
            name: "Al Hasakah",
            code: "SY-HA",
        },
        {
            country: "SY",
            name: "Al Ladhiqiyah",
            code: "SY-LA",
        },
        {
            country: "SY",
            name: "Al Qunaytirah",
            code: "SY-QU",
        },
        {
            country: "SY",
            name: "Ar Raqqah",
            code: "SY-RA",
        },
        {
            country: "SY",
            name: "As Suwayda'",
            code: "SY-SU",
        },
        {
            country: "SY",
            name: "Dar'a",
            code: "SY-DR",
        },
        {
            country: "SY",
            name: "Dayr az Zawr",
            code: "SY-DY",
        },
        {
            country: "SY",
            name: "Dimashq",
            code: "SY-DI",
        },
        {
            country: "SY",
            name: "Halab",
            code: "SY-HL",
        },
        {
            country: "SY",
            name: "Hamah",
            code: "SY-HM",
        },
        {
            country: "SY",
            name: "Hims",
            code: "SY-HI",
        },
        {
            country: "SY",
            name: "Idlib",
            code: "SY-ID",
        },
        {
            country: "SY",
            name: "Rif Dimashq",
            code: "SY-RD",
        },
        {
            country: "SY",
            name: "Tartus",
            code: "SY-TA",
        },
    ],
    SZ: [
        {
            country: "SZ",
            name: "Hhohho",
            code: "SZ-HH",
        },
        {
            country: "SZ",
            name: "Lubombo",
            code: "SZ-LU",
        },
        {
            country: "SZ",
            name: "Manzini",
            code: "SZ-MA",
        },
    ],
    TC: [
        {
            country: "TC",
            name: "Turks and Caicos Islands",
            code: "-",
        },
    ],
    TD: [
        {
            country: "TD",
            name: "Bahr el Ghazal",
            code: "TD-BG",
        },
        {
            country: "TD",
            name: "Chari-Baguirmi",
            code: "TD-CB",
        },
        {
            country: "TD",
            name: "Guera",
            code: "TD-GR",
        },
        {
            country: "TD",
            name: "Lac",
            code: "TD-LC",
        },
        {
            country: "TD",
            name: "Logone-Occidental",
            code: "TD-LO",
        },
        {
            country: "TD",
            name: "Sila",
            code: "TD-SI",
        },
        {
            country: "TD",
            name: "Ville de Ndjamena",
            code: "TD-ND",
        },
    ],
    TF: [
        {
            country: "TF",
            name: "French Southern Territories",
            code: "-",
        },
    ],
    TG: [
        {
            country: "TG",
            name: "Centrale",
            code: "TG-C",
        },
        {
            country: "TG",
            name: "Kara",
            code: "TG-K",
        },
        {
            country: "TG",
            name: "Maritime",
            code: "TG-M",
        },
        {
            country: "TG",
            name: "Plateaux",
            code: "TG-P",
        },
        {
            country: "TG",
            name: "Savanes",
            code: "TG-S",
        },
    ],
    TH: [
        {
            country: "TH",
            name: "Amnat Charoen",
            code: "TH-37",
        },
        {
            country: "TH",
            name: "Ang Thong",
            code: "TH-15",
        },
        {
            country: "TH",
            name: "Bueng Kan",
            code: "TH-38",
        },
        {
            country: "TH",
            name: "Buri Ram",
            code: "TH-31",
        },
        {
            country: "TH",
            name: "Chachoengsao",
            code: "TH-24",
        },
        {
            country: "TH",
            name: "Chai Nat",
            code: "TH-18",
        },
        {
            country: "TH",
            name: "Chaiyaphum",
            code: "TH-36",
        },
        {
            country: "TH",
            name: "Chanthaburi",
            code: "TH-22",
        },
        {
            country: "TH",
            name: "Chiang Mai",
            code: "TH-50",
        },
        {
            country: "TH",
            name: "Chiang Rai",
            code: "TH-57",
        },
        {
            country: "TH",
            name: "Chon Buri",
            code: "TH-20",
        },
        {
            country: "TH",
            name: "Chumphon",
            code: "TH-86",
        },
        {
            country: "TH",
            name: "Kalasin",
            code: "TH-46",
        },
        {
            country: "TH",
            name: "Kamphaeng Phet",
            code: "TH-62",
        },
        {
            country: "TH",
            name: "Kanchanaburi",
            code: "TH-71",
        },
        {
            country: "TH",
            name: "Khon Kaen",
            code: "TH-40",
        },
        {
            country: "TH",
            name: "Krabi",
            code: "TH-81",
        },
        {
            country: "TH",
            name: "Krung Thep Maha Nakhon",
            code: "TH-10",
        },
        {
            country: "TH",
            name: "Lampang",
            code: "TH-52",
        },
        {
            country: "TH",
            name: "Lamphun",
            code: "TH-51",
        },
        {
            country: "TH",
            name: "Loei",
            code: "TH-42",
        },
        {
            country: "TH",
            name: "Lop Buri",
            code: "TH-16",
        },
        {
            country: "TH",
            name: "Mae Hong Son",
            code: "TH-58",
        },
        {
            country: "TH",
            name: "Maha Sarakham",
            code: "TH-44",
        },
        {
            country: "TH",
            name: "Mukdahan",
            code: "TH-49",
        },
        {
            country: "TH",
            name: "Nakhon Nayok",
            code: "TH-26",
        },
        {
            country: "TH",
            name: "Nakhon Pathom",
            code: "TH-73",
        },
        {
            country: "TH",
            name: "Nakhon Phanom",
            code: "TH-48",
        },
        {
            country: "TH",
            name: "Nakhon Ratchasima",
            code: "TH-30",
        },
        {
            country: "TH",
            name: "Nakhon Sawan",
            code: "TH-60",
        },
        {
            country: "TH",
            name: "Nakhon Si Thammarat",
            code: "TH-80",
        },
        {
            country: "TH",
            name: "Nan",
            code: "TH-55",
        },
        {
            country: "TH",
            name: "Narathiwat",
            code: "TH-96",
        },
        {
            country: "TH",
            name: "Nong Bua Lam Phu",
            code: "TH-39",
        },
        {
            country: "TH",
            name: "Nong Khai",
            code: "TH-43",
        },
        {
            country: "TH",
            name: "Nonthaburi",
            code: "TH-12",
        },
        {
            country: "TH",
            name: "Pathum Thani",
            code: "TH-13",
        },
        {
            country: "TH",
            name: "Pattani",
            code: "TH-94",
        },
        {
            country: "TH",
            name: "Phangnga",
            code: "TH-82",
        },
        {
            country: "TH",
            name: "Phatthalung",
            code: "TH-93",
        },
        {
            country: "TH",
            name: "Phayao",
            code: "TH-56",
        },
        {
            country: "TH",
            name: "Phetchabun",
            code: "TH-67",
        },
        {
            country: "TH",
            name: "Phetchaburi",
            code: "TH-76",
        },
        {
            country: "TH",
            name: "Phichit",
            code: "TH-66",
        },
        {
            country: "TH",
            name: "Phitsanulok",
            code: "TH-65",
        },
        {
            country: "TH",
            name: "Phra Nakhon Si Ayutthaya",
            code: "TH-14",
        },
        {
            country: "TH",
            name: "Phrae",
            code: "TH-54",
        },
        {
            country: "TH",
            name: "Phuket",
            code: "TH-83",
        },
        {
            country: "TH",
            name: "Prachin Buri",
            code: "TH-25",
        },
        {
            country: "TH",
            name: "Prachuap Khiri Khan",
            code: "TH-77",
        },
        {
            country: "TH",
            name: "Ranong",
            code: "TH-85",
        },
        {
            country: "TH",
            name: "Ratchaburi",
            code: "TH-70",
        },
        {
            country: "TH",
            name: "Rayong",
            code: "TH-21",
        },
        {
            country: "TH",
            name: "Roi Et",
            code: "TH-45",
        },
        {
            country: "TH",
            name: "Sa Kaeo",
            code: "TH-27",
        },
        {
            country: "TH",
            name: "Sakon Nakhon",
            code: "TH-47",
        },
        {
            country: "TH",
            name: "Samut Prakan",
            code: "TH-11",
        },
        {
            country: "TH",
            name: "Samut Sakhon",
            code: "TH-74",
        },
        {
            country: "TH",
            name: "Samut Songkhram",
            code: "TH-75",
        },
        {
            country: "TH",
            name: "Saraburi",
            code: "TH-19",
        },
        {
            country: "TH",
            name: "Satun",
            code: "TH-91",
        },
        {
            country: "TH",
            name: "Si Sa Ket",
            code: "TH-33",
        },
        {
            country: "TH",
            name: "Sing Buri",
            code: "TH-17",
        },
        {
            country: "TH",
            name: "Songkhla",
            code: "TH-90",
        },
        {
            country: "TH",
            name: "Sukhothai",
            code: "TH-64",
        },
        {
            country: "TH",
            name: "Suphan Buri",
            code: "TH-72",
        },
        {
            country: "TH",
            name: "Surat Thani",
            code: "TH-84",
        },
        {
            country: "TH",
            name: "Surin",
            code: "TH-32",
        },
        {
            country: "TH",
            name: "Tak",
            code: "TH-63",
        },
        {
            country: "TH",
            name: "Trang",
            code: "TH-92",
        },
        {
            country: "TH",
            name: "Trat",
            code: "TH-23",
        },
        {
            country: "TH",
            name: "Ubon Ratchathani",
            code: "TH-34",
        },
        {
            country: "TH",
            name: "Udon Thani",
            code: "TH-41",
        },
        {
            country: "TH",
            name: "Uthai Thani",
            code: "TH-61",
        },
        {
            country: "TH",
            name: "Uttaradit",
            code: "TH-53",
        },
        {
            country: "TH",
            name: "Yala",
            code: "TH-95",
        },
        {
            country: "TH",
            name: "Yasothon",
            code: "TH-35",
        },
    ],
    TJ: [
        {
            country: "TJ",
            name: "Dushanbe",
            code: "TJ-DU",
        },
        {
            country: "TJ",
            name: "Khatlon",
            code: "TJ-KT",
        },
        {
            country: "TJ",
            name: "Kuhistoni Badakhshon",
            code: "TJ-GB",
        },
        {
            country: "TJ",
            name: "Nohiyahoi Tobei Jumhuri",
            code: "TJ-RA",
        },
        {
            country: "TJ",
            name: "Sughd",
            code: "TJ-SU",
        },
    ],
    TK: [
        {
            country: "TK",
            name: "Tokelau",
            code: "-",
        },
    ],
    TL: [
        {
            country: "TL",
            name: "Ainaro",
            code: "TL-AN",
        },
        {
            country: "TL",
            name: "Bobonaro",
            code: "TL-BO",
        },
        {
            country: "TL",
            name: "Dili",
            code: "TL-DI",
        },
        {
            country: "TL",
            name: "Ermera",
            code: "TL-ER",
        },
        {
            country: "TL",
            name: "Liquica",
            code: "TL-LI",
        },
        {
            country: "TL",
            name: "Viqueque",
            code: "TL-VI",
        },
    ],
    TM: [
        {
            country: "TM",
            name: "Ahal",
            code: "TM-A",
        },
        {
            country: "TM",
            name: "Balkan",
            code: "TM-B",
        },
        {
            country: "TM",
            name: "Dasoguz",
            code: "TM-D",
        },
        {
            country: "TM",
            name: "Lebap",
            code: "TM-L",
        },
        {
            country: "TM",
            name: "Mary",
            code: "TM-M",
        },
    ],
    TN: [
        {
            country: "TN",
            name: "Beja",
            code: "TN-31",
        },
        {
            country: "TN",
            name: "Ben Arous",
            code: "TN-13",
        },
        {
            country: "TN",
            name: "Bizerte",
            code: "TN-23",
        },
        {
            country: "TN",
            name: "Gabes",
            code: "TN-81",
        },
        {
            country: "TN",
            name: "Gafsa",
            code: "TN-71",
        },
        {
            country: "TN",
            name: "Jendouba",
            code: "TN-32",
        },
        {
            country: "TN",
            name: "Kairouan",
            code: "TN-41",
        },
        {
            country: "TN",
            name: "Kasserine",
            code: "TN-42",
        },
        {
            country: "TN",
            name: "Kebili",
            code: "TN-73",
        },
        {
            country: "TN",
            name: "L'Ariana",
            code: "TN-12",
        },
        {
            country: "TN",
            name: "La Manouba",
            code: "TN-14",
        },
        {
            country: "TN",
            name: "Le Kef",
            code: "TN-33",
        },
        {
            country: "TN",
            name: "Mahdia",
            code: "TN-53",
        },
        {
            country: "TN",
            name: "Medenine",
            code: "TN-82",
        },
        {
            country: "TN",
            name: "Monastir",
            code: "TN-52",
        },
        {
            country: "TN",
            name: "Nabeul",
            code: "TN-21",
        },
        {
            country: "TN",
            name: "Sfax",
            code: "TN-61",
        },
        {
            country: "TN",
            name: "Sidi Bouzid",
            code: "TN-43",
        },
        {
            country: "TN",
            name: "Siliana",
            code: "TN-34",
        },
        {
            country: "TN",
            name: "Sousse",
            code: "TN-51",
        },
        {
            country: "TN",
            name: "Tataouine",
            code: "TN-83",
        },
        {
            country: "TN",
            name: "Tozeur",
            code: "TN-72",
        },
        {
            country: "TN",
            name: "Tunis",
            code: "TN-11",
        },
        {
            country: "TN",
            name: "Zaghouan",
            code: "TN-22",
        },
    ],
    TO: [
        {
            country: "TO",
            name: "'Eua",
            code: "TO-01",
        },
        {
            country: "TO",
            name: "Ha'apai",
            code: "TO-02",
        },
        {
            country: "TO",
            name: "Niuas",
            code: "TO-03",
        },
        {
            country: "TO",
            name: "Tongatapu",
            code: "TO-04",
        },
        {
            country: "TO",
            name: "Vava'u",
            code: "TO-05",
        },
    ],
    TR: [
        {
            country: "TR",
            name: "Adana",
            code: "TR-01",
        },
        {
            country: "TR",
            name: "Adiyaman",
            code: "TR-02",
        },
        {
            country: "TR",
            name: "Afyonkarahisar",
            code: "TR-03",
        },
        {
            country: "TR",
            name: "Agri",
            code: "TR-04",
        },
        {
            country: "TR",
            name: "Aksaray",
            code: "TR-68",
        },
        {
            country: "TR",
            name: "Amasya",
            code: "TR-05",
        },
        {
            country: "TR",
            name: "Ankara",
            code: "TR-06",
        },
        {
            country: "TR",
            name: "Antalya",
            code: "TR-07",
        },
        {
            country: "TR",
            name: "Ardahan",
            code: "TR-75",
        },
        {
            country: "TR",
            name: "Artvin",
            code: "TR-08",
        },
        {
            country: "TR",
            name: "Aydin",
            code: "TR-09",
        },
        {
            country: "TR",
            name: "Balikesir",
            code: "TR-10",
        },
        {
            country: "TR",
            name: "Bartin",
            code: "TR-74",
        },
        {
            country: "TR",
            name: "Batman",
            code: "TR-72",
        },
        {
            country: "TR",
            name: "Bayburt",
            code: "TR-69",
        },
        {
            country: "TR",
            name: "Bilecik",
            code: "TR-11",
        },
        {
            country: "TR",
            name: "Bingol",
            code: "TR-12",
        },
        {
            country: "TR",
            name: "Bitlis",
            code: "TR-13",
        },
        {
            country: "TR",
            name: "Bolu",
            code: "TR-14",
        },
        {
            country: "TR",
            name: "Burdur",
            code: "TR-15",
        },
        {
            country: "TR",
            name: "Bursa",
            code: "TR-16",
        },
        {
            country: "TR",
            name: "Canakkale",
            code: "TR-17",
        },
        {
            country: "TR",
            name: "Cankiri",
            code: "TR-18",
        },
        {
            country: "TR",
            name: "Corum",
            code: "TR-19",
        },
        {
            country: "TR",
            name: "Denizli",
            code: "TR-20",
        },
        {
            country: "TR",
            name: "Diyarbakir",
            code: "TR-21",
        },
        {
            country: "TR",
            name: "Duzce",
            code: "TR-81",
        },
        {
            country: "TR",
            name: "Edirne",
            code: "TR-22",
        },
        {
            country: "TR",
            name: "Elazig",
            code: "TR-23",
        },
        {
            country: "TR",
            name: "Erzincan",
            code: "TR-24",
        },
        {
            country: "TR",
            name: "Erzurum",
            code: "TR-25",
        },
        {
            country: "TR",
            name: "Eskisehir",
            code: "TR-26",
        },
        {
            country: "TR",
            name: "Gaziantep",
            code: "TR-27",
        },
        {
            country: "TR",
            name: "Giresun",
            code: "TR-28",
        },
        {
            country: "TR",
            name: "Gumushane",
            code: "TR-29",
        },
        {
            country: "TR",
            name: "Hakkari",
            code: "TR-30",
        },
        {
            country: "TR",
            name: "Hatay",
            code: "TR-31",
        },
        {
            country: "TR",
            name: "Igdir",
            code: "TR-76",
        },
        {
            country: "TR",
            name: "Isparta",
            code: "TR-32",
        },
        {
            country: "TR",
            name: "Istanbul",
            code: "TR-34",
        },
        {
            country: "TR",
            name: "Izmir",
            code: "TR-35",
        },
        {
            country: "TR",
            name: "Kahramanmaras",
            code: "TR-46",
        },
        {
            country: "TR",
            name: "Karabuk",
            code: "TR-78",
        },
        {
            country: "TR",
            name: "Karaman",
            code: "TR-70",
        },
        {
            country: "TR",
            name: "Kars",
            code: "TR-36",
        },
        {
            country: "TR",
            name: "Kastamonu",
            code: "TR-37",
        },
        {
            country: "TR",
            name: "Kayseri",
            code: "TR-38",
        },
        {
            country: "TR",
            name: "Kilis",
            code: "TR-79",
        },
        {
            country: "TR",
            name: "Kirikkale",
            code: "TR-71",
        },
        {
            country: "TR",
            name: "Kirklareli",
            code: "TR-39",
        },
        {
            country: "TR",
            name: "Kirsehir",
            code: "TR-40",
        },
        {
            country: "TR",
            name: "Kocaeli",
            code: "TR-41",
        },
        {
            country: "TR",
            name: "Konya",
            code: "TR-42",
        },
        {
            country: "TR",
            name: "Kutahya",
            code: "TR-43",
        },
        {
            country: "TR",
            name: "Malatya",
            code: "TR-44",
        },
        {
            country: "TR",
            name: "Manisa",
            code: "TR-45",
        },
        {
            country: "TR",
            name: "Mardin",
            code: "TR-47",
        },
        {
            country: "TR",
            name: "Mersin",
            code: "TR-33",
        },
        {
            country: "TR",
            name: "Mugla",
            code: "TR-48",
        },
        {
            country: "TR",
            name: "Mus",
            code: "TR-49",
        },
        {
            country: "TR",
            name: "Nevsehir",
            code: "TR-50",
        },
        {
            country: "TR",
            name: "Nigde",
            code: "TR-51",
        },
        {
            country: "TR",
            name: "Ordu",
            code: "TR-52",
        },
        {
            country: "TR",
            name: "Osmaniye",
            code: "TR-80",
        },
        {
            country: "TR",
            name: "Rize",
            code: "TR-53",
        },
        {
            country: "TR",
            name: "Sakarya",
            code: "TR-54",
        },
        {
            country: "TR",
            name: "Samsun",
            code: "TR-55",
        },
        {
            country: "TR",
            name: "Sanliurfa",
            code: "TR-63",
        },
        {
            country: "TR",
            name: "Siirt",
            code: "TR-56",
        },
        {
            country: "TR",
            name: "Sinop",
            code: "TR-57",
        },
        {
            country: "TR",
            name: "Sirnak",
            code: "TR-73",
        },
        {
            country: "TR",
            name: "Sivas",
            code: "TR-58",
        },
        {
            country: "TR",
            name: "Tekirdag",
            code: "TR-59",
        },
        {
            country: "TR",
            name: "Tokat",
            code: "TR-60",
        },
        {
            country: "TR",
            name: "Trabzon",
            code: "TR-61",
        },
        {
            country: "TR",
            name: "Tunceli",
            code: "TR-62",
        },
        {
            country: "TR",
            name: "Usak",
            code: "TR-64",
        },
        {
            country: "TR",
            name: "Van",
            code: "TR-65",
        },
        {
            country: "TR",
            name: "Yalova",
            code: "TR-77",
        },
        {
            country: "TR",
            name: "Yozgat",
            code: "TR-66",
        },
        {
            country: "TR",
            name: "Zonguldak",
            code: "TR-67",
        },
    ],
    TT: [
        {
            country: "TT",
            name: "Arima",
            code: "TT-ARI",
        },
        {
            country: "TT",
            name: "Chaguanas",
            code: "TT-CHA",
        },
        {
            country: "TT",
            name: "Couva-Tabaquite-Talparo",
            code: "TT-CTT",
        },
        {
            country: "TT",
            name: "Diego Martin",
            code: "TT-DMN",
        },
        {
            country: "TT",
            name: "Mayaro-Rio Claro",
            code: "TT-MRC",
        },
        {
            country: "TT",
            name: "Penal-Debe",
            code: "TT-PED",
        },
        {
            country: "TT",
            name: "Point Fortin",
            code: "TT-PTF",
        },
        {
            country: "TT",
            name: "Port of Spain",
            code: "TT-POS",
        },
        {
            country: "TT",
            name: "Princes Town",
            code: "TT-PRT",
        },
        {
            country: "TT",
            name: "San Fernando",
            code: "TT-SFO",
        },
        {
            country: "TT",
            name: "San Juan-Laventille",
            code: "TT-SJL",
        },
        {
            country: "TT",
            name: "Sangre Grande",
            code: "TT-SGE",
        },
        {
            country: "TT",
            name: "Siparia",
            code: "TT-SIP",
        },
        {
            country: "TT",
            name: "Tobago",
            code: "TT-TOB",
        },
        {
            country: "TT",
            name: "Tunapuna-Piarco",
            code: "TT-TUP",
        },
    ],
    TV: [
        {
            country: "TV",
            name: "Funafuti",
            code: "TV-FUN",
        },
    ],
    TW: [
        {
            country: "TW",
            name: "Changhua",
            code: "TW-CHA",
        },
        {
            country: "TW",
            name: "Chiayi",
            code: "TW-CYQ",
        },
        {
            country: "TW",
            name: "Hsinchu",
            code: "TW-HSQ",
        },
        {
            country: "TW",
            name: "Hualien",
            code: "TW-HUA",
        },
        {
            country: "TW",
            name: "Kaohsiung",
            code: "TW-KHH",
        },
        {
            country: "TW",
            name: "Keelung",
            code: "TW-KEE",
        },
        {
            country: "TW",
            name: "Kinmen",
            code: "TW-KIN",
        },
        {
            country: "TW",
            name: "Lienchiang",
            code: "TW-LIE",
        },
        {
            country: "TW",
            name: "Miaoli",
            code: "TW-MIA",
        },
        {
            country: "TW",
            name: "Nantou",
            code: "TW-NAN",
        },
        {
            country: "TW",
            name: "New Taipei",
            code: "TW-NWT",
        },
        {
            country: "TW",
            name: "Penghu",
            code: "TW-PEN",
        },
        {
            country: "TW",
            name: "Pingtung",
            code: "TW-PIF",
        },
        {
            country: "TW",
            name: "Taichung",
            code: "TW-TXG",
        },
        {
            country: "TW",
            name: "Tainan",
            code: "TW-TNN",
        },
        {
            country: "TW",
            name: "Taipei",
            code: "TW-TPE",
        },
        {
            country: "TW",
            name: "Taitung",
            code: "TW-TTT",
        },
        {
            country: "TW",
            name: "Taoyuan",
            code: "TW-TAO",
        },
        {
            country: "TW",
            name: "Yilan",
            code: "TW-ILA",
        },
        {
            country: "TW",
            name: "Yunlin",
            code: "TW-YUN",
        },
    ],
    TZ: [
        {
            country: "TZ",
            name: "Arusha",
            code: "TZ-01",
        },
        {
            country: "TZ",
            name: "Dar es Salaam",
            code: "TZ-02",
        },
        {
            country: "TZ",
            name: "Dodoma",
            code: "TZ-03",
        },
        {
            country: "TZ",
            name: "Geita",
            code: "TZ-27",
        },
        {
            country: "TZ",
            name: "Iringa",
            code: "TZ-04",
        },
        {
            country: "TZ",
            name: "Kagera",
            code: "TZ-05",
        },
        {
            country: "TZ",
            name: "Kaskazini Pemba",
            code: "TZ-06",
        },
        {
            country: "TZ",
            name: "Kaskazini Unguja",
            code: "TZ-07",
        },
        {
            country: "TZ",
            name: "Katavi",
            code: "TZ-28",
        },
        {
            country: "TZ",
            name: "Kigoma",
            code: "TZ-08",
        },
        {
            country: "TZ",
            name: "Kilimanjaro",
            code: "TZ-09",
        },
        {
            country: "TZ",
            name: "Kusini Pemba",
            code: "TZ-10",
        },
        {
            country: "TZ",
            name: "Kusini Unguja",
            code: "TZ-11",
        },
        {
            country: "TZ",
            name: "Lindi",
            code: "TZ-12",
        },
        {
            country: "TZ",
            name: "Manyara",
            code: "TZ-26",
        },
        {
            country: "TZ",
            name: "Mara",
            code: "TZ-13",
        },
        {
            country: "TZ",
            name: "Mbeya",
            code: "TZ-14",
        },
        {
            country: "TZ",
            name: "Mjini Magharibi",
            code: "TZ-15",
        },
        {
            country: "TZ",
            name: "Morogoro",
            code: "TZ-16",
        },
        {
            country: "TZ",
            name: "Mtwara",
            code: "TZ-17",
        },
        {
            country: "TZ",
            name: "Mwanza",
            code: "TZ-18",
        },
        {
            country: "TZ",
            name: "Njombe",
            code: "TZ-29",
        },
        {
            country: "TZ",
            name: "Pwani",
            code: "TZ-19",
        },
        {
            country: "TZ",
            name: "Rukwa",
            code: "TZ-20",
        },
        {
            country: "TZ",
            name: "Ruvuma",
            code: "TZ-21",
        },
        {
            country: "TZ",
            name: "Shinyanga",
            code: "TZ-22",
        },
        {
            country: "TZ",
            name: "Simiyu",
            code: "TZ-30",
        },
        {
            country: "TZ",
            name: "Singida",
            code: "TZ-23",
        },
        {
            country: "TZ",
            name: "Songwe",
            code: "TZ-31",
        },
        {
            country: "TZ",
            name: "Tabora",
            code: "TZ-24",
        },
        {
            country: "TZ",
            name: "Tanga",
            code: "TZ-25",
        },
    ],
    UA: [
        {
            country: "UA",
            name: "Avtonomna Respublika Krym",
            code: "UA-43",
        },
        {
            country: "UA",
            name: "Cherkaska oblast",
            code: "UA-71",
        },
        {
            country: "UA",
            name: "Chernihivska oblast",
            code: "UA-74",
        },
        {
            country: "UA",
            name: "Chernivetska oblast",
            code: "UA-77",
        },
        {
            country: "UA",
            name: "Dnipropetrovska oblast",
            code: "UA-12",
        },
        {
            country: "UA",
            name: "Donetska oblast",
            code: "UA-14",
        },
        {
            country: "UA",
            name: "Ivano-Frankivska oblast",
            code: "UA-26",
        },
        {
            country: "UA",
            name: "Kharkivska oblast",
            code: "UA-63",
        },
        {
            country: "UA",
            name: "Khersonska oblast",
            code: "UA-65",
        },
        {
            country: "UA",
            name: "Khmelnytska oblast",
            code: "UA-68",
        },
        {
            country: "UA",
            name: "Kirovohradska oblast",
            code: "UA-35",
        },
        {
            country: "UA",
            name: "Kyiv",
            code: "UA-30",
        },
        {
            country: "UA",
            name: "Kyivska oblast",
            code: "UA-32",
        },
        {
            country: "UA",
            name: "Luhanska oblast",
            code: "UA-09",
        },
        {
            country: "UA",
            name: "Lvivska oblast",
            code: "UA-46",
        },
        {
            country: "UA",
            name: "Mykolaivska oblast",
            code: "UA-48",
        },
        {
            country: "UA",
            name: "Odeska oblast",
            code: "UA-51",
        },
        {
            country: "UA",
            name: "Poltavska oblast",
            code: "UA-53",
        },
        {
            country: "UA",
            name: "Rivnenska oblast",
            code: "UA-56",
        },
        {
            country: "UA",
            name: "Sevastopol",
            code: "UA-40",
        },
        {
            country: "UA",
            name: "Sumska oblast",
            code: "UA-59",
        },
        {
            country: "UA",
            name: "Ternopilska oblast",
            code: "UA-61",
        },
        {
            country: "UA",
            name: "Vinnytska oblast",
            code: "UA-05",
        },
        {
            country: "UA",
            name: "Volynska oblast",
            code: "UA-07",
        },
        {
            country: "UA",
            name: "Zakarpatska oblast",
            code: "UA-21",
        },
        {
            country: "UA",
            name: "Zaporizka oblast",
            code: "UA-23",
        },
        {
            country: "UA",
            name: "Zhytomyrska oblast",
            code: "UA-18",
        },
    ],
    UG: [
        {
            country: "UG",
            name: "Abim",
            code: "UG-314",
        },
        {
            country: "UG",
            name: "Adjumani",
            code: "UG-301",
        },
        {
            country: "UG",
            name: "Agago",
            code: "UG-322",
        },
        {
            country: "UG",
            name: "Alebtong",
            code: "UG-323",
        },
        {
            country: "UG",
            name: "Apac",
            code: "UG-302",
        },
        {
            country: "UG",
            name: "Arua",
            code: "UG-303",
        },
        {
            country: "UG",
            name: "Bududa",
            code: "UG-218",
        },
        {
            country: "UG",
            name: "Bugiri",
            code: "UG-201",
        },
        {
            country: "UG",
            name: "Buhweju",
            code: "UG-420",
        },
        {
            country: "UG",
            name: "Buikwe",
            code: "UG-117",
        },
        {
            country: "UG",
            name: "Bukedea",
            code: "UG-219",
        },
        {
            country: "UG",
            name: "Bukomansibi",
            code: "UG-118",
        },
        {
            country: "UG",
            name: "Bulambuli",
            code: "UG-225",
        },
        {
            country: "UG",
            name: "Buliisa",
            code: "UG-416",
        },
        {
            country: "UG",
            name: "Bundibugyo",
            code: "UG-401",
        },
        {
            country: "UG",
            name: "Bushenyi",
            code: "UG-402",
        },
        {
            country: "UG",
            name: "Busia",
            code: "UG-202",
        },
        {
            country: "UG",
            name: "Buvuma",
            code: "UG-120",
        },
        {
            country: "UG",
            name: "Buyende",
            code: "UG-226",
        },
        {
            country: "UG",
            name: "Gomba",
            code: "UG-121",
        },
        {
            country: "UG",
            name: "Gulu",
            code: "UG-304",
        },
        {
            country: "UG",
            name: "Hoima",
            code: "UG-403",
        },
        {
            country: "UG",
            name: "Ibanda",
            code: "UG-417",
        },
        {
            country: "UG",
            name: "Iganga",
            code: "UG-203",
        },
        {
            country: "UG",
            name: "Isingiro",
            code: "UG-418",
        },
        {
            country: "UG",
            name: "Jinja",
            code: "UG-204",
        },
        {
            country: "UG",
            name: "Kaabong",
            code: "UG-318",
        },
        {
            country: "UG",
            name: "Kabale",
            code: "UG-404",
        },
        {
            country: "UG",
            name: "Kabarole",
            code: "UG-405",
        },
        {
            country: "UG",
            name: "Kaberamaido",
            code: "UG-213",
        },
        {
            country: "UG",
            name: "Kalangala",
            code: "UG-101",
        },
        {
            country: "UG",
            name: "Kaliro",
            code: "UG-222",
        },
        {
            country: "UG",
            name: "Kalungu",
            code: "UG-122",
        },
        {
            country: "UG",
            name: "Kampala",
            code: "UG-102",
        },
        {
            country: "UG",
            name: "Kamuli",
            code: "UG-205",
        },
        {
            country: "UG",
            name: "Kamwenge",
            code: "UG-413",
        },
        {
            country: "UG",
            name: "Kanungu",
            code: "UG-414",
        },
        {
            country: "UG",
            name: "Kapchorwa",
            code: "UG-206",
        },
        {
            country: "UG",
            name: "Kasese",
            code: "UG-406",
        },
        {
            country: "UG",
            name: "Katakwi",
            code: "UG-207",
        },
        {
            country: "UG",
            name: "Kayunga",
            code: "UG-112",
        },
        {
            country: "UG",
            name: "Kibaale",
            code: "UG-407",
        },
        {
            country: "UG",
            name: "Kiboga",
            code: "UG-103",
        },
        {
            country: "UG",
            name: "Kibuku",
            code: "UG-227",
        },
        {
            country: "UG",
            name: "Kiruhura",
            code: "UG-419",
        },
        {
            country: "UG",
            name: "Kiryandongo",
            code: "UG-421",
        },
        {
            country: "UG",
            name: "Kisoro",
            code: "UG-408",
        },
        {
            country: "UG",
            name: "Kitgum",
            code: "UG-305",
        },
        {
            country: "UG",
            name: "Koboko",
            code: "UG-319",
        },
        {
            country: "UG",
            name: "Kole",
            code: "UG-325",
        },
        {
            country: "UG",
            name: "Kumi",
            code: "UG-208",
        },
        {
            country: "UG",
            name: "Kween",
            code: "UG-228",
        },
        {
            country: "UG",
            name: "Kyankwanzi",
            code: "UG-123",
        },
        {
            country: "UG",
            name: "Kyegegwa",
            code: "UG-422",
        },
        {
            country: "UG",
            name: "Kyenjojo",
            code: "UG-415",
        },
        {
            country: "UG",
            name: "Lamwo",
            code: "UG-326",
        },
        {
            country: "UG",
            name: "Lira",
            code: "UG-307",
        },
        {
            country: "UG",
            name: "Luuka",
            code: "UG-229",
        },
        {
            country: "UG",
            name: "Luwero",
            code: "UG-104",
        },
        {
            country: "UG",
            name: "Lwengo",
            code: "UG-124",
        },
        {
            country: "UG",
            name: "Lyantonde",
            code: "UG-114",
        },
        {
            country: "UG",
            name: "Manafwa",
            code: "UG-223",
        },
        {
            country: "UG",
            name: "Maracha",
            code: "UG-320",
        },
        {
            country: "UG",
            name: "Masaka",
            code: "UG-105",
        },
        {
            country: "UG",
            name: "Masindi",
            code: "UG-409",
        },
        {
            country: "UG",
            name: "Mayuge",
            code: "UG-214",
        },
        {
            country: "UG",
            name: "Mbale",
            code: "UG-209",
        },
        {
            country: "UG",
            name: "Mbarara",
            code: "UG-410",
        },
        {
            country: "UG",
            name: "Mitooma",
            code: "UG-423",
        },
        {
            country: "UG",
            name: "Mityana",
            code: "UG-115",
        },
        {
            country: "UG",
            name: "Moroto",
            code: "UG-308",
        },
        {
            country: "UG",
            name: "Moyo",
            code: "UG-309",
        },
        {
            country: "UG",
            name: "Mpigi",
            code: "UG-106",
        },
        {
            country: "UG",
            name: "Mubende",
            code: "UG-107",
        },
        {
            country: "UG",
            name: "Mukono",
            code: "UG-108",
        },
        {
            country: "UG",
            name: "Nakapiripirit",
            code: "UG-311",
        },
        {
            country: "UG",
            name: "Nakaseke",
            code: "UG-116",
        },
        {
            country: "UG",
            name: "Nakasongola",
            code: "UG-109",
        },
        {
            country: "UG",
            name: "Namayingo",
            code: "UG-230",
        },
        {
            country: "UG",
            name: "Napak",
            code: "UG-327",
        },
        {
            country: "UG",
            name: "Nebbi",
            code: "UG-310",
        },
        {
            country: "UG",
            name: "Ntoroko",
            code: "UG-424",
        },
        {
            country: "UG",
            name: "Ntungamo",
            code: "UG-411",
        },
        {
            country: "UG",
            name: "Nwoya",
            code: "UG-328",
        },
        {
            country: "UG",
            name: "Oyam",
            code: "UG-321",
        },
        {
            country: "UG",
            name: "Pader",
            code: "UG-312",
        },
        {
            country: "UG",
            name: "Rakai",
            code: "UG-110",
        },
        {
            country: "UG",
            name: "Rubirizi",
            code: "UG-425",
        },
        {
            country: "UG",
            name: "Rukungiri",
            code: "UG-412",
        },
        {
            country: "UG",
            name: "Sembabule",
            code: "UG-111",
        },
        {
            country: "UG",
            name: "Sheema",
            code: "UG-426",
        },
        {
            country: "UG",
            name: "Sironko",
            code: "UG-215",
        },
        {
            country: "UG",
            name: "Soroti",
            code: "UG-211",
        },
        {
            country: "UG",
            name: "Tororo",
            code: "UG-212",
        },
        {
            country: "UG",
            name: "Wakiso",
            code: "UG-113",
        },
        {
            country: "UG",
            name: "Yumbe",
            code: "UG-313",
        },
        {
            country: "UG",
            name: "Zombo",
            code: "UG-330",
        },
    ],
    UM: [
        {
            country: "UM",
            name: "Palmyra Atoll",
            code: "UM-95",
        },
    ],
    US: [
        {
            country: "US",
            name: "Alabama",
            code: "US-AL",
        },
        {
            country: "US",
            name: "Alaska",
            code: "US-AK",
        },
        {
            country: "US",
            name: "Arizona",
            code: "US-AZ",
        },
        {
            country: "US",
            name: "Arkansas",
            code: "US-AR",
        },
        {
            country: "US",
            name: "California",
            code: "US-CA",
        },
        {
            country: "US",
            name: "Colorado",
            code: "US-CO",
        },
        {
            country: "US",
            name: "Connecticut",
            code: "US-CT",
        },
        {
            country: "US",
            name: "Delaware",
            code: "US-DE",
        },
        {
            country: "US",
            name: "District of Columbia",
            code: "US-DC",
        },
        {
            country: "US",
            name: "Florida",
            code: "US-FL",
        },
        {
            country: "US",
            name: "Georgia",
            code: "US-GA",
        },
        {
            country: "US",
            name: "Hawaii",
            code: "US-HI",
        },
        {
            country: "US",
            name: "Idaho",
            code: "US-ID",
        },
        {
            country: "US",
            name: "Illinois",
            code: "US-IL",
        },
        {
            country: "US",
            name: "Indiana",
            code: "US-IN",
        },
        {
            country: "US",
            name: "Iowa",
            code: "US-IA",
        },
        {
            country: "US",
            name: "Kansas",
            code: "US-KS",
        },
        {
            country: "US",
            name: "Kentucky",
            code: "US-KY",
        },
        {
            country: "US",
            name: "Louisiana",
            code: "US-LA",
        },
        {
            country: "US",
            name: "Maine",
            code: "US-ME",
        },
        {
            country: "US",
            name: "Maryland",
            code: "US-MD",
        },
        {
            country: "US",
            name: "Massachusetts",
            code: "US-MA",
        },
        {
            country: "US",
            name: "Michigan",
            code: "US-MI",
        },
        {
            country: "US",
            name: "Minnesota",
            code: "US-MN",
        },
        {
            country: "US",
            name: "Mississippi",
            code: "US-MS",
        },
        {
            country: "US",
            name: "Missouri",
            code: "US-MO",
        },
        {
            country: "US",
            name: "Montana",
            code: "US-MT",
        },
        {
            country: "US",
            name: "Nebraska",
            code: "US-NE",
        },
        {
            country: "US",
            name: "Nevada",
            code: "US-NV",
        },
        {
            country: "US",
            name: "New Hampshire",
            code: "US-NH",
        },
        {
            country: "US",
            name: "New Jersey",
            code: "US-NJ",
        },
        {
            country: "US",
            name: "New Mexico",
            code: "US-NM",
        },
        {
            country: "US",
            name: "New York",
            code: "US-NY",
        },
        {
            country: "US",
            name: "North Carolina",
            code: "US-NC",
        },
        {
            country: "US",
            name: "North Dakota",
            code: "US-ND",
        },
        {
            country: "US",
            name: "Ohio",
            code: "US-OH",
        },
        {
            country: "US",
            name: "Oklahoma",
            code: "US-OK",
        },
        {
            country: "US",
            name: "Oregon",
            code: "US-OR",
        },
        {
            country: "US",
            name: "Pennsylvania",
            code: "US-PA",
        },
        {
            country: "US",
            name: "Rhode Island",
            code: "US-RI",
        },
        {
            country: "US",
            name: "South Carolina",
            code: "US-SC",
        },
        {
            country: "US",
            name: "South Dakota",
            code: "US-SD",
        },
        {
            country: "US",
            name: "Tennessee",
            code: "US-TN",
        },
        {
            country: "US",
            name: "Texas",
            code: "US-TX",
        },
        {
            country: "US",
            name: "Utah",
            code: "US-UT",
        },
        {
            country: "US",
            name: "Vermont",
            code: "US-VT",
        },
        {
            country: "US",
            name: "Virginia",
            code: "US-VA",
        },
        {
            country: "US",
            name: "Washington",
            code: "US-WA",
        },
        {
            country: "US",
            name: "West Virginia",
            code: "US-WV",
        },
        {
            country: "US",
            name: "Wisconsin",
            code: "US-WI",
        },
        {
            country: "US",
            name: "Wyoming",
            code: "US-WY",
        },
    ],
    UY: [
        {
            country: "UY",
            name: "Artigas",
            code: "UY-AR",
        },
        {
            country: "UY",
            name: "Canelones",
            code: "UY-CA",
        },
        {
            country: "UY",
            name: "Cerro Largo",
            code: "UY-CL",
        },
        {
            country: "UY",
            name: "Colonia",
            code: "UY-CO",
        },
        {
            country: "UY",
            name: "Durazno",
            code: "UY-DU",
        },
        {
            country: "UY",
            name: "Flores",
            code: "UY-FS",
        },
        {
            country: "UY",
            name: "Florida",
            code: "UY-FD",
        },
        {
            country: "UY",
            name: "Lavalleja",
            code: "UY-LA",
        },
        {
            country: "UY",
            name: "Maldonado",
            code: "UY-MA",
        },
        {
            country: "UY",
            name: "Montevideo",
            code: "UY-MO",
        },
        {
            country: "UY",
            name: "Paysandu",
            code: "UY-PA",
        },
        {
            country: "UY",
            name: "Rio Negro",
            code: "UY-RN",
        },
        {
            country: "UY",
            name: "Rivera",
            code: "UY-RV",
        },
        {
            country: "UY",
            name: "Rocha",
            code: "UY-RO",
        },
        {
            country: "UY",
            name: "Salto",
            code: "UY-SA",
        },
        {
            country: "UY",
            name: "San Jose",
            code: "UY-SJ",
        },
        {
            country: "UY",
            name: "Soriano",
            code: "UY-SO",
        },
        {
            country: "UY",
            name: "Tacuarembo",
            code: "UY-TA",
        },
        {
            country: "UY",
            name: "Treinta y Tres",
            code: "UY-TT",
        },
    ],
    UZ: [
        {
            country: "UZ",
            name: "Andijon",
            code: "UZ-AN",
        },
        {
            country: "UZ",
            name: "Buxoro",
            code: "UZ-BU",
        },
        {
            country: "UZ",
            name: "Farg'ona",
            code: "UZ-FA",
        },
        {
            country: "UZ",
            name: "Jizzax",
            code: "UZ-JI",
        },
        {
            country: "UZ",
            name: "Namangan",
            code: "UZ-NG",
        },
        {
            country: "UZ",
            name: "Navoiy",
            code: "UZ-NW",
        },
        {
            country: "UZ",
            name: "Qashqadaryo",
            code: "UZ-QA",
        },
        {
            country: "UZ",
            name: "Qoraqalpog'iston Respublikasi",
            code: "UZ-QR",
        },
        {
            country: "UZ",
            name: "Samarqand",
            code: "UZ-SA",
        },
        {
            country: "UZ",
            name: "Sirdaryo",
            code: "UZ-SI",
        },
        {
            country: "UZ",
            name: "Surxondaryo",
            code: "UZ-SU",
        },
        {
            country: "UZ",
            name: "Toshkent",
            code: "UZ-TK",
        },
        {
            country: "UZ",
            name: "Xorazm",
            code: "UZ-XO",
        },
    ],
    VA: [
        {
            country: "VA",
            name: "Vatican City",
            code: "-",
        },
    ],
    VC: [
        {
            country: "VC",
            name: "Charlotte",
            code: "VC-01",
        },
        {
            country: "VC",
            name: "Grenadines",
            code: "VC-06",
        },
        {
            country: "VC",
            name: "Saint George",
            code: "VC-04",
        },
        {
            country: "VC",
            name: "Saint Patrick",
            code: "VC-05",
        },
    ],
    VE: [
        {
            country: "VE",
            name: "Amazonas",
            code: "VE-Z",
        },
        {
            country: "VE",
            name: "Anzoategui",
            code: "VE-B",
        },
        {
            country: "VE",
            name: "Apure",
            code: "VE-C",
        },
        {
            country: "VE",
            name: "Aragua",
            code: "VE-D",
        },
        {
            country: "VE",
            name: "Barinas",
            code: "VE-E",
        },
        {
            country: "VE",
            name: "Bolivar",
            code: "VE-F",
        },
        {
            country: "VE",
            name: "Carabobo",
            code: "VE-G",
        },
        {
            country: "VE",
            name: "Cojedes",
            code: "VE-H",
        },
        {
            country: "VE",
            name: "Delta Amacuro",
            code: "VE-Y",
        },
        {
            country: "VE",
            name: "Dependencias Federales",
            code: "VE-W",
        },
        {
            country: "VE",
            name: "Distrito Capital",
            code: "VE-A",
        },
        {
            country: "VE",
            name: "Falcon",
            code: "VE-I",
        },
        {
            country: "VE",
            name: "Guarico",
            code: "VE-J",
        },
        {
            country: "VE",
            name: "La Guaira",
            code: "VE-X",
        },
        {
            country: "VE",
            name: "Lara",
            code: "VE-K",
        },
        {
            country: "VE",
            name: "Merida",
            code: "VE-L",
        },
        {
            country: "VE",
            name: "Miranda",
            code: "VE-M",
        },
        {
            country: "VE",
            name: "Monagas",
            code: "VE-N",
        },
        {
            country: "VE",
            name: "Nueva Esparta",
            code: "VE-O",
        },
        {
            country: "VE",
            name: "Portuguesa",
            code: "VE-P",
        },
        {
            country: "VE",
            name: "Sucre",
            code: "VE-R",
        },
        {
            country: "VE",
            name: "Tachira",
            code: "VE-S",
        },
        {
            country: "VE",
            name: "Trujillo",
            code: "VE-T",
        },
        {
            country: "VE",
            name: "Yaracuy",
            code: "VE-U",
        },
        {
            country: "VE",
            name: "Zulia",
            code: "VE-V",
        },
    ],
    VG: [
        {
            country: "VG",
            name: "Virgin Islands, British",
            code: "-",
        },
    ],
    VI: [
        {
            country: "VI",
            name: "Virgin Islands, U.S.",
            code: "-",
        },
    ],
    VN: [
        {
            country: "VN",
            name: "An Giang",
            code: "VN-44",
        },
        {
            country: "VN",
            name: "Ba Ria - Vung Tau",
            code: "VN-43",
        },
        {
            country: "VN",
            name: "Bac Giang",
            code: "VN-54",
        },
        {
            country: "VN",
            name: "Bac Kan",
            code: "VN-53",
        },
        {
            country: "VN",
            name: "Bac Lieu",
            code: "VN-55",
        },
        {
            country: "VN",
            name: "Bac Ninh",
            code: "VN-56",
        },
        {
            country: "VN",
            name: "Ben Tre",
            code: "VN-50",
        },
        {
            country: "VN",
            name: "Binh Dinh",
            code: "VN-31",
        },
        {
            country: "VN",
            name: "Binh Duong",
            code: "VN-57",
        },
        {
            country: "VN",
            name: "Binh Phuoc",
            code: "VN-58",
        },
        {
            country: "VN",
            name: "Binh Thuan",
            code: "VN-40",
        },
        {
            country: "VN",
            name: "Ca Mau",
            code: "VN-59",
        },
        {
            country: "VN",
            name: "Can Tho",
            code: "VN-CT",
        },
        {
            country: "VN",
            name: "Cao Bang",
            code: "VN-04",
        },
        {
            country: "VN",
            name: "Da Nang",
            code: "VN-DN",
        },
        {
            country: "VN",
            name: "Dak Lak",
            code: "VN-33",
        },
        {
            country: "VN",
            name: "Dak Nong",
            code: "VN-72",
        },
        {
            country: "VN",
            name: "Dien Bien",
            code: "VN-71",
        },
        {
            country: "VN",
            name: "Dong Nai",
            code: "VN-39",
        },
        {
            country: "VN",
            name: "Dong Thap",
            code: "VN-45",
        },
        {
            country: "VN",
            name: "Gia Lai",
            code: "VN-30",
        },
        {
            country: "VN",
            name: "Ha Giang",
            code: "VN-03",
        },
        {
            country: "VN",
            name: "Ha Nam",
            code: "VN-63",
        },
        {
            country: "VN",
            name: "Ha Noi",
            code: "VN-HN",
        },
        {
            country: "VN",
            name: "Ha Tinh",
            code: "VN-23",
        },
        {
            country: "VN",
            name: "Hai Duong",
            code: "VN-61",
        },
        {
            country: "VN",
            name: "Hai Phong",
            code: "VN-HP",
        },
        {
            country: "VN",
            name: "Hau Giang",
            code: "VN-73",
        },
        {
            country: "VN",
            name: "Ho Chi Minh",
            code: "VN-SG",
        },
        {
            country: "VN",
            name: "Hoa Binh",
            code: "VN-14",
        },
        {
            country: "VN",
            name: "Hung Yen",
            code: "VN-66",
        },
        {
            country: "VN",
            name: "Khanh Hoa",
            code: "VN-34",
        },
        {
            country: "VN",
            name: "Kien Giang",
            code: "VN-47",
        },
        {
            country: "VN",
            name: "Kon Tum",
            code: "VN-28",
        },
        {
            country: "VN",
            name: "Lai Chau",
            code: "VN-01",
        },
        {
            country: "VN",
            name: "Lam Dong",
            code: "VN-35",
        },
        {
            country: "VN",
            name: "Lang Son",
            code: "VN-09",
        },
        {
            country: "VN",
            name: "Lao Cai",
            code: "VN-02",
        },
        {
            country: "VN",
            name: "Long An",
            code: "VN-41",
        },
        {
            country: "VN",
            name: "Nam Dinh",
            code: "VN-67",
        },
        {
            country: "VN",
            name: "Nghe An",
            code: "VN-22",
        },
        {
            country: "VN",
            name: "Ninh Binh",
            code: "VN-18",
        },
        {
            country: "VN",
            name: "Ninh Thuan",
            code: "VN-36",
        },
        {
            country: "VN",
            name: "Phu Tho",
            code: "VN-68",
        },
        {
            country: "VN",
            name: "Phu Yen",
            code: "VN-32",
        },
        {
            country: "VN",
            name: "Quang Binh",
            code: "VN-24",
        },
        {
            country: "VN",
            name: "Quang Nam",
            code: "VN-27",
        },
        {
            country: "VN",
            name: "Quang Ngai",
            code: "VN-29",
        },
        {
            country: "VN",
            name: "Quang Ninh",
            code: "VN-13",
        },
        {
            country: "VN",
            name: "Quang Tri",
            code: "VN-25",
        },
        {
            country: "VN",
            name: "Soc Trang",
            code: "VN-52",
        },
        {
            country: "VN",
            name: "Son La",
            code: "VN-05",
        },
        {
            country: "VN",
            name: "Tay Ninh",
            code: "VN-37",
        },
        {
            country: "VN",
            name: "Thai Binh",
            code: "VN-20",
        },
        {
            country: "VN",
            name: "Thai Nguyen",
            code: "VN-69",
        },
        {
            country: "VN",
            name: "Thanh Hoa",
            code: "VN-21",
        },
        {
            country: "VN",
            name: "Thua Thien-Hue",
            code: "VN-26",
        },
        {
            country: "VN",
            name: "Tien Giang",
            code: "VN-46",
        },
        {
            country: "VN",
            name: "Tra Vinh",
            code: "VN-51",
        },
        {
            country: "VN",
            name: "Tuyen Quang",
            code: "VN-07",
        },
        {
            country: "VN",
            name: "Vinh Long",
            code: "VN-49",
        },
        {
            country: "VN",
            name: "Vinh Phuc",
            code: "VN-70",
        },
        {
            country: "VN",
            name: "Yen Bai",
            code: "VN-06",
        },
    ],
    VU: [
        {
            country: "VU",
            name: "Sanma",
            code: "VU-SAM",
        },
        {
            country: "VU",
            name: "Shefa",
            code: "VU-SEE",
        },
        {
            country: "VU",
            name: "Tafea",
            code: "VU-TAE",
        },
    ],
    WF: [
        {
            country: "WF",
            name: "Sigave",
            code: "WF-SG",
        },
        {
            country: "WF",
            name: "Uvea",
            code: "WF-UV",
        },
    ],
    WS: [
        {
            country: "WS",
            name: "Atua",
            code: "WS-AT",
        },
        {
            country: "WS",
            name: "Fa'asaleleaga",
            code: "WS-FA",
        },
        {
            country: "WS",
            name: "Tuamasaga",
            code: "WS-TU",
        },
    ],
    YE: [
        {
            country: "YE",
            name: "'Adan",
            code: "YE-AD",
        },
        {
            country: "YE",
            name: "'Amran",
            code: "YE-AM",
        },
        {
            country: "YE",
            name: "Ad Dali'",
            code: "YE-DA",
        },
        {
            country: "YE",
            name: "Al Bayda'",
            code: "YE-BA",
        },
        {
            country: "YE",
            name: "Al Hudaydah",
            code: "YE-HU",
        },
        {
            country: "YE",
            name: "Al Jawf",
            code: "YE-JA",
        },
        {
            country: "YE",
            name: "Al Mahrah",
            code: "YE-MR",
        },
        {
            country: "YE",
            name: "Al Mahwit",
            code: "YE-MW",
        },
        {
            country: "YE",
            name: "Amanat al 'Asimah",
            code: "YE-SA",
        },
        {
            country: "YE",
            name: "Dhamar",
            code: "YE-DH",
        },
        {
            country: "YE",
            name: "Hadramawt",
            code: "YE-HD",
        },
        {
            country: "YE",
            name: "Ibb",
            code: "YE-IB",
        },
        {
            country: "YE",
            name: "Lahij",
            code: "YE-LA",
        },
        {
            country: "YE",
            name: "Ma'rib",
            code: "YE-MA",
        },
        {
            country: "YE",
            name: "Raymah",
            code: "YE-RA",
        },
        {
            country: "YE",
            name: "Sa'dah",
            code: "YE-SD",
        },
        {
            country: "YE",
            name: "San'a'",
            code: "YE-SN",
        },
        {
            country: "YE",
            name: "Shabwah",
            code: "YE-SH",
        },
        {
            country: "YE",
            name: "Ta'izz",
            code: "YE-TA",
        },
    ],
    YT: [
        {
            country: "YT",
            name: "Bandraboua",
            code: "-",
        },
        {
            country: "YT",
            name: "Bandrele",
            code: "-",
        },
        {
            country: "YT",
            name: "Kani-Keli",
            code: "-",
        },
        {
            country: "YT",
            name: "Mamoudzou",
            code: "-",
        },
        {
            country: "YT",
            name: "Pamandzi",
            code: "-",
        },
        {
            country: "YT",
            name: "Tsingoni",
            code: "-",
        },
    ],
    ZA: [
        {
            country: "ZA",
            name: "Eastern Cape",
            code: "ZA-EC",
        },
        {
            country: "ZA",
            name: "Free State",
            code: "ZA-FS",
        },
        {
            country: "ZA",
            name: "Gauteng",
            code: "ZA-GP",
        },
        {
            country: "ZA",
            name: "Kwazulu-Natal",
            code: "ZA-KZN",
        },
        {
            country: "ZA",
            name: "Limpopo",
            code: "ZA-LP",
        },
        {
            country: "ZA",
            name: "Mpumalanga",
            code: "ZA-MP",
        },
        {
            country: "ZA",
            name: "North-West",
            code: "ZA-NW",
        },
        {
            country: "ZA",
            name: "Northern Cape",
            code: "ZA-NC",
        },
        {
            country: "ZA",
            name: "Western Cape",
            code: "ZA-WC",
        },
    ],
    ZM: [
        {
            country: "ZM",
            name: "Central",
            code: "ZM-02",
        },
        {
            country: "ZM",
            name: "Copperbelt",
            code: "ZM-08",
        },
        {
            country: "ZM",
            name: "Eastern",
            code: "ZM-03",
        },
        {
            country: "ZM",
            name: "Luapula",
            code: "ZM-04",
        },
        {
            country: "ZM",
            name: "Lusaka",
            code: "ZM-09",
        },
        {
            country: "ZM",
            name: "Muchinga",
            code: "ZM-10",
        },
        {
            country: "ZM",
            name: "North-Western",
            code: "ZM-06",
        },
        {
            country: "ZM",
            name: "Northern",
            code: "ZM-05",
        },
        {
            country: "ZM",
            name: "Southern",
            code: "ZM-07",
        },
        {
            country: "ZM",
            name: "Western",
            code: "ZM-01",
        },
    ],
    ZW: [
        {
            country: "ZW",
            name: "Bulawayo",
            code: "ZW-BU",
        },
        {
            country: "ZW",
            name: "Harare",
            code: "ZW-HA",
        },
        {
            country: "ZW",
            name: "Manicaland",
            code: "ZW-MA",
        },
        {
            country: "ZW",
            name: "Mashonaland Central",
            code: "ZW-MC",
        },
        {
            country: "ZW",
            name: "Mashonaland East",
            code: "ZW-ME",
        },
        {
            country: "ZW",
            name: "Mashonaland West",
            code: "ZW-MW",
        },
        {
            country: "ZW",
            name: "Masvingo",
            code: "ZW-MV",
        },
        {
            country: "ZW",
            name: "Matabeleland North",
            code: "ZW-MN",
        },
        {
            country: "ZW",
            name: "Matabeleland South",
            code: "ZW-MS",
        },
        {
            country: "ZW",
            name: "Midlands",
            code: "ZW-MI",
        },
    ],
};
